const badIngredientsConfig = [
  {
    "chemical": "1-4-Dioxane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>1-4-Dioxane is a contaminant / impurity associated with ethoxylated ingredients. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because 1,4-dioxane-based ingredients are restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, 1-4-Dioxane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing 1-4-Dioxane: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "1 4 dioxane",
      "dioxane"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "2-4-Diaminoanisole",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>2-4-Diaminoanisole is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, 2-4-Diaminoanisole performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for 2-4-Diaminoanisole: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "2 4 diaminoanisole",
      "2 4 diaminoanisole sulfate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "2-4-Diaminotoluene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>2-4-Diaminotoluene is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, 2-4-Diaminotoluene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret 2-4-Diaminotoluene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "2-Methoxyethanol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>2-Methoxyethanol is a glycol ether solvent with elevated toxicity concerns. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines restrict 2-methoxyethanol / methyl cellosolve. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, 2-Methoxyethanol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for 2-Methoxyethanol: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "ethylene glycol monomethyl ether",
      "methyl cellosolve"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "2-Nitro-p-Phenylenediamine",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>2-Nitro-p-Phenylenediamine is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, 2-Nitro-p-Phenylenediamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for 2-Nitro-p-Phenylenediamine: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "4-Amino-2-Nitrophenol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>4-Amino-2-Nitrophenol is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, 4-Amino-2-Nitrophenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for 4-Amino-2-Nitrophenol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "4-Aminobiphenyl",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>4-Aminobiphenyl is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, 4-Aminobiphenyl performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret 4-Aminobiphenyl in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "4-Methylbenzylidene Camphor (Enzacamene)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>4-Methylbenzylidene Camphor (Enzacamene) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, 4-Methylbenzylidene Camphor (Enzacamene) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If 4-Methylbenzylidene Camphor (Enzacamene) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "5-Bromo-5-Nitro-1-3-Dioxane",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>5-Bromo-5-Nitro-1-3-Dioxane is a formaldehyde-releasing preservative. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because it is listed on the Osmosis restricted ingredient listing as 5-Bromo-5-Nitro-1,3 Dioxane. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, 5-Bromo-5-Nitro-1-3-Dioxane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing 5-Bromo-5-Nitro-1-3-Dioxane: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "5 bromo 5 nitro 1 3 dioxane",
      "bronidox",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Acetone",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Acetone is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Within cosmetic formulas, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Acetone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>If Acetone appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Water (Aqua)",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Acetone Oxime",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Acetone Oxime is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Acetone Oxime performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Acetone Oxime: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Acetyl Heptapeptide-9 Colloidal Gold",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Acetyl Heptapeptide-9 Colloidal Gold is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Acetyl Heptapeptide-9 Colloidal Gold performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Acetyl Heptapeptide-9 Colloidal Gold: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acetyl heptapeptide 9"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Acetyl Tetrapeptide-17 Colloidal Platinum",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Acetyl Tetrapeptide-17 Colloidal Platinum is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Acetyl Tetrapeptide-17 Colloidal Platinum performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Acetyl Tetrapeptide-17 Colloidal Platinum in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Acetylated Lanolin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Acetylated Lanolin is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Acetylated Lanolin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>How to interpret Acetylated Lanolin in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "acetylatedlanolin",
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Acrylamide",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "severe",
    "description": "<p>Acrylamide is a reactive monomer associated with polymer systems and impurity concerns. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because acrylamide is explicitly restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Acrylamide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Checker guidance for Acrylamide: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Acrylates Copolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Acrylates Copolymer is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Acrylates Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Acrylates Copolymer: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Adapalene",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Adapalene is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Across many personal-care products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Adapalene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Decision tip for Adapalene: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Albumen",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Albumen is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Albumen performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Albumen: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Allantoin Uric Acid Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Allantoin Uric Acid Derived is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Allantoin Uric Acid Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Allantoin Uric Acid Derived appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Aloe Vera Whole Leaf Extract Non-Decolorized",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Aloe Vera Whole Leaf Extract Non-Decolorized is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Aloe Vera Whole Leaf Extract Non-Decolorized performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Aloe Vera Whole Leaf Extract Non-Decolorized appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Alpha-Arbutin",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "medium",
    "description": "<p>Alpha-Arbutin is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In modern beauty formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Alpha-Arbutin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>When reviewing Alpha-Arbutin, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "alpha arbutin",
      "alphaarbutin",
      "α arbutin"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Ascorbyl Phosphate",
      "Undecylenoyl Phenylalanine",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Alpha-Isomethyl Ionone",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Alpha-Isomethyl Ionone is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Alpha-Isomethyl Ionone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Alpha-Isomethyl Ionone: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "alpha isomethyl ionone",
      "alphaisomethylionone",
      "α isomethyl ionone",
      "isomethylionone"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Alpha-Pinene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Alpha-Pinene is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Alpha-Pinene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Alpha-Pinene appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "alpha pinene",
      "alphapinene",
      "α pinene"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Alpha-Terpinene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Alpha-Terpinene is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Alpha-Terpinene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Alpha-Terpinene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "alpha terpinene",
      "alphaterpinene",
      "α terpinene"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Aluminium Lakes",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Aluminium Lakes is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Aluminium Lakes performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing Aluminium Lakes: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "aluminium lake",
      "aluminium lakes generic",
      "aluminum lake",
      "aluminum lakes",
      "aluminum",
      "aluminium",
      "aluminum based",
      "aluminium based"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Aluminum Chlorohydrate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Aluminum Chlorohydrate is an aluminum-based salt used in antiperspirant and some cosmetic systems. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines restrict aluminum-based ingredients. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Aluminum Chlorohydrate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>If Aluminum Chlorohydrate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "aluminium",
      "aluminium chlorohydrate",
      "aluminum",
      "aluminum starch octenylsuccinate",
      "aluminum based",
      "aluminium based"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Ambergris",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Ambergris is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Ambergris performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Ambergris: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Ammonium Hydroxide",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Ammonium Hydroxide is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Ammonium Hydroxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret Ammonium Hydroxide in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Ammonium Laureth Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Ammonium Laureth Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Across many personal-care products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Ammonium Laureth Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Decision tip for Ammonium Laureth Sulfate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "ammoniumlaurethsulfate",
      "ales",
      "sulfates",
      "sulfate",
      "sulphates",
      "sulphate",
      "sulfate surfactants",
      "sulphate surfactants",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Ammonium Lauryl Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Ammonium Lauryl Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In modern beauty formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Ammonium Lauryl Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>When reviewing Ammonium Lauryl Sulfate, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "ammoniumlaurylsulfate",
      "als",
      "sulfates",
      "sulfate",
      "sulphates",
      "sulphate",
      "sulfate surfactants",
      "sulphate surfactants",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Lauryl Glucoside, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Ammonium Perfluorooctanoate (PFOA)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ammonium Perfluorooctanoate (PFOA) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Ammonium Perfluorooctanoate (PFOA) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Ammonium Perfluorooctanoate (PFOA) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "ammonium perfluorooctanoate",
      "pfoa",
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ammonium Thioglycolate",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Ammonium Thioglycolate is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Ammonium Thioglycolate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>If Ammonium Thioglycolate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Amniotic Fluid",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Amniotic Fluid is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Amniotic Fluid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Amniotic Fluid: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Amyl Cinnamal",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Amyl Cinnamal is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Amyl Cinnamal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Amyl Cinnamal: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "amylcinnamal",
      "amyl cinnamic aldehyde",
      "amylcinnamicaldehyde"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Amyl Salicylate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Amyl Salicylate is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Amyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Amyl Salicylate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "amylsalicylate",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Amylcinnamyl Alcohol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Amylcinnamyl Alcohol is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Amylcinnamyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Amylcinnamyl Alcohol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "amylcinnamylalcohol",
      "amyl cinnamyl alcohol"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Anisyl Alcohol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Anisyl Alcohol is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Anisyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Anisyl Alcohol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "anise alcohol",
      "anisealcohol",
      "anisylalcohol"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Arbutin",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "medium",
    "description": "<p>Arbutin is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In modern beauty formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Arbutin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>When reviewing Arbutin, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Ascorbyl Phosphate",
      "Undecylenoyl Phenylalanine",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Arsenic",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Arsenic is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Arsenic performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Arsenic: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Arsenic Compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Arsenic Compounds is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Arsenic Compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Arsenic Compounds: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Atranol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "severe",
    "description": "<p>Atranol is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Atranol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Atranol: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Avena Sativa (Oat) Kernel Flour",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Avena Sativa (Oat) Kernel Flour is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Avena Sativa (Oat) Kernel Flour performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Avena Sativa (Oat) Kernel Flour: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Avobenzone",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Avobenzone is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. Within cosmetic formulas, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Avobenzone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>If Avobenzone appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "butyl methoxydibenzoylmethane",
      "butylmethoxydibenzoylmethane",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Azelaic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "low",
    "description": "<p>Azelaic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. When used in topical products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as low concern, but context still matters for sensitive users.</p><p>In practical routine planning, Azelaic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>How to interpret Azelaic Acid in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Sodium Ascorbyl Phosphate, or Zinc Gluconate.</p>",
    "aliases": [
      "azelaicacid"
    ],
    "alternatives": [
      "Niacinamide",
      "Zinc Gluconate",
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Balsam of Peru",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Balsam of Peru is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Balsam of Peru performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Balsam of Peru: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "balsamofperu",
      "myroxylon pereirae resin",
      "myroxylonpereiraeresin",
      "peru balsam",
      "perubalsam"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Bee Venom",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Bee Venom is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Bee Venom performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Bee Venom: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Benzaldehyde",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Benzaldehyde is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Benzaldehyde performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Benzaldehyde, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Benzalkonium Chloride",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Benzalkonium Chloride is a preservative used to protect formulas from microbial contamination during storage and use. In skincare formulations, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Benzalkonium Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Checker guidance for Benzalkonium Chloride: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "benzalkoniumchloride",
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Benzene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Benzene is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Benzene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Benzene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Benzethonium Chloride",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Benzethonium Chloride is a preservative used to protect formulas from microbial contamination during storage and use. Within cosmetic formulas, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Benzethonium Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>If Benzethonium Chloride appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "benzethoniumchloride",
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Benzisothiazolinone",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Benzisothiazolinone is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Benzisothiazolinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Benzisothiazolinone in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "bit",
      "isothiazolinones",
      "isothiazolinone"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Benzoic Acid",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Benzoic Acid is a preservative used to protect formulas from microbial contamination during storage and use. Across many personal-care products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Benzoic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Decision tip for Benzoic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "benzoicacid"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Benzophenone",
    "category": "Chemical UV Filters of Concern",
    "risk": "high",
    "description": "<p>Benzophenone is an aromatic ketone used as a UV absorber / stabilizer. In modern beauty formulations, it is tracked under chemical uv filters of concern because benzophenone and related synonyms are restricted on the Osmosis listing. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Benzophenone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile. Sunscreen reapplication increases total daily exposure, so tolerance matters more than in rinse-off use.</p><p>Checker guidance for Benzophenone: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Titanium Dioxide (CI 77891), Kaolin, or Iron Oxides (CI 77491).</p>",
    "aliases": [
      "benzophenone 1",
      "benzoylbenzene",
      "diphenyl ketone",
      "diphenylmethanone",
      "phenyl ketone",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which supports mineral-style coverage and finish. It’s a good match when you want mineral-minded formula support."
    }
  },
  {
    "chemical": "Benzophenone-3",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Benzophenone-3 is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In modern beauty formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Benzophenone-3 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>When reviewing Benzophenone-3, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "oxybenzone",
      "benzophenone 3",
      "benzophenone3",
      "bp 3",
      "bp3",
      "2 hydroxy 4 methoxybenzophenone",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Benzyl Benzoate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Benzyl Benzoate is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Benzyl Benzoate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Benzyl Benzoate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "benzylbenzoate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Benzyl Cinnamate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Benzyl Cinnamate is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Benzyl Cinnamate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Benzyl Cinnamate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "benzylcinnamate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Benzyl Salicylate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Benzyl Salicylate is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Benzyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Benzyl Salicylate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "benzylsalicylate",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Benzylhemiformal",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Benzylhemiformal is a formaldehyde-releasing preservative. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because it is explicitly listed on the Osmosis restricted ingredient listing. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Benzylhemiformal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing Benzylhemiformal: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "benzyl hemiformal",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Benzylparaben",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Benzylparaben is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Benzylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Benzylparaben: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Beta-Caryophyllene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Beta-Caryophyllene is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Beta-Caryophyllene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Beta-Caryophyllene: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "beta caryophyllene",
      "betacaryophyllene"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3964796633197": "Calm contains Beta-Glucan, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Beta-Glucan Oat or Barley Derived",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Beta-Glucan Oat or Barley Derived is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Beta-Glucan Oat or Barley Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Beta-Glucan Oat or Barley Derived in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "beta-Myrcene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>beta-Myrcene is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, beta-Myrcene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If beta-Myrcene appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Beta-Pinene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Beta-Pinene is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Beta-Pinene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Beta-Pinene, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "beta pinene",
      "betapinene",
      "β pinene"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3964796633197": "Calm contains Beta-Glucan, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Betaine Salicylate",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Betaine Salicylate is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In skincare formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Betaine Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Checker guidance for Betaine Salicylate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "betainesalicylate",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Betamethasone Dipropionate",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Betamethasone Dipropionate is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. Within cosmetic formulas, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Betamethasone Dipropionate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>If Betamethasone Dipropionate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Allantoin, Bisabolol, or Panthenol.</p>",
    "aliases": [
      "betamethasonedipropionate"
    ],
    "alternatives": [
      "Allantoin",
      "Bisabolol",
      "Panthenol",
      "Beta-Glucan",
      "Niacinamide",
      "Ascorbyl Phosphate",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Bio-ferment filtrates",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Bio-ferment filtrates is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Bio-ferment filtrates performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Bio-ferment filtrates in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "bifida ferment lysate",
      "lactobacillus",
      "saccharomyces"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Bisphenol A (BPA)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Bisphenol A (BPA) is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Bisphenol A (BPA) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Bisphenol A (BPA): use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Bisphenol S (BPS)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Bisphenol S (BPS) is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Bisphenol S (BPS) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Bisphenol S (BPS): use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Bithionol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Bithionol is a substance with significant toxicology concern and strict cosmetic regulation in many markets. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Bithionol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>How to interpret Bithionol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "bitin"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Boric Acid",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Boric Acid is a boron compound historically used for antimicrobial or pH roles. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because boric acid is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Boric Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Boric Acid in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Brassica Campestris Oil",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Brassica Campestris Oil is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Brassica Campestris Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Brassica Campestris Oil appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "canola",
      "canola oil"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Bronopol",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Bronopol is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Bronopol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>Decision tip for Bronopol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "2 bromo 2 nitropropane 1 3 diol",
      "2bromo2nitropropane13diol",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Butoxyethanol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Butoxyethanol is a glycol ether solvent. Across many personal-care products, it is tracked under drying alcohols & irritating solvents because butoxyethanol is explicitly restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Butoxyethanol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients. Rinse-off formats are usually easier to tolerate than heavy leave-on exposure.</p><p>When reviewing Butoxyethanol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "2 butoxyethanol",
      "butyl glycol",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Caprylyl Glycol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "3983847227501": "Mineral Hydration Finishing Mist contains Butylene Glycol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Butyl Acetate",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Butyl Acetate is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. In modern beauty formulations, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Butyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>When reviewing Butyl Acetate, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "butylacetate",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Butyl Alcohol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Butyl Alcohol is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. In skincare formulations, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Butyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>Checker guidance for Butyl Alcohol: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "butylalcohol",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Butyl Benzyl Phthalate (BBP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Butyl Benzyl Phthalate (BBP) is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Butyl Benzyl Phthalate (BBP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Butyl Benzyl Phthalate (BBP): use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Butyl Methacrylate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Butyl Methacrylate is a methacrylate monomer used in film-forming systems. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because butyl methacrylate is explicitly restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Butyl Methacrylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Butyl Methacrylate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Butylated Hydroxyanisole",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Butylated Hydroxyanisole is a preservative used to protect formulas from microbial contamination during storage and use. Within cosmetic formulas, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Butylated Hydroxyanisole performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>If Butylated Hydroxyanisole appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Tocopherol, Tocopheryl Acetate, or Ubiquinone.</p>",
    "aliases": [
      "butylatedhydroxyanisole",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Ubiquinone",
      "Astaxanthin",
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Butylated Hydroxytoluene",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Butylated Hydroxytoluene is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Butylated Hydroxytoluene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Butylated Hydroxytoluene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Tocopherol, Tocopheryl Acetate, or Ubiquinone.</p>",
    "aliases": [
      "butylatedhydroxytoluene",
      "bht",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Ubiquinone",
      "Astaxanthin",
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Butylene/Ethylene/Styrene Copolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Butylene/Ethylene/Styrene Copolymer is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Butylene/Ethylene/Styrene Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Butylene/Ethylene/Styrene Copolymer in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Butyloctyl Salicylate",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Butyloctyl Salicylate is a salicylate ester used as a UV-filter solvent / emollient. In skincare formulations, it is tracked under chemical uv filters of concern because salicylates and butyloctyl salicylate are restricted on the Osmosis listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Butyloctyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile. Sunscreen reapplication increases total daily exposure, so tolerance matters more than in rinse-off use.</p><p>If Butyloctyl Salicylate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891), Kaolin, or Iron Oxides (CI 77491).</p>",
    "aliases": [
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which supports mineral-style coverage and finish. It’s a good match when you want mineral-minded formula support."
    }
  },
  {
    "chemical": "Butylparaben",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Butylparaben is a preservative used to protect formulas from microbial contamination during storage and use. Across many personal-care products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Butylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Decision tip for Butylparaben: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "C.I. Acid Red 114",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>C.I. Acid Red 114 is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, C.I. Acid Red 114 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If C.I. Acid Red 114 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "C.I. Basic Red 9 (Pararosaniline)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>C.I. Basic Red 9 (Pararosaniline) is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, C.I. Basic Red 9 (Pararosaniline) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for C.I. Basic Red 9 (Pararosaniline): use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "C.I. Direct Blue 6",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>C.I. Direct Blue 6 is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, C.I. Direct Blue 6 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for C.I. Direct Blue 6: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "C9-15 Fluoroalcohol Phosphate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>C9-15 Fluoroalcohol Phosphate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, C9-15 Fluoroalcohol Phosphate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for C9-15 Fluoroalcohol Phosphate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cadmium",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cadmium is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Cadmium performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Cadmium: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cadmium Compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cadmium Compounds is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Cadmium Compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Cadmium Compounds: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Caffeine",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Caffeine is a stimulant active sometimes used in eye and body care. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because caffeine is explicitly listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Caffeine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Caffeine appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "1 3 7 trimethylxanthine"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cannabidiol (CBD)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Cannabidiol (CBD) is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cannabidiol (CBD) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Cannabidiol (CBD): use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Capryloyl Salicylic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Capryloyl Salicylic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In modern beauty formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Capryloyl Salicylic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>When reviewing Capryloyl Salicylic Acid, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "capryloylsalicylicacid",
      "lipo hydroxy acid",
      "lipohydroxyacid",
      "lha",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Carbon Black",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Carbon Black is a carbon-based black colorant. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because carbon black / Black 2 is restricted on the Osmosis listing due to impurity and sensitizer concerns. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Carbon Black performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Carbon Black in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "black 2",
      "ci 77266",
      "d&c black 2"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Carbon Nanotubes",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Carbon Nanotubes is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Carbon Nanotubes performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Carbon Nanotubes: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Carboxymethyl Chitosan",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Carboxymethyl Chitosan is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Carboxymethyl Chitosan performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Carboxymethyl Chitosan: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Carica Papaya (Papaya) Fruit Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Carica Papaya (Papaya) Fruit Extract is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Carica Papaya (Papaya) Fruit Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Carica Papaya (Papaya) Fruit Extract: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Carmine",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Carmine is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Carmine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing Carmine: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Carvone",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Carvone is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Carvone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Carvone: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Casein",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Casein is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Casein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Casein appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Castoreum",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Castoreum is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Castoreum performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Castoreum: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Cedrol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Cedrol is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Cedrol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Cedrol appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Cera Alba (Beeswax)",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Cera Alba (Beeswax) is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Cera Alba (Beeswax) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Cera Alba (Beeswax) in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Cera Flava",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Cera Flava is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Cera Flava performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Cera Flava in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Ceramides Animal-Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Ceramides Animal-Derived is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Ceramides Animal-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Ceramides Animal-Derived: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "ceramides",
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Cerium Dioxide Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cerium Dioxide Nano is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Cerium Dioxide Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Cerium Dioxide Nano: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ceteareth-20",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Ceteareth-20 is an ethoxylated fatty-alcohol emulsifier. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because ceteareth ingredients are restricted on the Osmosis listing and may carry 1,4-dioxane impurity concerns. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Ceteareth-20 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>If Ceteareth-20 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "ceteareth",
      "ceteareth 12",
      "ceteareth 30"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Cetrimonium Bromide",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Cetrimonium Bromide is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cetrimonium Bromide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>Decision tip for Cetrimonium Bromide: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Cetyl Alcohol Tallow-Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Cetyl Alcohol Tallow-Derived is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Cetyl Alcohol Tallow-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Cetyl Alcohol Tallow-Derived: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Chitin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Chitin is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Chitin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Chitin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Chitosan",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Chitosan is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Chitosan performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Chitosan appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Chlorhexidine",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Chlorhexidine is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Chlorhexidine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Chlorhexidine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Chlorine Dioxide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Chlorine Dioxide is a strong oxidizing antimicrobial agent. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because chlorine dioxide / ClO2 is restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Chlorine Dioxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Chlorine Dioxide: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "clo 2",
      "clo2"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Chloroacetamide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Chloroacetamide is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Chloroacetamide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Chloroacetamide appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Chloroatranol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "severe",
    "description": "<p>Chloroatranol is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Chloroatranol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Chloroatranol: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Chlorofluorocarbon Propellants",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Chlorofluorocarbon Propellants is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Chlorofluorocarbon Propellants performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>When reviewing Chlorofluorocarbon Propellants, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Isododecane or Isohexadecane.</p>",
    "aliases": [
      "chlorofluorocarbonpropellants",
      "cfc propellants",
      "cfcpropellants",
      "cfcs",
      "fluorocarbons",
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbon"
    ],
    "alternatives": [
      "Isododecane",
      "Isohexadecane",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Chloroform",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Chloroform is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Chloroform performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>Checker guidance for Chloroform: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Water (Aqua), Propanediol, or Butylene Glycol.</p>",
    "aliases": [],
    "alternatives": [
      "Water (Aqua)",
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Chloromethylisothiazolinone",
    "category": "Preservative Sensitizers",
    "risk": "severe",
    "description": "<p>Chloromethylisothiazolinone is a preservative used to protect formulas from microbial contamination during storage and use. Within cosmetic formulas, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Chloromethylisothiazolinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>If Chloromethylisothiazolinone appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "cmit",
      "isothiazolinones",
      "isothiazolinone"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Chloroxylenol",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Chloroxylenol is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Chloroxylenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Chloroxylenol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Cholecalciferol Lanolin-Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Cholecalciferol Lanolin-Derived is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Cholecalciferol Lanolin-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Cholecalciferol Lanolin-Derived in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "cholecalciferol",
      "cholecalciferol vitamin d3 lanolin derived",
      "vitamin d3",
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Cholesterol Animal-Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Cholesterol Animal-Derived is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Cholesterol Animal-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Cholesterol Animal-Derived: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "cholesterol",
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Chromium",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Chromium is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Chromium performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>Decision tip for Chromium: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891), Mica, or Boron Nitride.</p>",
    "aliases": [
      "chromate",
      "chromium salts",
      "chromiumsalts"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Chromium (hexavalent) compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Chromium (hexavalent) compounds is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Chromium (hexavalent) compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Chromium (hexavalent) compounds: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "chromium vi",
      "hexavalent chromium",
      "hexavalent chromium compounds"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Chromium Oxide Greens",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Chromium Oxide Greens is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Chromium Oxide Greens performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>When reviewing Chromium Oxide Greens, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891), Mica, or Iron Oxides (CI 77491).</p>",
    "aliases": [
      "chromiumoxidegreens"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "CI 77510",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>CI 77510 is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, CI 77510 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Decision tip for CI 77510: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ferric ferrocyanide ci 77510"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Cinnamal",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Cinnamal is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Cinnamal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Cinnamal: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Cinnamomum Camphora Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Cinnamomum Camphora Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. Within cosmetic formulas, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Cinnamomum Camphora Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>If Cinnamomum Camphora Oil appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "cinnamomumcamphoraoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Cinnamomum Zeylanicum Bark Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Cinnamomum Zeylanicum Bark Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. When used in topical products, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Cinnamomum Zeylanicum Bark Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>How to interpret Cinnamomum Zeylanicum Bark Oil in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "cinnamon bark oil",
      "cinnamonbarkoil",
      "cinnamomumzeylanicumbarkoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Cinnamyl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Cinnamyl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Cinnamyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Cinnamyl Acetate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "cinnamylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Cinnamyl Alcohol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Cinnamyl Alcohol is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cinnamyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Cinnamyl Alcohol, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "cinnamylalcohol"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Cinoxate",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Cinoxate is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In skincare formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Cinoxate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>Checker guidance for Cinoxate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Citral",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Citral is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Citral performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Citral appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Citronellol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Citronellol is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Citronellol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Citronellol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Citronellyl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Citronellyl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Citronellyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Citronellyl Acetate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "citronellylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Citrus Aurantium Amara Flower Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Citrus Aurantium Amara Flower Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. In skincare formulations, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Citrus Aurantium Amara Flower Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>Checker guidance for Citrus Aurantium Amara Flower Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "neroli oil",
      "nerolioil",
      "citrusaurantiumamarafloweroil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Civet",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Civet is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Civet performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Civet: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Clobetasol Propionate",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Clobetasol Propionate is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. Across many personal-care products, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Clobetasol Propionate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>Decision tip for Clobetasol Propionate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Allantoin, Bisabolol, or Panthenol.</p>",
    "aliases": [
      "clobetasolpropionate"
    ],
    "alternatives": [
      "Allantoin",
      "Bisabolol",
      "Panthenol",
      "Beta-Glucan",
      "Niacinamide",
      "Ascorbyl Phosphate",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Coal Tar",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Coal Tar is a complex tar-derived material historically used in some dermatologic products. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because coal tar is restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Coal Tar performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Coal Tar appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cobalt",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Cobalt is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cobalt performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>When reviewing Cobalt, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891), Mica, or Boron Nitride.</p>",
    "aliases": [
      "cobalt chloride",
      "cobaltchloride",
      "cobalt metal",
      "cobaltmetal"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Cobalt Compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cobalt Compounds is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Cobalt Compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Cobalt Compounds in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cocamide DEA",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Cocamide DEA is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Cocamide DEA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Checker guidance for Cocamide DEA: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "cocamidedea",
      "cocamide diethanolamine",
      "cocamidediethanolamine",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Cocamide MEA",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Cocamide MEA is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Within cosmetic formulas, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Cocamide MEA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>If Cocamide MEA appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "cocamidemea",
      "cocamide monoethanolamine",
      "cocamidemonoethanolamine",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Cocamidopropyl Betaine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Cocamidopropyl Betaine is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. When used in topical products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Cocamidopropyl Betaine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>How to interpret Cocamidopropyl Betaine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "cocamidopropylbetaine",
      "capb"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Cocamidopropylamine Oxide",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Cocamidopropylamine Oxide is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Across many personal-care products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Cocamidopropylamine Oxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Decision tip for Cocamidopropylamine Oxide: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "cocamidopropylamineoxide"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Cochineal Extract",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Cochineal Extract is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Cochineal Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>If Cochineal Extract appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Cocoa Butter",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Cocoa Butter is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cocoa Butter performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>When reviewing Cocoa Butter, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "cocoabutter",
      "theobroma cacao seed butter",
      "theobromacacaoseedbutter",
      "cacao butter",
      "cacaobutter"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Diheptyl Succinate",
      "Dicaprylyl Ether",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044882411629": "Hydrate contains Diheptyl Succinate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Collagen",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Collagen is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Collagen performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Collagen appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Colloidal Copper",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Colloidal Copper is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Colloidal Copper performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Colloidal Copper: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Colloidal Copper Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Colloidal Copper Nano is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Colloidal Copper Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Colloidal Copper Nano: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Colloidal Gold",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Colloidal Gold is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Colloidal Gold performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Colloidal Gold: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Colloidal Oatmeal",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Colloidal Oatmeal is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Colloidal Oatmeal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Colloidal Oatmeal: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Colloidal Platinum",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Colloidal Platinum is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Colloidal Platinum performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Colloidal Platinum: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Colloidal Silver",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Colloidal Silver is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Colloidal Silver performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Colloidal Silver in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Copper Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Copper Nano is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Copper Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Copper Nano appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cottonseed Oil",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Cottonseed Oil is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Cottonseed Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Cottonseed Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Coumarin",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Coumarin is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Coumarin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Coumarin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Cyanide Salts",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cyanide Salts is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Cyanide Salts performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Cyanide Salts: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cyclohexasiloxane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cyclohexasiloxane is a volatile cyclic silicone used for slip and sensory finish. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines restrict D6 / cyclohexasiloxane silicones. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Cyclohexasiloxane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Cyclohexasiloxane appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "d6",
      "dodecamethylcyclohexasiloxane",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cyclopentasiloxane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Cyclopentasiloxane is a volatile cyclic silicone used for lightweight slip and fast dry-down. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines restrict cyclomethicone / D4–D6 silicones for safety and formulation-policy reasons. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Cyclopentasiloxane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Cyclopentasiloxane: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "cyclomethicone",
      "d5",
      "decamethylcyclopentasiloxane",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cyclotetrasiloxane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Cyclotetrasiloxane is a volatile cyclic silicone associated with heightened regulatory scrutiny. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines restrict D4 silicones as highly restricted cosmetic toxicants. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Cyclotetrasiloxane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Cyclotetrasiloxane: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "d4",
      "octamethylcyclotetrasiloxane",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Cymbopogon Nardus Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Cymbopogon Nardus Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. Within cosmetic formulas, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Cymbopogon Nardus Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>If Cymbopogon Nardus Oil appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "citronella oil",
      "citronellaoil",
      "cymbopogonnardusoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "D&C Green No. 3",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>D&C Green No. 3 is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, D&C Green No. 3 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Decision tip for D&C Green No. 3: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "D&C Green No. 5",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>D&C Green No. 5 is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, D&C Green No. 5 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Checker guidance for D&C Green No. 5: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "green no 5"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "D&C Orange No. 5",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>D&C Orange No. 5 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, D&C Orange No. 5 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret D&C Orange No. 5 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "D&C Orange No. 5 (CI 45370)",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>D&C Orange No. 5 (CI 45370) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, D&C Orange No. 5 (CI 45370) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>If D&C Orange No. 5 (CI 45370) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 45370",
      "d&c orange no 5"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "D&C Red No. 33 (CI 17200)",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>D&C Red No. 33 (CI 17200) is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, D&C Red No. 33 (CI 17200) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Checker guidance for D&C Red No. 33 (CI 17200): use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 17200",
      "d&c red no 33",
      "d&c red no 33 ci 17200 & lake"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Daidzein",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Daidzein is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Daidzein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Daidzein: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "DEA-Cetyl Phosphate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>DEA-Cetyl Phosphate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Across many personal-care products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, DEA-Cetyl Phosphate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Decision tip for DEA-Cetyl Phosphate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "dea cetyl phosphate",
      "deacetylphosphate",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Deoxyarbutin",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Deoxyarbutin is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Deoxyarbutin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Deoxyarbutin: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Dextrin",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Dextrin is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Dextrin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Dextrin: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Di(2-ethylhexyl) Phthalate (DEHP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Di(2-ethylhexyl) Phthalate (DEHP) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Di(2-ethylhexyl) Phthalate (DEHP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Di(2-ethylhexyl) Phthalate (DEHP) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "bis 2 ethylhexyl phthalate",
      "dehp",
      "di phthalate dehp",
      "di 2 ethylhexyl phthalate",
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Di-n-hexyl Phthalate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Di-n-hexyl Phthalate is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Di-n-hexyl Phthalate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Di-n-hexyl Phthalate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Di-n-hexyl Phthalate (DnHP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Di-n-hexyl Phthalate (DnHP) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Di-n-hexyl Phthalate (DnHP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Di-n-hexyl Phthalate (DnHP) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Di-n-octyl Phthalate (DnOP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Di-n-octyl Phthalate (DnOP) is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Di-n-octyl Phthalate (DnOP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Di-n-octyl Phthalate (DnOP): use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Diazolidinyl Urea",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Diazolidinyl Urea is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. In modern beauty formulations, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Diazolidinyl Urea performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>When reviewing Diazolidinyl Urea, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "diazolidinylurea",
      "germall ii",
      "germallii",
      "germall 2",
      "germall2",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde",
      "urea based",
      "urea",
      "ureas"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Dibutyl Phthalate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Dibutyl Phthalate is a phthalate plasticizer. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because phthalates are restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Dibutyl Phthalate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Dibutyl Phthalate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "dbp",
      "diethyl phthalate",
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Diethanolamine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Diethanolamine is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Diethanolamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Checker guidance for Diethanolamine: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "dea",
      "ethanolamines",
      "ethanolamine",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Diethyl Ether",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Diethyl Ether is a highly volatile solvent. In modern beauty formulations, it is tracked under drying alcohols & irritating solvents because ether is restricted on the Osmosis listing; diethyl ether is used as the checker tag-safe representative. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Diethyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients. Rinse-off formats are usually easier to tolerate than heavy leave-on exposure.</p><p>Checker guidance for Diethyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "ether",
      "ethyl ether",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Caprylyl Glycol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "7181347881069": "Satin Treatment Primer contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Diethylene Glycol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Diethylene Glycol is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Diethylene Glycol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Diethylene Glycol appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Diisobutyl Phthalate (DIBP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Diisobutyl Phthalate (DIBP) is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Diisobutyl Phthalate (DIBP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Diisobutyl Phthalate (DIBP): use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Diisodecyl Phthalate (DIDP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Diisodecyl Phthalate (DIDP) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Diisodecyl Phthalate (DIDP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Diisodecyl Phthalate (DIDP) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "didp",
      "diisodecyl",
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Diisononyl Phthalate (DINP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Diisononyl Phthalate (DINP) is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Diisononyl Phthalate (DINP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Diisononyl Phthalate (DINP) in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "diisononyl",
      "dinp",
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Dimethyl Phthalate (DMP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Dimethyl Phthalate (DMP) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Dimethyl Phthalate (DMP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Dimethyl Phthalate (DMP) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Dimethylamine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "high",
    "description": "<p>Dimethylamine is an amine used in some surfactant / pH systems. In modern beauty formulations, it is tracked under harsh or irritation-prone surfactants because dimethylamine is explicitly restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Dimethylamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>Checker guidance for Dimethylamine: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Dioxybenzone",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Dioxybenzone is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. Within cosmetic formulas, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Dioxybenzone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>If Dioxybenzone appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "benzophenone 8",
      "benzophenone8",
      "bp 8",
      "bp8",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Direct Black 38",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Direct Black 38 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Direct Black 38 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Direct Black 38 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Direct Blue 15",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Direct Blue 15 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Direct Blue 15 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Direct Blue 15 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Direct Blue 218",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Direct Blue 218 is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Direct Blue 218 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Direct Blue 218: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Disodium EDTA",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Disodium EDTA is a chelating agent used to bind metal ions and support preservative systems. Across many personal-care products, it is tracked under preservative sensitizers because Osmosis guidelines restrict EDTA in any form. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Disodium EDTA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing Disodium EDTA: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "edta",
      "ethylenediaminetetraacetic acid",
      "sodium edta",
      "tetrasodium edta"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Disperse Blue 1",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Disperse Blue 1 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Disperse Blue 1 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Disperse Blue 1 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Disperse Blue 106",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Disperse Blue 106 is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Disperse Blue 106 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>How to interpret Disperse Blue 106 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891), Iron Oxides (CI 77491), or Iron Oxides (CI 77499).</p>",
    "aliases": [
      "disperseblue106"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Disperse Blue 124",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Disperse Blue 124 is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Disperse Blue 124 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>Decision tip for Disperse Blue 124: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Titanium Dioxide (CI 77891), Iron Oxides (CI 77491), or Iron Oxides (CI 77499).</p>",
    "aliases": [
      "disperseblue124"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Distarch Phosphate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Distarch Phosphate is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Distarch Phosphate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Distarch Phosphate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "DMDM Hydantoin",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>DMDM Hydantoin is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. In modern beauty formulations, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, DMDM Hydantoin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>When reviewing DMDM Hydantoin, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "dmdmhydantoin",
      "dmdmh",
      "1 3 dimethylol 5 5 dimethylhydantoin",
      "13dimethylol55dimethylhydantoin",
      "dimethylol dimethyl hydantoin",
      "dimethyloldimethylhydantoin",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Egg Lecithin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Egg Lecithin is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Egg Lecithin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Egg Lecithin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Elastin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Elastin is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Elastin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Elastin appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Erythrosine",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Erythrosine is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Erythrosine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Erythrosine appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "ci 45430",
      "fd&c red 3"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Estradiol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Estradiol is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Estradiol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Estradiol appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Estragole (Methyl Chavicol)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Estragole (Methyl Chavicol) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Estragole (Methyl Chavicol) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Estragole (Methyl Chavicol) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Estrogens",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Estrogens is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Estrogens performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Estrogens: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethanol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Ethanol is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. In skincare formulations, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Ethanol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>Checker guidance for Ethanol: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "ethyl alcohol",
      "ethylalcohol",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Ethinylestradiol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ethinylestradiol is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Ethinylestradiol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Ethinylestradiol appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethyl Acetate",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Ethyl Acetate is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Within cosmetic formulas, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Ethyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>If Ethyl Acetate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "ethylacetate",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Ethyl Acrylate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Ethyl Acrylate is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Ethyl Acrylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>How to interpret Ethyl Acrylate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Pullulan, Xanthan Gum, or Sclerotium Gum.</p>",
    "aliases": [
      "ethylacrylate",
      "ea",
      "ethlacrylate",
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Pullulan",
      "Sclerotium Gum",
      "Hydroxyethylcellulose",
      "Titanium Dioxide (CI 77891)",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Synthetic Fluorphlogopite",
      "Kaolin"
    ],
    "product_recommendations": {
      "7591723860077": "Amplify Maximizing Mascara contains Pullulan, which helps improve wear and texture. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Ethyl Ascorbic Acid",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Ethyl Ascorbic Acid is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Ethyl Ascorbic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Ethyl Ascorbic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethyl Perfluorobutyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ethyl Perfluorobutyl Ether is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Ethyl Perfluorobutyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Ethyl Perfluorobutyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethyl Perfluoroisobutyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ethyl Perfluoroisobutyl Ether is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Ethyl Perfluoroisobutyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Ethyl Perfluoroisobutyl Ether appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethylene Glycol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Ethylene Glycol is a simple glycol solvent with elevated safety concerns versus cosmetic glycols. In skincare formulations, it is tracked under drying alcohols & irritating solvents because ethylene glycol is explicitly restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Ethylene Glycol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients. Rinse-off formats are usually easier to tolerate than heavy leave-on exposure.</p><p>If Ethylene Glycol appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Caprylyl Glycol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "3983847227501": "Mineral Hydration Finishing Mist contains Butylene Glycol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Ethylene Oxide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ethylene Oxide is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Ethylene Oxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Ethylene Oxide: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethylene/Acrylic Acid Copolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ethylene/Acrylic Acid Copolymer is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Ethylene/Acrylic Acid Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Ethylene/Acrylic Acid Copolymer appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Ethylhexyl Methoxycinnamate",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Ethylhexyl Methoxycinnamate is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. Across many personal-care products, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Ethylhexyl Methoxycinnamate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>Decision tip for Ethylhexyl Methoxycinnamate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Titanium Dioxide (CI 77891), Aloe Barbadensis Leaf Juice, or Allantoin.</p>",
    "aliases": [
      "octinoxate",
      "ethylhexylmethoxycinnamate",
      "octyl methoxycinnamate",
      "octylmethoxycinnamate",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Ethylhexyl Salicylate",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Ethylhexyl Salicylate is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In modern beauty formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Ethylhexyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>When reviewing Ethylhexyl Salicylate, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891), Aloe Barbadensis Leaf Juice, or Allantoin.</p>",
    "aliases": [
      "octisalate",
      "ethylhexylsalicylate",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Ethylparaben",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Ethylparaben is a preservative used to protect formulas from microbial contamination during storage and use. In skincare formulations, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Ethylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Checker guidance for Ethylparaben: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Eucalyptol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Eucalyptol is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Eucalyptol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Eucalyptol appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "1 8 cineole",
      "18cineole",
      "cineole"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Eugenol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Eugenol is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Eugenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Eugenol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Evernia Furfuracea Extract",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Evernia Furfuracea Extract is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Evernia Furfuracea Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Evernia Furfuracea Extract: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "treemoss extract",
      "treemossextract",
      "everniafurfuraceaextract",
      "tree moss extract"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Evernia Prunastri Extract",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Evernia Prunastri Extract is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Evernia Prunastri Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Evernia Prunastri Extract, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "oakmoss extract",
      "oakmossextract",
      "everniaprunastriextract",
      "oak moss extract"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Farnesol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Farnesol is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Farnesol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Farnesol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "FD&C Blue No. 1 (CI 42090)",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>FD&C Blue No. 1 (CI 42090) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, FD&C Blue No. 1 (CI 42090) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>If FD&C Blue No. 1 (CI 42090) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 42090",
      "fd&c blue no 1",
      "fd&c blue no 1 ci 42090 & lake"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "FD&C Yellow No. 5",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>FD&C Yellow No. 5 is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, FD&C Yellow No. 5 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing FD&C Yellow No. 5: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 19140",
      "tartrazine"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "FD&C Yellow No. 6 (CI 15985)",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>FD&C Yellow No. 6 (CI 15985) is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, FD&C Yellow No. 6 (CI 15985) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Decision tip for FD&C Yellow No. 6 (CI 15985): use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 15985",
      "fd&c yellow no 6",
      "fd&c yellow no 6 ci 15985 & lake"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Ferulic Acid",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Ferulic Acid is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Ferulic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Ferulic Acid appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Formaldehyde",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Formaldehyde is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Within cosmetic formulas, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Formaldehyde performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>If Formaldehyde appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "methanal",
      "methylene oxide",
      "methyleneoxide",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Formalin",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Formalin is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. When used in topical products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Formalin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>How to interpret Formalin in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "formaldehyde solution",
      "formaldehydesolution",
      "aqueous formaldehyde",
      "aqueousformaldehyde",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Fullerenes",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Fullerenes is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Fullerenes performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Fullerenes appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Furfuryl Alcohol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Furfuryl Alcohol is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Furfuryl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Furfuryl Alcohol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Gamma-Terpinene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Gamma-Terpinene is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Gamma-Terpinene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Gamma-Terpinene: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "gamma terpinene",
      "gammaterpinene",
      "γ terpinene"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Gaultheria Procumbens Leaf Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Gaultheria Procumbens Leaf Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. In modern beauty formulations, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Gaultheria Procumbens Leaf Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>When reviewing Gaultheria Procumbens Leaf Oil, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "wintergreen oil",
      "wintergreenoil",
      "gaultheriaprocumbensleafoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Gelatin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Gelatin is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Gelatin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Gelatin: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Genistein",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Genistein is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Genistein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Genistein: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Geraniol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Geraniol is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Geraniol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Geraniol: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Geranyl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Geranyl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Geranyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Geranyl Acetate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "geranylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Glacial Acetic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Glacial Acetic Acid is a highly concentrated acid used for pH adjustment or specialty treatments. Across many personal-care products, it is tracked under strong exfoliating acids & peeling agents because glacial acetic acid is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Glacial Acetic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection. Introduce gradually and stop if stinging, peeling, or persistent redness outpaces visible benefit.</p><p>When reviewing Glacial Acetic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "acetic acid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Allantoin",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports smoother-looking texture. It’s a good match when you want renewal support with a gentler exfoliation approach."
    }
  },
  {
    "chemical": "Gluconolactone",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Gluconolactone is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. When used in topical products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Gluconolactone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>How to interpret Gluconolactone in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Gluconic Acid, Sodium Hyaluronate, or Betaine.</p>",
    "aliases": [],
    "alternatives": [
      "Gluconic Acid",
      "Sodium Hyaluronate",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044882411629": "Hydrate contains Sodium Hyaluronate, which helps hydrate skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Glutaral",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Glutaral is a strong aldehyde preservative / disinfectant. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because glutaral is restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Glutaral performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing Glutaral: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "glutaraldehyde",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Glyceryl Hydroxystearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Glyceryl Hydroxystearate is a glyceryl ester thickener / emollient. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because glyceryl hydroxystearate is listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Glyceryl Hydroxystearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Glyceryl Hydroxystearate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Glyceryl Isostearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Glyceryl Isostearate is a glyceryl ester emollient / emulsifier. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because glyceryl isostearate is listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Glyceryl Isostearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Glyceryl Isostearate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "glyceral isostearate"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Glycolic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Glycolic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. Across many personal-care products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Glycolic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Decision tip for Glycolic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "glycolicacid",
      "aha",
      "alpha hydroxy acid",
      "alphahydroxyacid",
      "ahas",
      "alpha hydroxy acids"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Glyoxal",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "high",
    "description": "<p>Glyoxal is a reactive dialdehyde used in some specialty systems. Within cosmetic formulas, it is tracked under formaldehyde & formaldehyde-releasing preservatives because glyoxal is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Glyoxal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret Glyoxal in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Gold Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Gold Nano is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Gold Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Gold Nano: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Gold Thioethylamino Hyaluronic Acid",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Gold Thioethylamino Hyaluronic Acid is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Gold Thioethylamino Hyaluronic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Gold Thioethylamino Hyaluronic Acid appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Goldenseal Root Powder",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Goldenseal Root Powder is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Goldenseal Root Powder performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Goldenseal Root Powder in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Gossypium Herbaceum derivatives",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Gossypium Herbaceum derivatives is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Gossypium Herbaceum derivatives performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Gossypium Herbaceum derivatives: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "gossypium herbaceum"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Granactive Retinoid",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Granactive Retinoid is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. In modern beauty formulations, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Granactive Retinoid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>When reviewing Granactive Retinoid, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "granactiveretinoid",
      "hydroxypinacolone retinoate complex",
      "hydroxypinacoloneretinoatecomplex",
      "hpr complex",
      "hprcomplex"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Guanidine Carbonate",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Guanidine Carbonate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Guanidine Carbonate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>Checker guidance for Guanidine Carbonate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Guanine",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Guanine is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Guanine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Guanine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ci 75170"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Halogenated Salicylanilides",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Halogenated Salicylanilides is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Halogenated Salicylanilides performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>Checker guidance for Halogenated Salicylanilides: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "halogenatedsalicylanilides",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "HC Blue No. 1",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>HC Blue No. 1 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, HC Blue No. 1 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret HC Blue No. 1 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "HDI/Trimethylol Hexyllactone Crosspolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>HDI/Trimethylol Hexyllactone Crosspolymer is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, HDI/Trimethylol Hexyllactone Crosspolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for HDI/Trimethylol Hexyllactone Crosspolymer: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hexachlorophene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Hexachlorophene is a substance with significant toxicology concern and strict cosmetic regulation in many markets. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Hexachlorophene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>If Hexachlorophene appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "hexachlorofen"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hexyl Cinnamal",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Hexyl Cinnamal is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Hexyl Cinnamal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Hexyl Cinnamal in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "hexylcinnamal"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Hexyl Salicylate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Hexyl Salicylate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Hexyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Hexyl Salicylate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Homosalate",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Homosalate is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. Across many personal-care products, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Homosalate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>Decision tip for Homosalate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Honey Extract",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Honey Extract is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Honey Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Honey Extract: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Hordeum Vulgare (Barley) Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Hordeum Vulgare (Barley) Extract is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Hordeum Vulgare (Barley) Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Hordeum Vulgare (Barley) Extract appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hydroabietyl Alcohol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "medium",
    "description": "<p>Hydroabietyl Alcohol is a rosin-derived alcohol used in fragrance / film systems. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because hydroabietyl alcohol is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Hydroabietyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated. Even small amounts can add up when multiple scented products are used in the same routine.</p><p>Decision tip for Hydroabietyl Alcohol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Allantoin, Bisabolol, or Beta-Glucan.</p>",
    "aliases": [],
    "alternatives": [
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Aloe Barbadensis Leaf Juice",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Hydrogen Cyanide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Hydrogen Cyanide is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Hydrogen Cyanide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Hydrogen Cyanide appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hydrogen Peroxide",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Hydrogen Peroxide is an oxidizing agent used for bleaching or antimicrobial roles. Within cosmetic formulas, it is tracked under strong exfoliating acids & peeling agents because hydrogen peroxide is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Hydrogen Peroxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection. Introduce gradually and stop if stinging, peeling, or persistent redness outpaces visible benefit.</p><p>How to interpret Hydrogen Peroxide in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Allantoin",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports smoother-looking texture. It’s a good match when you want renewal support with a gentler exfoliation approach."
    }
  },
  {
    "chemical": "Hydrolyzed Conchiolin Protein",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Hydrolyzed Conchiolin Protein is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Hydrolyzed Conchiolin Protein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Hydrolyzed Conchiolin Protein in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Hydrolyzed Elastin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Hydrolyzed Elastin is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Hydrolyzed Elastin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Hydrolyzed Elastin: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Hydrolyzed Keratin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Hydrolyzed Keratin is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Hydrolyzed Keratin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Hydrolyzed Keratin appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Hydrolyzed Silk",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Hydrolyzed Silk is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Hydrolyzed Silk performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Hydrolyzed Silk appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Hydrolyzed Wheat Gluten",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Hydrolyzed Wheat Gluten is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Hydrolyzed Wheat Gluten performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Hydrolyzed Wheat Gluten: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "gluten",
      "gluten risk"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hydrolyzed Wheat Protein",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Hydrolyzed Wheat Protein is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Hydrolyzed Wheat Protein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Hydrolyzed Wheat Protein in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hydroquinone",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Hydroquinone is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In modern beauty formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Hydroquinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>When reviewing Hydroquinone, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "hq"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Undecylenoyl Phenylalanine",
      "Ascorbyl Phosphate",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Hydroxyapatite Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Hydroxyapatite Nano is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Hydroxyapatite Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Hydroxyapatite Nano in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Hydroxycitronellal",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Hydroxycitronellal is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Hydroxycitronellal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Hydroxycitronellal: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Hydroxyisohexyl 3-Cyclohexene Carboxaldehyde",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "severe",
    "description": "<p>Hydroxyisohexyl 3-Cyclohexene Carboxaldehyde is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Hydroxyisohexyl 3-Cyclohexene Carboxaldehyde performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Hydroxyisohexyl 3-Cyclohexene Carboxaldehyde appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "hicc",
      "hydroxyisohexyl 3 cyclohexene carboxaldehyde",
      "hydroxyisohexyl3cyclohexenecarboxaldehyde",
      "lyral"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Hydroxypinacolone Retinoate",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Hydroxypinacolone Retinoate is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. When used in topical products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Hydroxypinacolone Retinoate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>How to interpret Hydroxypinacolone Retinoate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "hydroxypinacoloneretinoate",
      "hpr"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Imidazolidinyl Urea",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Imidazolidinyl Urea is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Imidazolidinyl Urea performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>Decision tip for Imidazolidinyl Urea: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "imidazolidinylurea",
      "germall 115",
      "germall115",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde",
      "urea based",
      "urea",
      "ureas"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Iodine",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Iodine is a halogen antimicrobial. In skincare formulations, it is tracked under preservative sensitizers because iodine is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Iodine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>If Iodine appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Iodopropynyl Butylcarbamate",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Iodopropynyl Butylcarbamate is a preservative used to protect formulas from microbial contamination during storage and use. In modern beauty formulations, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Iodopropynyl Butylcarbamate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>When reviewing Iodopropynyl Butylcarbamate, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "iodopropynylbutylcarbamate",
      "ipbc",
      "iodopropynyl butyllcarbamate"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Isoborneol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Isoborneol is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Isoborneol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Isoborneol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Isobornyl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Isobornyl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Isobornyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Isobornyl Acetate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "isobornylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Isobutane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Isobutane is a hydrocarbon propellant. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because isobutane is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Isobutane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Isobutane: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Isobutylparaben",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Isobutylparaben is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Isobutylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Isobutylparaben in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Isocetyl Stearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Isocetyl Stearate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Isocetyl Stearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Decision tip for Isocetyl Stearate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "isocetylstearate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Isoeugenol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Isoeugenol is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Isoeugenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Isoeugenol, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Isopropyl Isostearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Isopropyl Isostearate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Isopropyl Isostearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for Isopropyl Isostearate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "isopropylisostearate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Isopropyl Myristate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Isopropyl Myristate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Isopropyl Myristate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>If Isopropyl Myristate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "isopropylmyristate",
      "ipm"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Isopropyl Palmitate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Isopropyl Palmitate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Isopropyl Palmitate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>How to interpret Isopropyl Palmitate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "isopropylpalmitate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Isopropylparaben",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Isopropylparaben is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Isopropylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Isopropylparaben in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Isotretinoin",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Isotretinoin is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Across many personal-care products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Isotretinoin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Decision tip for Isotretinoin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "13 cis retinoic acid",
      "13cisretinoicacid",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Jasminum Officinale Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Jasminum Officinale Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. In modern beauty formulations, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Jasminum Officinale Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>When reviewing Jasminum Officinale Oil, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "jasmine oil",
      "jasmineoil",
      "jasminumofficinaleoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Keratin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Keratin is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Keratin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Keratin: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Ketoconazole",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Ketoconazole is an antifungal active typically used in drug products. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because ketoconazole is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Ketoconazole performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Ketoconazole: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Kojic Acid",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Kojic Acid is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In skincare formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Kojic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>Checker guidance for Kojic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "kojicacid"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Ascorbyl Phosphate",
      "Undecylenoyl Phenylalanine",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "L-Cysteine Hair or Feather Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>L-Cysteine Hair or Feather Derived is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, L-Cysteine Hair or Feather Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing L-Cysteine Hair or Feather Derived: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "l cysteine",
      "l cysteine hair feather derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Lactis Proteinum",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Lactis Proteinum is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Lactis Proteinum performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Lactis Proteinum: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Lactobionic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Lactobionic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. Within cosmetic formulas, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Lactobionic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>If Lactobionic Acid appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Gluconic Acid, Sodium Hyaluronate, or Betaine.</p>",
    "aliases": [
      "lactobionicacid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Sodium Hyaluronate",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044882411629": "Hydrate contains Sodium Hyaluronate, which helps hydrate skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Lactose",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Lactose is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Lactose performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Lactose appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Lanolin Alcohol",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Lanolin Alcohol is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Lanolin Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>How to interpret Lanolin Alcohol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "lanolinalcohol",
      "wool alcohols",
      "woolalcohols",
      "lanolin alcohols",
      "lanolinalcohols",
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Lard",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Lard is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Lard performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Lard: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Lauramide DEA",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Lauramide DEA is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Across many personal-care products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Lauramide DEA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Decision tip for Lauramide DEA: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "lauramidedea",
      "lauramide diethanolamine",
      "lauramidediethanolamine",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Laureth-23",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Laureth-23 is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Laureth-23 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>When reviewing Laureth-23, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "laureth 23",
      "laureth23"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Laureth-4",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Laureth-4 is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Laureth-4 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for Laureth-4: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "laureth 4",
      "laureth4"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Lauryl Lactate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Lauryl Lactate is an ester emollient / mild exfoliating ester. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because lauryl lactate is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Lauryl Lactate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Lauryl Lactate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Lead Acetate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Lead Acetate is a heavy-metal salt historically used in some color cosmetics. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because lead acetate is prohibited under Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Lead Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Lead Acetate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "lead"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Lead Compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Lead Compounds is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Lead Compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Lead Compounds: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Lilial",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "severe",
    "description": "<p>Lilial is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Lilial performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Lilial appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "butylphenyl methylpropional",
      "butylphenylmethylpropional",
      "bmhca",
      "p bmhca",
      "pbmhca"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Limonene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Limonene is a fragrance molecule used to build scent character in skincare and personal care formulas. When used in topical products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Limonene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>How to interpret Limonene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Linalool",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Linalool is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Linalool performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Linalool: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Linalyl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Linalyl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Linalyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Linalyl Acetate, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "linalylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Linoleamide DEA",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "high",
    "description": "<p>Linoleamide DEA is a DEA-derived surfactant / foam booster. When used in topical products, it is tracked under harsh or irritation-prone surfactants because linoleamide DEA is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Linoleamide DEA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>Decision tip for Linoleamide DEA: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "linoleamide dea",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Lysozyme",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Lysozyme is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Lysozyme performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Lysozyme in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Malt Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Malt Extract is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Malt Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Malt Extract in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Maltodextrin Wheat Derived",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Maltodextrin Wheat Derived is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Maltodextrin Wheat Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Maltodextrin Wheat Derived in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Manganese",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Manganese is a metal that can appear in pigments or impurities. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because manganese is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Manganese performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Manganese in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Marine Collagen",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Marine Collagen is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Marine Collagen performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Marine Collagen in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Marshmallow",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "medium",
    "description": "<p>Marshmallow is a botanical (Althaea) sometimes used for soothing claims. In modern beauty formulations, it is tracked under essential oils & aromatic botanicals because marshmallow is explicitly listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Marshmallow performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Simplify leave-on exposure first if your skin feels reactive, and prefer formulas built around gentler substitutes when possible. Patch testing a small area can help when you are unsure how your skin will respond over time.</p><p>Checker guidance for Marshmallow: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Allantoin, Bisabolol, or Beta-Glucan.</p>",
    "aliases": [
      "althaea",
      "althaea officinalis",
      "althea",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Aloe Barbadensis Leaf Juice",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and comfort skin. It’s a good match when you want calmer care with fewer aromatic oils."
    }
  },
  {
    "chemical": "Mel (Honey)",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Mel (Honey) is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Mel (Honey) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Mel (Honey): use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Mentha Viridis Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Mentha Viridis Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. When used in topical products, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Mentha Viridis Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>How to interpret Mentha Viridis Oil in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "spearmint oil",
      "spearmintoil",
      "menthaviridisoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Menthol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Menthol is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Menthol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Menthol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Mequinol",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Mequinol is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In modern beauty formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Mequinol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>When reviewing Mequinol, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "4 methoxyphenol",
      "4methoxyphenol",
      "p methoxyphenol",
      "pmethoxyphenol"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Ascorbyl Phosphate",
      "Undecylenoyl Phenylalanine",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Mercurous Chloride",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Mercurous Chloride is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Mercurous Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>Checker guidance for Mercurous Chloride: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "calomel",
      "mercurouschloride",
      "mercury chloride",
      "mercurychloride"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Undecylenoyl Phenylalanine",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Mercury",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Mercury is a substance with significant toxicology concern and strict cosmetic regulation in many markets. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Mercury performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>If Mercury appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "hg",
      "mercury compounds",
      "mercurycompounds"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Undecylenoyl Phenylalanine",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Mercury Ammoniated",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Mercury Ammoniated is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. When used in topical products, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Mercury Ammoniated performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>How to interpret Mercury Ammoniated in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "mercuryammoniated",
      "ammoniated mercury",
      "ammoniatedmercury"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Undecylenoyl Phenylalanine",
      "Ascorbyl Phosphate",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Methanol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Methanol is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Across many personal-care products, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Methanol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>Decision tip for Methanol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Methenamine",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Methenamine is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. In modern beauty formulations, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Methenamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>When reviewing Methenamine, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "hexamethylenetetramine",
      "urotropine",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Methyl 2-Octynoate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Methyl 2-Octynoate is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Methyl 2-Octynoate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Methyl 2-Octynoate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "methyl 2 octynoate",
      "methyl2octynoate",
      "methyl heptine carbonate",
      "methylheptinecarbonate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Methyl Ethyl Ketone",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Methyl Ethyl Ketone is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Within cosmetic formulas, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Methyl Ethyl Ketone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>If Methyl Ethyl Ketone appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "methylethylketone",
      "mek",
      "butanone",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Methyl Methacrylate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Methyl Methacrylate is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Methyl Methacrylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>How to interpret Methyl Methacrylate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Pullulan, Xanthan Gum, or Sclerotium Gum.</p>",
    "aliases": [
      "methylmethacrylate",
      "mma",
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Pullulan",
      "Sclerotium Gum",
      "Hydroxyethylcellulose",
      "Titanium Dioxide (CI 77891)",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Synthetic Fluorphlogopite",
      "Kaolin"
    ],
    "product_recommendations": {
      "7591723860077": "Amplify Maximizing Mascara contains Pullulan, which helps improve wear and texture. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Methyl Methacrylate Crosspolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Methyl Methacrylate Crosspolymer is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Methyl Methacrylate Crosspolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Methyl Methacrylate Crosspolymer appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methyl Perfluorobutyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Methyl Perfluorobutyl Ether is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Methyl Perfluorobutyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Methyl Perfluorobutyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methyl Perfluoroisobutyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Methyl Perfluoroisobutyl Ether is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Methyl Perfluoroisobutyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Methyl Perfluoroisobutyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methyl Salicylate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Methyl Salicylate is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Methyl Salicylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Methyl Salicylate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "methylsalicylate",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Methylchloroisothiazolinone",
    "category": "Preservative Sensitizers",
    "risk": "severe",
    "description": "<p>Methylchloroisothiazolinone is a preservative used to protect formulas from microbial contamination during storage and use. In modern beauty formulations, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Methylchloroisothiazolinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>When reviewing Methylchloroisothiazolinone, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "mci",
      "methylchloroisothiazolone",
      "isothiazolinones",
      "isothiazolinone"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Methyldibromo Glutaronitrile (MDGN)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Methyldibromo Glutaronitrile (MDGN) is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Methyldibromo Glutaronitrile (MDGN) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Methyldibromo Glutaronitrile (MDGN): use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methylene Chloride",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Methylene Chloride is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Methylene Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>Checker guidance for Methylene Chloride: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Water (Aqua), Propanediol, or Butylene Glycol.</p>",
    "aliases": [
      "methylenechloride",
      "dichloromethane",
      "dcm"
    ],
    "alternatives": [
      "Water (Aqua)",
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methylene Glycol",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Methylene Glycol is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Within cosmetic formulas, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Methylene Glycol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>If Methylene Glycol appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "methyleneglycol",
      "formaldehyde hydrate",
      "formaldehydehydrate",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Methyleugenol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Methyleugenol is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Methyleugenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Methyleugenol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Methylisothiazolinone",
    "category": "Preservative Sensitizers",
    "risk": "severe",
    "description": "<p>Methylisothiazolinone is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Methylisothiazolinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Methylisothiazolinone in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "mi",
      "methylisothiazolone",
      "isothiazolinones",
      "isothiazolinone"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Methylparaben",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Methylparaben is a preservative used to protect formulas from microbial contamination during storage and use. Across many personal-care products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Methylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Decision tip for Methylparaben: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Mineral Oil",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Mineral Oil is a petroleum-derived occlusive emollient. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because mineral oil and related petroleum ingredients are restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Mineral Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Mineral Oil in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "liquid paraffin",
      "paraffinum liquidum",
      "petroleum oil",
      "petroleum",
      "petroleum based",
      "petrolatum",
      "petrolatums"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Mink Oil",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Mink Oil is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Mink Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Mink Oil: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Monobenzone",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "severe",
    "description": "<p>Monobenzone is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. In modern beauty formulations, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Monobenzone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>When reviewing Monobenzone, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [
      "monobenzyl ether of hydroquinone",
      "monobenzyletherofhydroquinone",
      "mbeh"
    ],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Undecylenoyl Phenylalanine",
      "Ascorbyl Phosphate",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Monoethanolamine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "high",
    "description": "<p>Monoethanolamine is an ethanolamine used for pH adjustment and surfactant systems. Across many personal-care products, it is tracked under harsh or irritation-prone surfactants because MEA / ethanolamine are restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Monoethanolamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>When reviewing Monoethanolamine: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "ethanolamine",
      "mea",
      "ethanolamines",
      "dea"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Musk (animal)",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Musk (animal) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Musk (animal) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Musk (animal) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "animal musk",
      "musk"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Musk Ambrette",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Musk Ambrette is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Musk Ambrette performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Musk Ambrette: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Musk Ketone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Musk Ketone is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Musk Ketone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Musk Ketone: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Musk Xylene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Musk Xylene is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Musk Xylene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Musk Xylene: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Myrcene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Myrcene is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Myrcene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Myrcene: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Myristic Acid",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Myristic Acid is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Myristic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>If Myristic Acid appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Squalane, C15-19 Alkane, or Dicaprylyl Ether.</p>",
    "aliases": [
      "myristicacid"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Dicaprylyl Ether",
      "Coco-Caprylate/Caprate",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Myristyl Lactate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Myristyl Lactate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Myristyl Lactate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>How to interpret Myristyl Lactate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "myristyllactate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Myristyl Myristate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Myristyl Myristate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Myristyl Myristate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Decision tip for Myristyl Myristate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "myristylmyristate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "N-Methyl-N-Formylhydrazine",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>N-Methyl-N-Formylhydrazine is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, N-Methyl-N-Formylhydrazine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If N-Methyl-N-Formylhydrazine appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "N-Phenyl-p-Phenylenediamine",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>N-Phenyl-p-Phenylenediamine is an aromatic amine dye intermediate. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because it is restricted by Osmosis guidelines as a sensitizing dye intermediate. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, N-Phenyl-p-Phenylenediamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Decision tip for N-Phenyl-p-Phenylenediamine: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "n phenyl p phenylenediamine"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Nacre",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Nacre is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Nacre performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Nacre: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Naphazoline Hydrochloride",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Naphazoline Hydrochloride is a vasoconstrictor active typically used in drug products. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because naphazoline hydrochloride is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Naphazoline Hydrochloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Naphazoline Hydrochloride: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "naphazoline"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nerol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Nerol is a fragrance molecule used to build scent character in skincare and personal care formulas. In modern beauty formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Nerol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>When reviewing Nerol, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Neryl Acetate",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Neryl Acetate is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Neryl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Neryl Acetate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "nerylacetate"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Nickel",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Nickel is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Nickel performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>If Nickel appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891), Mica, or Boron Nitride.</p>",
    "aliases": [
      "nickel sulfate",
      "nickelsulfate",
      "nickel metal",
      "nickelmetal"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Nickel Compounds",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nickel Compounds is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Nickel Compounds performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Nickel Compounds: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nitrilotriacetic Acid (NTA)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nitrilotriacetic Acid (NTA) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Nitrilotriacetic Acid (NTA) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Nitrilotriacetic Acid (NTA) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "nitrilotriacetic acid salts",
      "nta",
      "nta salts"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nitrosamines",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nitrosamines is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Nitrosamines performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Nitrosamines in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "ndea",
      "ndela",
      "ndma"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nonoxynol-9",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "high",
    "description": "<p>Nonoxynol-9 is an ethoxylated alkylphenol surfactant. When used in topical products, it is tracked under harsh or irritation-prone surfactants because nonoxynol ingredients are restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Nonoxynol-9 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>Decision tip for Nonoxynol-9: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "nonoxynol",
      "nonoxynol 9"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Nylon-6",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nylon-6 is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Nylon-6 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Nylon-6: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nylon-611",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nylon-611 is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Nylon-611 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Nylon-611 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Nylon-66",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Nylon-66 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Nylon-66 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Nylon-66 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "o-Aminophenol",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>o-Aminophenol is an aromatic amine dye intermediate. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because o-aminophenol is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, o-Aminophenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>Decision tip for o-Aminophenol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "2 aminophenol",
      "o aminophenol"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "o-Phenylphenol",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>o-Phenylphenol is a phenolic preservative. Within cosmetic formulas, it is tracked under preservative sensitizers because phenylphenol is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, o-Phenylphenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret o-Phenylphenol in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "2 phenylphenol",
      "phenylphenol"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "o-Toluidine",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>o-Toluidine is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, o-Toluidine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for o-Toluidine: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Oat Amino Acids",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Oat Amino Acids is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Oat Amino Acids performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Oat Amino Acids appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Octafluoropentyl Methacrylate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Octafluoropentyl Methacrylate is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Octafluoropentyl Methacrylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Octafluoropentyl Methacrylate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Octocrylene",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Octocrylene is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. When used in topical products, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Octocrylene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>How to interpret Octocrylene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Octoxynol-9",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "high",
    "description": "<p>Octoxynol-9 is an ethoxylated octylphenol surfactant. When used in topical products, it is tracked under harsh or irritation-prone surfactants because octoxynol-9 is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Octoxynol-9 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>Decision tip for Octoxynol-9: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "octoxynol 9"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Octylisothiazolinone",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Octylisothiazolinone is a preservative used to protect formulas from microbial contamination during storage and use. Across many personal-care products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Octylisothiazolinone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Decision tip for Octylisothiazolinone: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "oit",
      "isothiazolinones",
      "isothiazolinone"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Oleamide DEA",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Oleamide DEA is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In modern beauty formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Oleamide DEA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>When reviewing Oleamide DEA, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "oleamidedea",
      "oleamide diethanolamine",
      "oleamidediethanolamine",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Oleic Acid",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Oleic Acid is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Oleic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for Oleic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "oleicacid"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Oleth-3",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Oleth-3 is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Oleth-3 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>If Oleth-3 appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "oleth 3",
      "oleth3",
      "oleth"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Ovum",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Ovum is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Ovum performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Ovum: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "p-Aminophenol",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>p-Aminophenol is an aromatic amine dye intermediate. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because p-aminophenol is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, p-Aminophenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing p-Aminophenol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "4 aminophenol",
      "p aminophenol"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "p-Phenylenediamine",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>p-Phenylenediamine is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. When used in topical products, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, p-Phenylenediamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>How to interpret p-Phenylenediamine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Mica.</p>",
    "aliases": [
      "p phenylenediamine",
      "pphenylenediamine",
      "ppd",
      "para phenylenediamine",
      "paraphenylenediamine"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "p-Toluenediamine",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Toluene-2,5-Diamine is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. In modern beauty formulations, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Toluene-2,5-Diamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>When reviewing Toluene-2,5-Diamine, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Mica.</p>",
    "aliases": [
      "toluene 2 5 diamine",
      "toluene25diamine",
      "ptd",
      "para toluenediamine",
      "paratoluenediamine"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "p-Toluenediamine Sulfate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Toluene-2,5-Diamine Sulfate is a colorant, metal-related compound, or acrylate-linked ingredient used for appearance or film performance. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because this class can provoke irritation or sensitization in people with prior cosmetic allergy history. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Toluene-2,5-Diamine Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Be extra careful around the eye area, track delayed reactions over 24-72 hours, and avoid repeat exposure when the same trigger pattern recurs.</p><p>Checker guidance for Toluene-2,5-Diamine Sulfate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Mica.</p>",
    "aliases": [
      "toluene 2 5 diamine sulfate",
      "toluene25diaminesulfate",
      "ptd sulfate",
      "ptdsulfate",
      "toluene diamine sulfate",
      "toluenediaminesulfate"
    ],
    "alternatives": [
      "Synthetic Fluorphlogopite",
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Boron Nitride",
      "Kaolin",
      "CI 77492",
      "Niacinamide"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which improves texture and finish. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "PABA",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>PABA is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. Across many personal-care products, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, PABA performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>Decision tip for PABA: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "para aminobenzoic acid",
      "paraaminobenzoicacid",
      "4 aminobenzoic acid",
      "4aminobenzoicacid",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Padimate O",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Padimate O is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In modern beauty formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Padimate O performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>When reviewing Padimate O, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "padimateo",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Parabens hidden in raw materials",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Parabens hidden in raw materials is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Parabens hidden in raw materials performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Parabens hidden in raw materials: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Pearl Powder",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Pearl Powder is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Pearl Powder performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Pearl Powder: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "PEG-40 Hydrogenated Castor Oil",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>PEG-40 Hydrogenated Castor Oil is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, PEG-40 Hydrogenated Castor Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for PEG-40 Hydrogenated Castor Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "peg 40 hydrogenated castor oil",
      "peg40hydrogenatedcastoroil",
      "polyethylene glycol 40 hydrogenated castor oil",
      "polyethyleneglycol40hydrogenatedcastoroil",
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "6799218868333": "Superfood Lip Oil contains Hydrogenated Polyisobutene, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "PEG-40 Stearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>PEG-40 Stearate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, PEG-40 Stearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>If PEG-40 Stearate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "peg 40 stearate",
      "peg40stearate",
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "PEG-8 Stearate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>PEG-8 Stearate is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, PEG-8 Stearate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>How to interpret PEG-8 Stearate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "peg 8 stearate",
      "peg8stearate",
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Pentaerythrityl Tetra-Di-T-Butyl Hydroxyhydrocinnamate",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Pentaerythrityl Tetra-Di-T-Butyl Hydroxyhydrocinnamate is a hindered phenolic antioxidant stabilizer. Across many personal-care products, it is tracked under preservative sensitizers because hydroxyhydrocinnamate / this antioxidant is restricted on the Osmosis listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Pentaerythrityl Tetra-Di-T-Butyl Hydroxyhydrocinnamate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing Pentaerythrityl Tetra-Di-T-Butyl Hydroxyhydrocinnamate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "hydroxyhydrocinnamate",
      "tinuvin"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Pentylparaben",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Pentylparaben is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Pentylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Pentylparaben appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perboric Acid",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perboric Acid is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Perboric Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Perboric Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluoroalkylethyl Phosphate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluoroalkylethyl Phosphate is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Perfluoroalkylethyl Phosphate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Perfluoroalkylethyl Phosphate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "6:2",
      "8:2",
      "dipaps",
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorodecalin",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorodecalin is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Perfluorodecalin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Perfluorodecalin: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorodecyl Triethoxysilane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorodecyl Triethoxysilane is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Perfluorodecyl Triethoxysilane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Perfluorodecyl Triethoxysilane in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorodimethylcyclohexane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorodimethylcyclohexane is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Perfluorodimethylcyclohexane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Perfluorodimethylcyclohexane: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorohexane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorohexane is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Perfluorohexane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Perfluorohexane in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorohexylethyl Triethoxysilane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorohexylethyl Triethoxysilane is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Perfluorohexylethyl Triethoxysilane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Perfluorohexylethyl Triethoxysilane in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluoromethylcyclopentane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluoromethylcyclopentane is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Perfluoromethylcyclopentane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Perfluoromethylcyclopentane: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorononyl Dimethicone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorononyl Dimethicone is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Perfluorononyl Dimethicone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Perfluorononyl Dimethicone: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorononylethyl Carboxydecyl PEG-10 Dimethicone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorononylethyl Carboxydecyl PEG-10 Dimethicone is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Perfluorononylethyl Carboxydecyl PEG-10 Dimethicone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Perfluorononylethyl Carboxydecyl PEG-10 Dimethicone: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon",
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluorooctyl Triethoxysilane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluorooctyl Triethoxysilane is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Perfluorooctyl Triethoxysilane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Perfluorooctyl Triethoxysilane: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluoroperhydrophenanthrene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluoroperhydrophenanthrene is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Perfluoroperhydrophenanthrene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Perfluoroperhydrophenanthrene appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Perfluoropolymethylisopropyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Perfluoropolymethylisopropyl Ether is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Perfluoropolymethylisopropyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Perfluoropolymethylisopropyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Petroleum Distillates",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Petroleum Distillates is a petroleum-derived solvent / emollient fraction. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because petroleum distillates are restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Petroleum Distillates performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Petroleum Distillates: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "petroleum distillate",
      "petroleum",
      "petroleum based",
      "petrolatum",
      "petrolatums"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "PFOS",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>PFOS is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, PFOS performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for PFOS: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Phenol",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "severe",
    "description": "<p>Phenol is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. Across many personal-care products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Phenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Decision tip for Phenol: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "carbolic acid",
      "phenol carbolic acid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Phenylbenzimidazole Sulfonic Acid",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Phenylbenzimidazole Sulfonic Acid is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In modern beauty formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Phenylbenzimidazole Sulfonic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>When reviewing Phenylbenzimidazole Sulfonic Acid, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "ensulizole",
      "phenylbenzimidazolesulfonicacid",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Phenylparaben",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Phenylparaben is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Phenylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Phenylparaben: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Phthalates migrating from packaging",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Phthalates migrating from packaging is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Phthalates migrating from packaging performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Phthalates migrating from packaging appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pvc",
      "closures",
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Phytic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Phytic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In skincare formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Phytic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Checker guidance for Phytic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Tetrasodium Glutamate Diacetate, or Sodium Gluconate.</p>",
    "aliases": [
      "phyticacid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Tetrasodium Glutamate Diacetate",
      "Sodium Gluconate",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "8049709809773": "Affirm MD contains Sodium Gluconate, which supports skin comfort. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Pinene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Pinene is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Pinene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Pinene appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Placental Enzymes",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Placental Enzymes is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Placental Enzymes performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Placental Enzymes appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Placental Protein",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Placental Protein is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Placental Protein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Placental Protein appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Platinum Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Platinum Nano is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Platinum Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Platinum Nano appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyacrylamide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyacrylamide is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Polyacrylamide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Polyacrylamide in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyacrylate Series",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyacrylate Series is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Polyacrylate Series performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Polyacrylate Series: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "polyacrylate",
      "polyacrylate x series",
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyaminopropyl Biguanide",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Polyaminopropyl Biguanide is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Polyaminopropyl Biguanide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Polyaminopropyl Biguanide in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "polyaminopropylbiguanide",
      "polyhexamethylene biguanide",
      "polyhexamethylenebiguanide",
      "phmb"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Polyethylene (PE)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyethylene (PE) is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Polyethylene (PE) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Polyethylene (PE): use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyethylene Glycol Series",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polyethylene Glycol Series is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Polyethylene Glycol Series performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Polyethylene Glycol Series: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "peg series",
      "peg x",
      "peg x series",
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyethylene Terephthalate (PET)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyethylene Terephthalate (PET) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Polyethylene Terephthalate (PET) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polyethylene Terephthalate (PET) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "phthalates",
      "phthalate",
      "pthalates",
      "pthalate",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyethylene Wax",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Polyethylene Wax is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Polyethylene Wax performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>When reviewing Polyethylene Wax: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Polyoxymethylene Urea",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Polyoxymethylene Urea is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Polyoxymethylene Urea performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>Decision tip for Polyoxymethylene Urea: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "polyoxymethyleneurea",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde",
      "urea based",
      "urea",
      "ureas"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Polyperfluoroethoxymethoxy Difluoroethyl PEG Phosphate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyperfluoroethoxymethoxy Difluoroethyl PEG Phosphate is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Polyperfluoroethoxymethoxy Difluoroethyl PEG Phosphate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Polyperfluoroethoxymethoxy Difluoroethyl PEG Phosphate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyperfluoroethoxymethoxy Difluorohydroxyethyl Dimer Dilinoleate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyperfluoroethoxymethoxy Difluorohydroxyethyl Dimer Dilinoleate is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Polyperfluoroethoxymethoxy Difluorohydroxyethyl Dimer Dilinoleate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polyperfluoroethoxymethoxy Difluorohydroxyethyl Dimer Dilinoleate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyperfluoromethylisopropyl Ether",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyperfluoromethylisopropyl Ether is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Polyperfluoromethylisopropyl Ether performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Polyperfluoromethylisopropyl Ether: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polypropylene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polypropylene is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Polypropylene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polypropylene appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyquaternium-10",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polyquaternium-10 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Polyquaternium-10 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Polyquaternium-10 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyquaternium-37",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polyquaternium-37 is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Polyquaternium-37 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polyquaternium-37 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyquaternium-6",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polyquaternium-6 is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Polyquaternium-6 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Polyquaternium-6: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyquaternium-7",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polyquaternium-7 is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Polyquaternium-7 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Polyquaternium-7: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polysilicone-11",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Polysilicone-11 is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Polysilicone-11 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Polysilicone-11: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polysorbate 20",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Polysorbate 20 is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Polysorbate 20 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>When reviewing Polysorbate 20, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "polysorbate20",
      "polysorbates",
      "polysorbate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Polysorbate 60",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Polysorbate 60 is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Polysorbate 60 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for Polysorbate 60: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "polysorbate60",
      "polysorbates",
      "polysorbate"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Polyurethane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Polyurethane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polyurethane appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "polyurethane 2 11 34 35 64"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyurethane-11",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane-11 is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Polyurethane-11 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Polyurethane-11: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyurethane-2",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane-2 is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Polyurethane-2 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Polyurethane-2 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyurethane-34",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane-34 is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Polyurethane-34 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Polyurethane-34: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyurethane-35",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane-35 is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Polyurethane-35 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Polyurethane-35: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Polyurethane-64",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Polyurethane-64 is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Polyurethane-64 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Polyurethane-64 in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Potassium Dichromate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "severe",
    "description": "<p>Potassium Dichromate is a chromium(VI) salt associated with strong sensitization and toxicity concerns. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because potassium dichromate is restricted by Osmosis guidelines. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Potassium Dichromate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Potassium Dichromate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "potassium bichromate"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "PPG Series",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>PPG Series is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, PPG Series performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for PPG Series: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "ppg",
      "ppg x series",
      "ppg x series propylene glycol ethers",
      "propylene glycol ethers"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Progesterone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Progesterone is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Progesterone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Progesterone: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Propanediol Corn-Derived",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Propanediol Corn-Derived is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Propanediol Corn-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Propanediol Corn-Derived appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "propanediol 1 3 propanediol corn derived"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Propolis Extract",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Propolis Extract is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Propolis Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Propolis Extract: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Propyl Alcohol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Propyl Alcohol is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Within cosmetic formulas, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Propyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>If Propyl Alcohol appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "propylalcohol",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Propylene Oxide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Propylene Oxide is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Propylene Oxide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Propylene Oxide appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Propylparaben",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Propylparaben is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Propylparaben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Propylparaben in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "PTFE",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>PTFE is a fluoropolymer / fluorocarbon-related material. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because fluorocarbons / PFAS-related materials are restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, PTFE performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing PTFE: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "fluorocarbons",
      "perfluoro compounds",
      "polytetrafluoroethylene",
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Pulegone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Pulegone is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Pulegone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Pulegone in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Pyruvic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Pyruvic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. Across many personal-care products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Pyruvic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Decision tip for Pyruvic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "pyruvicacid"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Quaternium-15",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Quaternium-15 is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. In modern beauty formulations, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Quaternium-15 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>When reviewing Quaternium-15, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "quaternium 15",
      "quaternium15",
      "quat 15",
      "quat15",
      "dowicil 200",
      "dowicil200",
      "quats",
      "quat",
      "quaternary ammonium",
      "quaternary ammoniums",
      "quaternary",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde",
      "ammonium based",
      "ammonium"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Rapeseed",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Rapeseed is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Rapeseed performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Rapeseed: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Resorcinol",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Resorcinol is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In skincare formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Resorcinol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Checker guidance for Resorcinol: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Sodium Ascorbyl Phosphate, or Phenylethyl Resorcinol.</p>",
    "aliases": [],
    "alternatives": [
      "Niacinamide",
      "Phenylethyl Resorcinol",
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Retinol",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Retinol is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Within cosmetic formulas, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Retinol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>If Retinol appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "vitamin a",
      "vitamina",
      "all trans retinol",
      "alltransretinol",
      "retinoids",
      "retinoid"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Retinyl Acetate",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Retinyl Acetate is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. When used in topical products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Retinyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>How to interpret Retinyl Acetate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinylacetate",
      "vitamin a acetate",
      "vitaminaacetate",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Retinyl Linoleate",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Retinyl Linoleate is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Across many personal-care products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Retinyl Linoleate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Decision tip for Retinyl Linoleate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinyllinoleate",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Retinyl Propionate",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Retinyl Propionate is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. In skincare formulations, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Retinyl Propionate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Checker guidance for Retinyl Propionate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinylpropionate",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Retinyl Retinoate",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Retinyl Retinoate is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Within cosmetic formulas, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Retinyl Retinoate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>If Retinyl Retinoate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinylretinoate",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Rosin",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "medium",
    "description": "<p>Rosin is a pine-derived resin used in adhesives and fragrance systems. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because rosin is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Rosin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated. Even small amounts can add up when multiple scented products are used in the same routine.</p><p>When reviewing Rosin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Allantoin, Bisabolol, or Beta-Glucan.</p>",
    "aliases": [
      "colophony"
    ],
    "alternatives": [
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Aloe Barbadensis Leaf Juice",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Royal Jelly",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Royal Jelly is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Royal Jelly performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Royal Jelly: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Safrole",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Safrole is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Safrole performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Safrole in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Salicylic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Salicylic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. Across many personal-care products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Salicylic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>Decision tip for Salicylic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Zinc Gluconate, or Gluconic Acid.</p>",
    "aliases": [
      "salicylicacid",
      "bha",
      "beta hydroxy acid",
      "betahydroxyacid",
      "salicylates",
      "salicylate",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Niacinamide",
      "Zinc Gluconate",
      "Gluconic Acid",
      "Panthenol",
      "Papain",
      "Bromelain",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Salix Alba Bark Extract",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Salix Alba Bark Extract is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In modern beauty formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Salix Alba Bark Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>When reviewing Salix Alba Bark Extract, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Zinc Gluconate, or Gluconic Acid.</p>",
    "aliases": [
      "willow bark extract",
      "willowbarkextract",
      "salixalbabarkextract",
      "salicylates",
      "salicylate",
      "beta hydroxy acid",
      "beta hydroxy acids",
      "bhas",
      "bha acid"
    ],
    "alternatives": [
      "Niacinamide",
      "Zinc Gluconate",
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Salvia Officinalis Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Salvia Officinalis Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. In skincare formulations, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Salvia Officinalis Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>Checker guidance for Salvia Officinalis Oil: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "sage oil",
      "sageoil",
      "salviaofficinalisoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Salvia Sclarea Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Salvia Sclarea Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. Within cosmetic formulas, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Salvia Sclarea Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>If Salvia Sclarea Oil appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "clary sage oil",
      "clarysageoil",
      "salviasclareaoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Santalum Album Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Santalum Album Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. When used in topical products, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Santalum Album Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>How to interpret Santalum Album Oil in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "santalumalbumoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "SD Alcohol 40",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>SD Alcohol 40 is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Across many personal-care products, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, SD Alcohol 40 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>Decision tip for SD Alcohol 40: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "sdalcohol40",
      "specially denatured alcohol 40",
      "speciallydenaturedalcohol40",
      "sd alcohol",
      "sdalcohol",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "SD Alcohol 40-B",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>SD Alcohol 40-B is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. In modern beauty formulations, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, SD Alcohol 40-B performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>When reviewing SD Alcohol 40-B, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "sd alcohol 40 b",
      "sdalcohol40b",
      "specially denatured alcohol 40 b",
      "speciallydenaturedalcohol40b",
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol",
      "Sodium PCA",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Secale Cereale (Rye) Seed Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Secale Cereale (Rye) Seed Extract is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Secale Cereale (Rye) Seed Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Secale Cereale (Rye) Seed Extract: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Selenium",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Selenium is a metal / metalloid of toxicological concern. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because selenium is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Selenium performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Selenium: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Selenium Sulfide",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Selenium Sulfide is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Selenium Sulfide performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Selenium Sulfide: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Serica",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Serica is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Serica performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Serica: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Sericin",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Sericin is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Sericin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Sericin: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Shellac (Lac resin)",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Shellac (Lac resin) is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Shellac (Lac resin) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Shellac (Lac resin): use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Silk",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Silk is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Silk performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing Silk: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Mineral Pressed Base contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Silk Amino Acids",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Silk Amino Acids is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Silk Amino Acids performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Silk Amino Acids in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Silver Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Silver Nano is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Silver Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Silver Nano: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silver colloidal nano"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Silver Zinc Zeolite",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Silver Zinc Zeolite is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Silver Zinc Zeolite performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Silver Zinc Zeolite: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Snail Secretion Filtrate (Snail Mucin)",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Snail Secretion Filtrate (Snail Mucin) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Snail Secretion Filtrate (Snail Mucin) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Snail Secretion Filtrate (Snail Mucin) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Sodium Borate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Borate is a boron salt used for pH / buffering in some older formulas. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because sodium borate is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Sodium Borate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Sodium Borate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "borax"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium C14-16 Olefin Sulfonate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium C14-16 Olefin Sulfonate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Sodium C14-16 Olefin Sulfonate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Checker guidance for Sodium C14-16 Olefin Sulfonate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodium c14 16 olefin sulfonate",
      "sodiumc1416olefinsulfonate",
      "sodium olefin sulfonate",
      "sodiumolefinsulfonate"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Caseinate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Sodium Caseinate is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Sodium Caseinate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>How to interpret Sodium Caseinate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Sodium Coco-Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Coco-Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Within cosmetic formulas, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Sodium Coco-Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>If Sodium Coco-Sulfate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodium coco sulfate",
      "sodiumcocosulfate",
      "scs"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Dodecylbenzenesulfonate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Dodecylbenzenesulfonate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. When used in topical products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Sodium Dodecylbenzenesulfonate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>How to interpret Sodium Dodecylbenzenesulfonate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodiumdodecylbenzenesulfonate"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Fluoride",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Fluoride is a fluoride salt typically used in oral-care drug products. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because sodium fluoride is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Sodium Fluoride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Sodium Fluoride: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Hyaluronate Bio-Fermented",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Sodium Hyaluronate Bio-Fermented is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Sodium Hyaluronate Bio-Fermented performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Sodium Hyaluronate Bio-Fermented: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Hyaluronate Rooster Comb Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Sodium Hyaluronate Rooster Comb Derived is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Sodium Hyaluronate Rooster Comb Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Sodium Hyaluronate Rooster Comb Derived: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "sodium hyaluronate rooster comb"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Sodium Hydroxide Relaxers",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Sodium Hydroxide Relaxers is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Sodium Hydroxide Relaxers performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret Sodium Hydroxide Relaxers in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Sodium Hydroxymethylglycinate",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Sodium Hydroxymethylglycinate is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Across many personal-care products, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Sodium Hydroxymethylglycinate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>Decision tip for Sodium Hydroxymethylglycinate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "sodiumhydroxymethylglycinate",
      "suttocide a",
      "suttocidea",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "7668596441197": "HydraFirm Smoothing Cream contains Sodium Levulinate, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Sodium Lactate",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Sodium Lactate is a lactate salt used for humectancy and mild AHA support. In modern beauty formulations, it is tracked under strong exfoliating acids & peeling agents because sodium lactate is listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Sodium Lactate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection. Introduce gradually and stop if stinging, peeling, or persistent redness outpaces visible benefit.</p><p>Checker guidance for Sodium Lactate: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Allantoin",
      "Panthenol",
      "Propanediol",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports smoother-looking texture. It’s a good match when you want renewal support with a gentler exfoliation approach."
    }
  },
  {
    "chemical": "Sodium Laureth Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Laureth Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In modern beauty formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Sodium Laureth Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>When reviewing Sodium Laureth Sulfate, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodiumlaurethsulfate",
      "sles",
      "sodium laureth sulphate",
      "sulfates",
      "sulfate",
      "sulphates",
      "sulphate",
      "sulfate surfactants",
      "sulphate surfactants"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Lauroyl Lactylate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Sodium Lauroyl Lactylate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Sodium Lauroyl Lactylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Sodium Lauroyl Lactylate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Lauroyl Oat Amino Acids",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Sodium Lauroyl Oat Amino Acids is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Sodium Lauroyl Oat Amino Acids performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Sodium Lauroyl Oat Amino Acids: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Lauryl Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Lauryl Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Sodium Lauryl Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>Checker guidance for Sodium Lauryl Sulfate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodiumlaurylsulfate",
      "sls",
      "sodium lauryl sulphate",
      "sulfates",
      "sulfate",
      "sulphates",
      "sulphate",
      "sulfate surfactants",
      "sulphate surfactants"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Metabisulfite",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Sodium Metabisulfite is a sulfite antioxidant / preservative. In skincare formulations, it is tracked under preservative sensitizers because sodium metabisulfite is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Sodium Metabisulfite performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>If Sodium Metabisulfite appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "sodium metabisulphite"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Sodium Myreth Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Myreth Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. Within cosmetic formulas, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Sodium Myreth Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>If Sodium Myreth Sulfate appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodiummyrethsulfate"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium Perborate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Perborate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Sodium Perborate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Sodium Perborate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "its salts sodium perborate",
      "perboric acid salts"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Perfluorohexane Sulfonate (PFHxS)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Perfluorohexane Sulfonate (PFHxS) is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Sodium Perfluorohexane Sulfonate (PFHxS) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Sodium Perfluorohexane Sulfonate (PFHxS): use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pfas",
      "pfa",
      "forever chemicals",
      "forever chemical",
      "perfluoroalkyl",
      "polyfluoroalkyl",
      "fluorocarbons",
      "fluorocarbon"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Polyacrylate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Polyacrylate is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Sodium Polyacrylate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Sodium Polyacrylate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Styrene/Acrylates Copolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Styrene/Acrylates Copolymer is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Sodium Styrene/Acrylates Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Sodium Styrene/Acrylates Copolymer: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "sodium styrene acrylates copolymer nano",
      "sodium styrene acrylates copolymer",
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Styrene/Acrylates Copolymer Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium Styrene/Acrylates Copolymer Nano is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Sodium Styrene/Acrylates Copolymer Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Sodium Styrene/Acrylates Copolymer Nano appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sodium Tallowate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Sodium Tallowate is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Sodium Tallowate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Sodium Tallowate: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Sodium Xylenesulfonate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Sodium Xylenesulfonate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. When used in topical products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Sodium Xylenesulfonate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>How to interpret Sodium Xylenesulfonate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "sodiumxylenesulfonate"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Sodium/Potassium salts of any paraben",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Sodium/Potassium salts of any paraben is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Sodium/Potassium salts of any paraben performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Sodium/Potassium salts of any paraben in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "potassium butylparaben",
      "potassium methylparaben",
      "potassium propylparaben",
      "sodium butylparaben",
      "sodium methylparaben",
      "sodium propylparaben",
      "parabens",
      "paraben",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sorbic Acid",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Sorbic Acid is a preservative used to protect formulas from microbial contamination during storage and use. Across many personal-care products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Sorbic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Decision tip for Sorbic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "sorbicacid"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Soy Isoflavones",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Soy Isoflavones is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Soy Isoflavones performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Soy Isoflavones: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Soy Protein",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Soy Protein is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Soy Protein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Soy Protein: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Soy Sterols",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Soy Sterols is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Soy Sterols performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Soy Sterols appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Squalane Bio-Fermented",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Squalane Bio-Fermented is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Squalane Bio-Fermented performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Squalane Bio-Fermented: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "squalane sugarcane bio fermented"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Squalane Shark-Derived",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Squalane Shark-Derived is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Squalane Shark-Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Squalane Shark-Derived appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Squalene",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Squalene is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Squalene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>If Squalene appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [
      "non vegan",
      "animal derived"
    ],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Steareth-20",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Steareth-20 is an ethoxylated stearyl-alcohol emulsifier. In skincare formulations, it is tracked under harsh or irritation-prone surfactants because steareth-20 is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Steareth-20 performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>If Steareth-20 appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [
      "steareth 20"
    ],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Stearyl Alcohol",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Stearyl Alcohol is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Stearyl Alcohol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Stearyl Alcohol: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Styrene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Styrene is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Styrene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>How to interpret Styrene in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Styrene/Acrylates Copolymer Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Styrene/Acrylates Copolymer Nano is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Styrene/Acrylates Copolymer Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Styrene/Acrylates Copolymer Nano: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sucrose",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Sucrose is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Sucrose performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Sucrose appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Sulfur",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "medium",
    "description": "<p>Sulfur is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In modern beauty formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Sulfur performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>When reviewing Sulfur, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Zinc Gluconate, or Panthenol.</p>",
    "aliases": [],
    "alternatives": [
      "Niacinamide",
      "Zinc Gluconate",
      "Panthenol",
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Sulisobenzone",
    "category": "Chemical UV Filters of Concern",
    "risk": "medium",
    "description": "<p>Sulisobenzone is a chemical UV filter that absorbs ultraviolet radiation to prevent sunburn and pigment darkening. In skincare formulations, it is tracked under chemical uv filters of concern because some filters in this group can irritate reactive skin, raise photoallergy questions, or create ingredient-preference concerns for users who want mineral-only SPF. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Sulisobenzone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Review where it appears in the formula, patch test if your skin is reactive, and compare with mineral-filter options when you want a simpler trigger profile.</p><p>Checker guidance for Sulisobenzone: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "benzophenone 4",
      "benzophenone4",
      "bp 4",
      "bp4",
      "chemical uv filters",
      "chemical uv filter",
      "chemical sunscreen",
      "chemical sunscreens",
      "organic uv filters",
      "organic uv filter",
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Titanium Dioxide (CI 77891)",
      "Kaolin",
      "Iron Oxides (CI 77491)",
      "Niacinamide",
      "Panthenol",
      "Propanediol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "6799229845613": "Beach Glow Bronzer contains Titanium Dioxide (CI 77891), which provides mineral color and coverage. It’s a good match when you want mineral-based color and coverage."
    }
  },
  {
    "chemical": "Synthetic Wax",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Synthetic Wax is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Synthetic Wax performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret Synthetic Wax in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Syzygium Aromaticum Oil",
    "category": "Essential Oils & Aromatic Botanicals",
    "risk": "high",
    "description": "<p>Syzygium Aromaticum Oil is an aromatic botanical component added mainly for scent, sensorial experience, or botanical positioning. Within cosmetic formulas, it is tracked under essential oils & aromatic botanicals because natural fragrance constituents can still trigger irritation or contact sensitivity in people with reactive skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Syzygium Aromaticum Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Keep total fragrance load low across your routine, avoid stacking multiple scented leave-on products, and prioritize bland formulas during flare-ups.</p><p>If Syzygium Aromaticum Oil appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [
      "clove oil",
      "cloveoil",
      "syzygiumaromaticumoil",
      "essential oils",
      "essential oil"
    ],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Aloe Barbadensis Leaf Juice, which helps soothe and support skin. It’s a good match when you want soothing care without essential oils."
    }
  },
  {
    "chemical": "Talc",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Talc is a mineral powder used for slip and oil absorption. Across many personal-care products, it is tracked under metals, dyes & acrylate sensitizers because talc is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Talc performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>When reviewing Talc: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Tallow",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Tallow is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Tallow performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Tallow: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Tallow Acid",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Tallow Acid is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Tallow Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>When reviewing Tallow Acid: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Tartaric Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "high",
    "description": "<p>Tartaric Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. When used in topical products, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Tartaric Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>How to interpret Tartaric Acid in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "tartaricacid",
      "aha",
      "ahas",
      "alpha hydroxy acid",
      "alpha hydroxy acids"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Tazarotene",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Tazarotene is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Across many personal-care products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Tazarotene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Decision tip for Tazarotene: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "TEA-Lauryl Sulfate",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>TEA-Lauryl Sulfate is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. In modern beauty formulations, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, TEA-Lauryl Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>When reviewing TEA-Lauryl Sulfate, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "tea lauryl sulfate",
      "tealaurylsulfate",
      "sulfates",
      "sulfate",
      "sulphates",
      "sulphate",
      "sulfate surfactants",
      "sulphate surfactants"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Lauryl Glucoside, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Terpineol",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Terpineol is a fragrance molecule used to build scent character in skincare and personal care formulas. In skincare formulations, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Terpineol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Checker guidance for Terpineol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Terpinolene",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Terpinolene is a fragrance molecule used to build scent character in skincare and personal care formulas. Within cosmetic formulas, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Terpinolene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>If Terpinolene appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Tetrahydropyranyloxy Phenol",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Tetrahydropyranyloxy Phenol is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Tetrahydropyranyloxy Phenol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Tetrahydropyranyloxy Phenol: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Thimerosal",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Thimerosal is a preservative used to protect formulas from microbial contamination during storage and use. When used in topical products, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Thimerosal performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>How to interpret Thimerosal in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Thioglycolic Acid",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Thioglycolic Acid is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Thioglycolic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>Checker guidance for Thioglycolic Acid: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "aha",
      "ahas",
      "alpha hydroxy acid",
      "alpha hydroxy acids"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Titanium Dioxide Airborne Unbound",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Titanium Dioxide Airborne Unbound is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Titanium Dioxide Airborne Unbound performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Titanium Dioxide Airborne Unbound: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "titanium dioxide airborne respirable unbound"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Titanium Dioxide Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Titanium Dioxide Nano is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Titanium Dioxide Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Titanium Dioxide Nano: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Tocopherol Wheat Germ Derived",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Tocopherol Wheat Germ Derived is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Tocopherol Wheat Germ Derived performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Tocopherol Wheat Germ Derived: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Toluene",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Toluene is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Across many personal-care products, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Toluene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>Decision tip for Toluene: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Isododecane, Isohexadecane, or C15-19 Alkane.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Isododecane",
      "Isohexadecane",
      "C15-19 Alkane",
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Tosylamide Epoxy Resin",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "high",
    "description": "<p>Tosylamide Epoxy Resin is a film-forming resin used in some nail systems. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because tosylamide epoxy resin is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Tosylamide Epoxy Resin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Tosylamide Epoxy Resin in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Tosylamide/Formaldehyde Resin",
    "category": "Formaldehyde & Formaldehyde-Releasing Preservatives",
    "risk": "severe",
    "description": "<p>Tosylamide/Formaldehyde Resin is a preservative linked to formaldehyde exposure pathways in cosmetic preservation systems. Within cosmetic formulas, it is tracked under formaldehyde & formaldehyde-releasing preservatives because this chemistry is a frequent source of allergic contact dermatitis and receives heightened safety scrutiny in sensitive populations. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Tosylamide/Formaldehyde Resin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat prior preservative allergy history as a major signal, avoid repeat exposure if you have reacted before, and select modern low-sensitization preservative systems when possible.</p><p>If Tosylamide/Formaldehyde Resin appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "tosylamide formaldehyde resin",
      "tosylamideformaldehyderesin",
      "tsfr",
      "formaldehyde releasers",
      "formaldehyde releaser",
      "formaldehyde releasing",
      "formaldehyde forming",
      "formaldehyde"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Tranexamic Acid",
    "category": "Skin-Lightening Agents of Concern",
    "risk": "medium",
    "description": "<p>Tranexamic Acid is a pigment-modulating active used to fade dark spots and improve visible tone unevenness. When used in topical products, it is tracked under skin-lightening agents of concern because results depend on concentration and use pattern, while misuse can increase irritation or rebound discoloration concerns. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Tranexamic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Pair with daily broad-spectrum sunscreen, set realistic timelines, and reassess if irritation appears before visible tone benefits.</p><p>How to interpret Tranexamic Acid in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Niacinamide, Sodium Ascorbyl Phosphate, or Undecylenoyl Phenylalanine.</p>",
    "aliases": [
      "tranexamicacid"
    ],
    "alternatives": [
      "Niacinamide",
      "Undecylenoyl Phenylalanine",
      "Ascorbyl Phosphate",
      "Phenylethyl Resorcinol",
      "Glycyrrhiza Glabra (Licorice) Root Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Panthenol",
      "Propanediol"
    ],
    "product_recommendations": {
      "6873600950381": "Perfection contains Undecylenoyl Phenylalanine, which helps support a more even-looking tone. It’s a good match when you want a more even-looking tone with a milder brightening approach."
    }
  },
  {
    "chemical": "Tretinoin",
    "category": "Retinoids & Pregnancy-Caution Actives",
    "risk": "severe",
    "description": "<p>Tretinoin is a vitamin A derivative used to target acne, uneven texture, and signs of photoaging. Across many personal-care products, it is tracked under retinoids & pregnancy-caution actives because retinoids can be highly effective but also increase irritation risk and require pregnancy-caution decision making. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>For consumers with reactive skin, Tretinoin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Introduce slowly, avoid aggressive active stacking early on, and follow clinician guidance during pregnancy or preconception planning.</p><p>Decision tip for Tretinoin: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Niacinamide, Panthenol, or Palmitoyl Tripeptide-1.</p>",
    "aliases": [
      "retinoic acid",
      "retinoicacid",
      "tretinoin acid",
      "tretinoinacid",
      "all trans retinoic acid",
      "alltransretinoicacid",
      "retinoids",
      "retinoid",
      "retinol"
    ],
    "alternatives": [
      "Retinaldehyde",
      "Niacinamide",
      "Panthenol",
      "Palmitoyl Tripeptide-1",
      "Palmitoyl Tripeptide-38",
      "Allantoin",
      "Beta-Glucan",
      "Propanediol"
    ],
    "product_recommendations": {
      "3964801843309": "Correct contains Retinaldehyde, which delivers gentle vitamin A renewal with retinaldehyde. It’s a good match when you want smoother, more even-looking skin with Osmosis retinaldehyde instead of harsher retinoids."
    }
  },
  {
    "chemical": "Trichloroacetic Acid",
    "category": "Strong Exfoliating Acids & Peeling Agents",
    "risk": "severe",
    "description": "<p>Trichloroacetic Acid is a keratolytic or peeling active that accelerates cell turnover and smooths rough texture. In modern beauty formulations, it is tracked under strong exfoliating acids & peeling agents because strong exfoliation can over-challenge the barrier and increase stinging, peeling, or post-inflammatory pigmentation risk. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Trichloroacetic Acid performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Space usage carefully, avoid combining with multiple aggressive actives on the same night, and prioritize hydration plus sun protection.</p><p>When reviewing Trichloroacetic Acid, use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Gluconic Acid, Papain, or Bromelain.</p>",
    "aliases": [
      "trichloroaceticacid",
      "tca"
    ],
    "alternatives": [
      "Gluconic Acid",
      "Papain",
      "Bromelain",
      "Niacinamide",
      "Panthenol",
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Propanediol"
    ],
    "product_recommendations": {
      "4044797640813": "Illuminate Eye & Lip contains Niacinamide, which supports healthier-looking skin. It’s a good match when you want gentler support for texture and tone."
    }
  },
  {
    "chemical": "Trichloroethylene",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Trichloroethylene is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Trichloroethylene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Trichloroethylene: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triclocarban",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Triclocarban is a preservative used to protect formulas from microbial contamination during storage and use. In skincare formulations, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Triclocarban performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>Checker guidance for Triclocarban: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Triclosan",
    "category": "Preservative Sensitizers",
    "risk": "high",
    "description": "<p>Triclosan is a preservative used to protect formulas from microbial contamination during storage and use. Within cosmetic formulas, it is tracked under preservative sensitizers because some preservatives are established sensitizers and can cause irritation or delayed allergic reactions in susceptible users. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Triclosan performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance.</p><p>If Triclosan appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [
      "endocrine disruptor",
      "endocrine disruptors",
      "endocrine disrupting",
      "endocrine disrupting chemicals",
      "edc",
      "edcs"
    ],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Sodium Levulinate",
      "Hydroxyacetophenone",
      "Tropolone"
    ],
    "product_recommendations": {
      "3965089906797": "Tropical Mango Mask contains Caprylhydroxamic Acid, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Triethanolamine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Triethanolamine is a cleansing surfactant that helps lift oil, makeup, and debris from the skin surface. When used in topical products, it is tracked under harsh or irritation-prone surfactants because stronger surfactants can strip barrier lipids and leave skin rough, tight, or more reactive after cleansing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Triethanolamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent.</p><p>How to interpret Triethanolamine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Sodium Cocoyl Glutamate, Sodium Lauroyl Methyl Isethionate, or Sodium Methyl Cocoyl Taurate.</p>",
    "aliases": [
      "tea",
      "trolamine",
      "ethanolamines",
      "ethanolamine",
      "dea",
      "mea"
    ],
    "alternatives": [
      "Sodium Cocoyl Glutamate",
      "Sodium Lauroyl Methyl Isethionate",
      "Sodium Methyl Cocoyl Taurate",
      "Sodium Cocoamphoacetate",
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Sodium Coco-Glucoside Tartrate"
    ],
    "product_recommendations": {
      "3963025031277": "Purify contains Sodium Cocoamphoacetate, which cleanses gently. It’s a good match when you want a milder cleanse."
    }
  },
  {
    "chemical": "Triethoxycaprylylsilane",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Triethoxycaprylylsilane is a silane surface-treatment used on pigments and powders. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because it is explicitly listed on the Osmosis restricted ingredient listing. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From an ingredient-checking standpoint, Triethoxycaprylylsilane performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Triethoxycaprylylsilane: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triethyl Citrate",
    "category": "Preservative Sensitizers",
    "risk": "medium",
    "description": "<p>Triethyl Citrate is an ingredient restricted by Osmosis formulation guidelines. Within cosmetic formulas, it is tracked under preservative sensitizers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Triethyl Citrate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Cross-check all daily products for repeated preservative exposure, discontinue early at signs of dermatitis, and move to alternatives with better personal tolerance. Preservative stacking across serums, creams, and mists is a common hidden trigger.</p><p>How to interpret Triethyl Citrate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylhydroxamic Acid, Ethylhexylglycerin, or Glyceryl Caprylate.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylhydroxamic Acid",
      "Ethylhexylglycerin",
      "Glyceryl Caprylate",
      "Glyceryl Undecylenate",
      "Levulinic Acid",
      "Tropolone",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Tropolone, which helps keep the formula fresh. It’s a good match when you want gentler formula preservation."
    }
  },
  {
    "chemical": "Triethylene Glycol",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "medium",
    "description": "<p>Triethylene Glycol is a glycol solvent / humectant. In skincare formulations, it is tracked under drying alcohols & irritating solvents because triethylene glycol is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Triethylene Glycol performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients. Rinse-off formats are usually easier to tolerate than heavy leave-on exposure.</p><p>If Triethylene Glycol appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Propanediol, Butylene Glycol, or Pentylene Glycol.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "Caprylyl Glycol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Caprylic/Capric Triglyceride"
    ],
    "product_recommendations": {
      "3983847227501": "Mineral Hydration Finishing Mist contains Butylene Glycol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Trifluoromethyl C1-4 Alkyl Dimethicone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Trifluoromethyl C1-4 Alkyl Dimethicone is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Trifluoromethyl C1-4 Alkyl Dimethicone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Trifluoromethyl C1-4 Alkyl Dimethicone: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Trifluoropropyl Dimethicone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Trifluoropropyl Dimethicone is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Trifluoropropyl Dimethicone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Trifluoropropyl Dimethicone appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Trifluoropropyl Dimethicone/PEG-10 Dimethicone Crosspolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Trifluoropropyl Dimethicone/PEG-10 Dimethicone Crosspolymer is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Trifluoropropyl Dimethicone/PEG-10 Dimethicone Crosspolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Trifluoropropyl Dimethicone/PEG-10 Dimethicone Crosspolymer appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pegs",
      "peg",
      "polyethylene glycol",
      "polyethylene glycols",
      "polyethelene glycol",
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Trifluoropropyl Methicone",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Trifluoropropyl Methicone is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Trifluoropropyl Methicone performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Trifluoropropyl Methicone appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triisopropanolamine",
    "category": "Harsh or Irritation-Prone Surfactants",
    "risk": "medium",
    "description": "<p>Triisopropanolamine is an alkanolamine used for neutralization. Within cosmetic formulas, it is tracked under harsh or irritation-prone surfactants because triisopropanolamine is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Triisopropanolamine performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Consider cleanser contact time and frequency, favor blended mild-surfactant systems, and adjust use if post-wash tightness becomes persistent. Double cleansing or long contact times can amplify irritation even when the formula looks mild.</p><p>How to interpret Triisopropanolamine in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Decyl Glucoside, Coco-Glucoside, or Lauryl Glucoside.</p>",
    "aliases": [],
    "alternatives": [
      "Decyl Glucoside",
      "Coco-Glucoside",
      "Lauryl Glucoside",
      "Arachidyl Glucoside",
      "Heptyl Glucoside",
      "Sodium Stearoyl Glutamate",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3963183857773": "Lift Away contains Decyl Glucoside, which helps cleanse with a milder feel. It’s a good match when you want gentle cleansing without harsher surfactants."
    }
  },
  {
    "chemical": "Trimethylsiloxysilicate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Trimethylsiloxysilicate is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Trimethylsiloxysilicate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Trimethylsiloxysilicate: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triphenyl Phosphate (TPHP)",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Triphenyl Phosphate (TPHP) is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Triphenyl Phosphate (TPHP) performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Triphenyl Phosphate (TPHP) appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triticum Vulgare Germ Oil",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Triticum Vulgare Germ Oil is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Triticum Vulgare Germ Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Triticum Vulgare Germ Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Triticum Vulgare Starch",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Triticum Vulgare Starch is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Triticum Vulgare Starch performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Triticum Vulgare Starch: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Turtle Oil",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Turtle Oil is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Turtle Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Turtle Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Uracil",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Uracil is a pyrimidine compound not used as a standard cosmetic active. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because uracil is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Uracil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Uracil: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Vanillin",
    "category": "Fragrance Allergens & Aroma Chemicals",
    "risk": "high",
    "description": "<p>Vanillin is a fragrance molecule used to build scent character in skincare and personal care formulas. Across many personal-care products, it is tracked under fragrance allergens & aroma chemicals because fragrance allergens are common triggers for redness, itching, and delayed sensitization, especially with chronic leave-on exposure. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Vanillin performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Audit all leave-on products for cumulative fragrance load, simplify to fragrance-free options during irritation cycles, and reintroduce cautiously if tolerated.</p><p>Decision tip for Vanillin: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Aloe Barbadensis Leaf Juice, Allantoin, or Bisabolol.</p>",
    "aliases": [],
    "alternatives": [
      "Aloe Barbadensis Leaf Juice",
      "Allantoin",
      "Bisabolol",
      "Beta-Glucan",
      "Panthenol",
      "Centella Asiatica Extract",
      "Camellia Sinensis (Green Tea) Leaf Extract",
      "Niacinamide"
    ],
    "product_recommendations": {
      "7491831791725": "HydraLuxe Mask contains Allantoin, which helps soothe and comfort skin. It’s a good match when you want soothing care with less fragrance load."
    }
  },
  {
    "chemical": "Vinyl Acetate",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Vinyl Acetate is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Vinyl Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Vinyl Acetate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Vinyl Chloride",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Vinyl Chloride is a substance with significant toxicology concern and strict cosmetic regulation in many markets. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Vinyl Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>When reviewing Vinyl Chloride, use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Isododecane, Isohexadecane, or C15-19 Alkane.</p>",
    "aliases": [
      "vinylchloride",
      "chloroethene"
    ],
    "alternatives": [
      "Isododecane",
      "Isohexadecane",
      "C15-19 Alkane",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Vinyl Dimethicone/Methicone Silsesquioxane Crosspolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Vinyl Dimethicone/Methicone Silsesquioxane Crosspolymer is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Vinyl Dimethicone/Methicone Silsesquioxane Crosspolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Vinyl Dimethicone/Methicone Silsesquioxane Crosspolymer appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "silicones",
      "silicone",
      "silicon",
      "silicons"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "VP-Methacrylamide Copolymer",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>VP-Methacrylamide Copolymer is a vinylpyrrolidone / methacrylamide film-forming polymer. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because VP-methacrylamide is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, VP-Methacrylamide Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret VP-Methacrylamide Copolymer in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "vp methacrylamide",
      "vp methacrylamide copolymer",
      "acrylates",
      "acrylate"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "VP/VA Copolymer",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>VP/VA Copolymer is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, VP/VA Copolymer performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If VP/VA Copolymer appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Wheat Bran Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Wheat Bran Extract is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Wheat Bran Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Wheat Bran Extract: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Wheat Germ Extract",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Wheat Germ Extract is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Wheat Germ Extract performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Wheat Germ Extract appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Wheat Germ Oil",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "medium",
    "description": "<p>Wheat Germ Oil is an emollient or fatty ingredient used to improve slip, softness, and barrier feel. In skincare formulations, it is tracked under comedogenic or fungal-acne triggers because its texture profile can feel too occlusive for some acne-prone users and may be unhelpful for routines focused on fungal-acne control. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>From a skin-health perspective, Wheat Germ Oil performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use.</p><p>Checker guidance for Wheat Germ Oil: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Squalane, C15-19 Alkane, or Coco-Caprylate/Caprate.</p>",
    "aliases": [
      "wheatgermoil"
    ],
    "alternatives": [
      "Squalane",
      "C15-19 Alkane",
      "Coco-Caprylate/Caprate",
      "Dicaprylyl Ether",
      "Diheptyl Succinate",
      "Isododecane",
      "Isohexadecane",
      "Hydrogenated Polyisobutene"
    ],
    "product_recommendations": {
      "4044795183213": "Refresh Eye contains Dicaprylyl Ether, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive emollient feel."
    }
  },
  {
    "chemical": "Whey Protein",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Whey Protein is an ingredient restricted by Osmosis formulation guidelines. When used in topical products, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Whey Protein performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Decision tip for Whey Protein: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Xylene",
    "category": "Drying Alcohols & Irritating Solvents",
    "risk": "high",
    "description": "<p>Xylene is a fast-evaporating solvent used to thin formulas, speed dry-down, or improve ingredient penetration. Within cosmetic formulas, it is tracked under drying alcohols & irritating solvents because frequent exposure can increase tightness, stinging, and transepidermal water loss in dry or sensitized skin. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For day-to-day use, Xylene performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check placement in the ingredient list, reduce frequency if you notice dryness, and pair with barrier-supporting humectants and emollients.</p><p>If Xylene appears in a product you are considering, use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Isododecane, Isohexadecane, or C15-19 Alkane.</p>",
    "aliases": [
      "drying alcohols",
      "drying alcohol",
      "denatured alcohol",
      "denatured alcohols"
    ],
    "alternatives": [
      "Isododecane",
      "Isohexadecane",
      "C15-19 Alkane",
      "Propanediol",
      "Butylene Glycol",
      "Pentylene Glycol",
      "2-Hexanediol",
      "Caprylyl Glycol"
    ],
    "product_recommendations": {
      "4044675776621": "Boost Mist contains Propanediol, which helps hydrate and soften skin. It’s a good match when you want hydration without harsh solvents."
    }
  },
  {
    "chemical": "Yogurt Filtrate",
    "category": "Comedogenic or Fungal-Acne Triggers",
    "risk": "high",
    "description": "<p>Yogurt Filtrate is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under comedogenic or fungal-acne triggers because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Yogurt Filtrate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Focus on leave-on products first, watch for new congestion over two to three weeks, and switch to lighter esters or hydrocarbons if breakouts cluster after use. Compare how the product feels after one week of daily use, and pause if congestion trends upward.</p><p>Checker guidance for Yogurt Filtrate: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Caprylic/Capric Triglyceride, Coco-Caprylate, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Caprylic/Capric Triglyceride",
      "Coco-Caprylate",
      "Squalane",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin",
      "Kaolin"
    ],
    "product_recommendations": {
      "6964372701293": "Therapeutic Body Oil contains Coco-Caprylate, which helps soften and condition skin. It’s a good match when you want a lighter, less occlusive feel."
    }
  },
  {
    "chemical": "Yohimbe",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Yohimbe is a botanical alkaloid source. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because yohimbe is restricted by Osmosis guidelines. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From an ingredient-checking standpoint, Yohimbe performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Decision tip for Yohimbe: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [
      "pausinystalia yohimbe",
      "yohimbine"
    ],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Zea Mays Starch",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "medium",
    "description": "<p>Zea Mays Starch is an ingredient restricted by Osmosis formulation guidelines. In skincare formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Zea Mays Starch performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>If Zea Mays Starch appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Zinc Acetate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Zinc Acetate is a zinc salt used in some astringent / drug-adjacent formulas. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because zinc acetate is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Zinc Acetate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Zinc Acetate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Zinc Chloride",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Zinc Chloride is a zinc salt used in some astringent systems. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because zinc chloride is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Zinc Chloride performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Zinc Chloride in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Zinc Oxide Nano",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Zinc Oxide Nano is an ingredient restricted by Osmosis formulation guidelines. In modern beauty formulations, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>From a skin-health perspective, Zinc Oxide Nano performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>Checker guidance for Zinc Oxide Nano: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Zinc Pyrithione",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "high",
    "description": "<p>Zinc Pyrithione is an ingredient restricted by Osmosis formulation guidelines. Across many personal-care products, it is tracked under prohibited or highly restricted cosmetic toxicants because Osmosis guidelines list this chemistry among ingredients to avoid in formulation recommendations. The current record tags it as high concern, so conservative use or avoidance is often more appropriate.</p><p>For day-to-day use, Zinc Pyrithione performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use. When in doubt, choose formulas that do not rely on this chemistry for their core function.</p><p>When reviewing Zinc Pyrithione: use category risk as a starting signal, then decide with your tolerance history and product type. The alternatives linked here include Kaolin, Boron Nitride, or Squalane.</p>",
    "aliases": [],
    "alternatives": [
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol",
      "Allantoin"
    ],
    "product_recommendations": {
      "6990341439597": "Extract Mask contains Kaolin, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Zinc Sulfate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Zinc Sulfate is a zinc salt used in some treatment formulas. In skincare formulations, it is tracked under metals, dyes & acrylate sensitizers because zinc sulfate is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>In practical routine planning, Zinc Sulfate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>If Zinc Sulfate appears in a product you are considering: use category risk as a starting signal, then decide with your tolerance history and product type. Possible substitutes in this dataset include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [
      "zinc sulphate"
    ],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  },
  {
    "chemical": "Zirconium Complexes",
    "category": "Prohibited or Highly Restricted Cosmetic Toxicants",
    "risk": "severe",
    "description": "<p>Zirconium Complexes is a substance with significant toxicology concern and strict cosmetic regulation in many markets. When used in topical products, it is tracked under prohibited or highly restricted cosmetic toxicants because its risk profile is substantial enough that many frameworks restrict or prohibit routine cosmetic use. The current record tags it as severe concern, so conservative use or avoidance is often more appropriate.</p><p>In practical routine planning, Zirconium Complexes performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Treat this as a high-priority avoid signal, verify regional compliance, and replace with safer purpose-matched ingredients before regular use.</p><p>How to interpret Zirconium Complexes in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. You can often swap toward ingredients such as Silica, Bentonite, or Kaolin.</p>",
    "aliases": [
      "zirconiumcomplexes",
      "zirconium silicate"
    ],
    "alternatives": [
      "Bentonite",
      "Kaolin",
      "Boron Nitride",
      "Squalane",
      "Caprylic/Capric Triglyceride",
      "Propanediol",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Highlighting Quad contains Boron Nitride, which supports a cleaner texture system. It’s a good match when you want performance without restricted fillers."
    }
  },
  {
    "chemical": "Zirconium Silicate",
    "category": "Metals, Dyes & Acrylate Sensitizers",
    "risk": "medium",
    "description": "<p>Zirconium Silicate is a zirconium mineral powder. Within cosmetic formulas, it is tracked under metals, dyes & acrylate sensitizers because zirconium silicate is restricted by Osmosis guidelines. The current record tags it as medium concern, so tolerance and frequency should guide decisions.</p><p>For consumers with reactive skin, Zirconium Silicate performs a specific functional job, yet personal response depends on skin condition, product format, concentration clues, and total routine load. Check cumulative exposure across color cosmetics and skincare, and simplify formulas if sensitization or persistent irritation appears. Pigment-heavy or long-wear products can increase daily load even when each item looks low risk alone.</p><p>How to interpret Zirconium Silicate in this checker: use category risk as a starting signal, then decide with your tolerance history and product type. Comparable options listed by the checker include Iron Oxides (CI 77491), Iron Oxides (CI 77499), or Titanium Dioxide (CI 77891).</p>",
    "aliases": [],
    "alternatives": [
      "Iron Oxides (CI 77491)",
      "Iron Oxides (CI 77499)",
      "Titanium Dioxide (CI 77891)",
      "Synthetic Fluorphlogopite",
      "Kaolin",
      "Boron Nitride",
      "Niacinamide",
      "Panthenol"
    ],
    "product_recommendations": {
      "3965124378733": "Beach Glow Bronzer contains Boron Nitride, which supports clean mineral-style coverage. It’s a good match when you want pigment payoff with a simpler color system."
    }
  }
];

const goodIngredientsConfig = [
  {
    "name": " Acacia Senegal Gum",
    "category": "Thickener/stabilizer",
    "description": "<p>Acacia Senegal Gum is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": [
      "acacia gum",
      "gum arabic"
    ]
  },
  {
    "name": "2-Hexanediol",
    "category": "Humectant/solvent",
    "description": "<p>2-Hexanediol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": [
      "1 2 hexanediol",
      "hexanediol",
      "2 hexanediol"
    ]
  },
  {
    "name": "Acetyl Cysteine",
    "category": "Protein/amino acid",
    "description": "<p>Acetyl Cysteine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": [
      "n acetyl cysteine",
      "nac"
    ]
  },
  {
    "name": "Acetyl Tetrapeptide-5",
    "category": "Peptide",
    "description": "<p>Acetyl Tetrapeptide-5 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "eyeseryl",
      "acetyl tetrapeptide 5"
    ]
  },
  {
    "name": "Acrylates C10-20 Alkyl Acrylate Crosspolymer",
    "category": "Film former/polymer",
    "description": "<p>Acrylates C10-20 Alkyl Acrylate Crosspolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "acrylates c10 20 alkyl acrylate crosspolymer"
    ]
  },
  {
    "name": "Actinidia Chinensis (Kiwi) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Actinidia Chinensis (Kiwi) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "kiwi fruit extract",
      "kiwi extract",
      "kiwi"
    ]
  },
  {
    "name": "Aesculus Hippocastanum Seed Extract",
    "category": "Botanical extract",
    "description": "<p>Aesculus Hippocastanum Seed Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "horse chestnut seed extract",
      "aesculus hippocastanum extract",
      "aesculus hippocastanum seed"
    ]
  },
  {
    "name": "Alanine",
    "category": "Protein/amino acid",
    "description": "<p>Alanine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Alaria Esculenta Extract",
    "category": "Marine/algae extract",
    "description": "<p>Alaria Esculenta Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "alaria esculenta"
    ]
  },
  {
    "name": "Aleurites Moluccanus Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Aleurites Moluccanus Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "kukui nut oil",
      "kukui seed oil"
    ]
  },
  {
    "name": "Algin",
    "category": "Thickener/stabilizer",
    "description": "<p>Algin is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": [
      "alginic acid"
    ]
  },
  {
    "name": "Alginate",
    "category": "Thickener/stabilizer",
    "description": "<p>Alginate is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": [
      "alginic acid salt"
    ]
  },
  {
    "name": "Allantoin",
    "category": "Skin-soothing active",
    "description": "<p>Allantoin is a skin-soothing ingredient used to support comfort and a smoother skin feel.</p><p>In an ingredient checker, it is generally tagged as a calming and barrier-support ingredient.</p>",
    "aliases": [
      "aluminum dihydroxy allantoinate"
    ]
  },
  {
    "name": "Allyl Caproate",
    "category": "Fragrance/aroma compound",
    "description": "<p>Allyl Caproate is an aroma ingredient used to contribute scent or flavor character to a product.</p><p>In an ingredient checker, it should be tagged as aroma-related so users with fragrance sensitivity can review it in context.</p>",
    "aliases": []
  },
  {
    "name": "Aloe Barbadensis Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Aloe Barbadensis Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "aloe barbadensis flower"
    ]
  },
  {
    "name": "Aloe Barbadensis Leaf Juice",
    "category": "Botanical extract",
    "description": "<p>Aloe Barbadensis Leaf Juice is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "aloe vera leaf juice",
      "aloe vera juice",
      "aloe leaf juice"
    ]
  },
  {
    "name": "Aloe Barbadensis Leaf Juice Powder",
    "category": "Botanical extract",
    "description": "<p>Aloe Barbadensis Leaf Juice Powder is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "aloe vera powder",
      "aloe vera leaf juice powder"
    ]
  },
  {
    "name": "Aminobutyric Acid",
    "category": "Protein/amino acid",
    "description": "<p>Aminobutyric Acid is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": [
      "gaba",
      "gamma aminobutyric acid"
    ]
  },
  {
    "name": "Aminomethyl Propanol",
    "category": "pH adjuster/buffer",
    "description": "<p>Aminomethyl Propanol is used to adjust or buffer the pH of a cosmetic formula so it remains stable and performs as intended.</p><p>In an ingredient checker, it is typically grouped as a functional formulation ingredient rather than a direct skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Amorphophallus Konjac Root Powder",
    "category": "Botanical extract",
    "description": "<p>Amorphophallus Konjac Root Powder is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": []
  },
  {
    "name": "AMP-Acrylates/Diacetoneacrylamide Copolymer",
    "category": "Film former/polymer",
    "description": "<p>AMP-Acrylates/Diacetoneacrylamide Copolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "amp acrylates diacetoneacrylamide copolymer"
    ]
  },
  {
    "name": "Anhydroxylitol",
    "category": "Humectant",
    "description": "<p>Anhydroxylitol is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Anthemis Nobilis Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Anthemis Nobilis Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "roman chamomile flower extract",
      "anthemis nobilis flower",
      "chamomile extract"
    ]
  },
  {
    "name": "Anthemis Nobilis Flower Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Anthemis Nobilis Flower Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "roman chamomile oil",
      "chamomile oil"
    ]
  },
  {
    "name": "Arachidyl Alcohol",
    "category": "Fatty alcohol/emollient",
    "description": "<p>Arachidyl Alcohol is a fatty alcohol used as an emollient, thickener, and texture enhancer. Fatty alcohols are different from drying alcohols.</p><p>In an ingredient checker, it is usually treated as a skin-softening and formula-structuring ingredient rather than a drying alcohol.</p>",
    "aliases": []
  },
  {
    "name": "Arachidyl Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Arachidyl Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Arctostaphylos Uva Ursi (Bearberry) Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Arctostaphylos Uva Ursi (Bearberry) Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "bearberry leaf extract",
      "uva ursi leaf extract",
      "bearberry",
      "bearberry extract"
    ]
  },
  {
    "name": "Arginine",
    "category": "Protein/amino acid",
    "description": "<p>Arginine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Arnica Montana Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Arnica Montana Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "arnica montana flower"
    ]
  },
  {
    "name": "Artemisia Umbelliformis Extract",
    "category": "Botanical extract",
    "description": "<p>Artemisia Umbelliformis Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "artemisia umbelliformis"
    ]
  },
  {
    "name": "Ascorbyl Palmitate",
    "category": "Antioxidant/vitamin active",
    "description": "<p>Ascorbyl Palmitate is a vitamin-derived antioxidant active used to support skin conditioning and help protect the formula or skin from oxidation.</p><p>In an ingredient checker, it can be grouped as a vitamin active and antioxidant support ingredient.</p>",
    "aliases": [
      "vitamin c palmitate",
      "ascorbic acid palmitate"
    ]
  },
  {
    "name": "Ascorbyl Phosphate",
    "category": "Antioxidant/vitamin active",
    "description": "<p>Ascorbyl Phosphate is a vitamin-derived antioxidant active used to support skin conditioning and help protect the formula or skin from oxidation.</p><p>In an ingredient checker, it can be grouped as a vitamin active and antioxidant support ingredient.</p>",
    "aliases": [
      "vitamin c phosphate",
      "ascorbic acid phosphate"
    ]
  },
  {
    "name": "Asiatic Acid",
    "category": "Skin-soothing active",
    "description": "<p>Asiatic Acid is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Asiaticoside",
    "category": "Skin-soothing active",
    "description": "<p>Asiaticoside is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Astaxanthin",
    "category": "Antioxidant",
    "description": "<p>Astaxanthin is an antioxidant used to help protect the formula or skin from oxidation and support product freshness.</p><p>In an ingredient checker, it is usually grouped as a supportive active or formula-protection ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Astragalus Membranaceus Root Extract",
    "category": "Botanical extract",
    "description": "<p>Astragalus Membranaceus Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "astragalus membranaceus root"
    ]
  },
  {
    "name": "Astrocaryum Murumuru Seed Butter",
    "category": "Plant oil/butter/wax",
    "description": "<p>Astrocaryum Murumuru Seed Butter is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "murumuru butter",
      "murumuru seed butter"
    ]
  },
  {
    "name": "Avena Sativa Kernel Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Avena Sativa Kernel Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "oat kernel oil",
      "oat oil"
    ]
  },
  {
    "name": "Bambusa Arundinacea Stem Powder",
    "category": "Absorbent/mineral powder",
    "description": "<p>Bambusa Arundinacea Stem Powder is an absorbent mineral powder used to mattify, add opacity, enhance slip, or adjust product texture.</p><p>In an ingredient checker, it is usually grouped as a texture and oil-control support ingredient.</p>",
    "aliases": [
      "bamboo stem powder",
      "bamboo powder"
    ]
  },
  {
    "name": "Bee Pollen Extract",
    "category": "Animal-derived extract",
    "description": "<p>Bee Pollen Extract is an ingredient used for skin-conditioning or nutrient-support positioning in cosmetic formulas.</p><p>In an ingredient checker, it should be tagged for sourcing and reviewed against user preferences such as vegan requirements.</p>",
    "aliases": [
      "bee pollen"
    ]
  },
  {
    "name": "Behenyl Alcohol",
    "category": "Fatty alcohol/emollient",
    "description": "<p>Behenyl Alcohol is a fatty alcohol used as an emollient, thickener, and texture enhancer. Fatty alcohols are different from drying alcohols.</p><p>In an ingredient checker, it is usually treated as a skin-softening and formula-structuring ingredient rather than a drying alcohol.</p>",
    "aliases": []
  },
  {
    "name": "Behenyl Behenate",
    "category": "Emollient",
    "description": "<p>Behenyl Behenate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Bentonite",
    "category": "Absorbent/mineral powder",
    "description": "<p>Bentonite is an absorbent mineral powder used to mattify, add opacity, enhance slip, or adjust product texture.</p><p>In an ingredient checker, it is usually grouped as a texture and oil-control support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Beta Carotene",
    "category": "Colorant/pigment",
    "description": "<p>Beta Carotene is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "beta carotene",
      "provitamin a"
    ]
  },
  {
    "name": "Beta-Glucan",
    "category": "Skin-soothing active",
    "description": "<p>Beta-Glucan is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": [
      "beta glucan",
      "β glucan"
    ]
  },
  {
    "name": "Biotinoyl Tripeptide-1",
    "category": "Peptide",
    "description": "<p>Biotinoyl Tripeptide-1 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "biotinoyl tripeptide 1"
    ]
  },
  {
    "name": "Bisabolol",
    "category": "Skin-soothing active",
    "description": "<p>Bisabolol is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": [
      "alpha bisabolol",
      "α bisabolol"
    ]
  },
  {
    "name": "Bismuth Oxychloride",
    "category": "Colorant/pigment",
    "description": "<p>Bismuth Oxychloride is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": []
  },
  {
    "name": "Blumea Balsamifera Extract",
    "category": "Botanical extract",
    "description": "<p>Blumea Balsamifera Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "blumea balsamifera"
    ]
  },
  {
    "name": "Boron Nitride",
    "category": "Texture enhancer/mineral powder",
    "description": "<p>Boron Nitride is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": []
  },
  {
    "name": "Brachychiton Acerifolius Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Brachychiton Acerifolius Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "brachychiton acerifolius flower"
    ]
  },
  {
    "name": "Bromelain",
    "category": "Enzyme exfoliant",
    "description": "<p>Bromelain is an enzyme ingredient commonly used to help loosen dead surface cells and support smoother-looking skin.</p><p>In an ingredient checker, it should be tagged as an exfoliating active and reviewed for sensitivity, frequency of use, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Butylene Glycol",
    "category": "Humectant/solvent",
    "description": "<p>Butylene Glycol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Butyrospermum Parkii (Shea) Butter",
    "category": "Plant oil/butter/wax",
    "description": "<p>Butyrospermum Parkii (Shea) Butter is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "shea butter",
      "butyrospermum parkii butter",
      "shea",
      "butyrospermum parkii shea butter"
    ]
  },
  {
    "name": "C12-15 Alkyl Benzoate",
    "category": "Emollient",
    "description": "<p>C12-15 Alkyl Benzoate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": [
      "alkyl benzoate",
      "c12 15 alkyl benzoate"
    ]
  },
  {
    "name": "C15-19 Alkane",
    "category": "Emollient",
    "description": "<p>C15-19 Alkane is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": [
      "plant derived alkane",
      "c15 19 alkane emollient",
      "c15 19 alkane"
    ]
  },
  {
    "name": "Caesalpinia Spinosa Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Caesalpinia Spinosa Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "caesalpinia spinosa fruit"
    ]
  },
  {
    "name": "Calendula Officinalis Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Calendula Officinalis Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "calendula officinalis flower"
    ]
  },
  {
    "name": "Calendula Officinalis Flower Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Calendula Officinalis Flower Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": []
  },
  {
    "name": "Camellia Oleifera Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Camellia Oleifera Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "camellia oleifera leaf"
    ]
  },
  {
    "name": "Camellia Sinensis (Green Tea) Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Camellia Sinensis (Green Tea) Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "camellia sinensis leaf extract",
      "green tea leaf extract",
      "green tea extract",
      "camellia sinensis leaf",
      "green tea"
    ]
  },
  {
    "name": "Cannabidiol",
    "category": "Skin-soothing active",
    "description": "<p>Cannabidiol is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": [
      "cbd"
    ]
  },
  {
    "name": "Cannabis Sativa Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Cannabis Sativa Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "hemp seed oil",
      "hemp oil"
    ]
  },
  {
    "name": "Caprooyl Tetrapeptide-3",
    "category": "Peptide",
    "description": "<p>Caprooyl Tetrapeptide-3 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "caprooyl tetrapeptide 3"
    ]
  },
  {
    "name": "Caprylhydroxamic Acid",
    "category": "Preservative",
    "description": "<p>Caprylhydroxamic Acid is a preservative used to help protect a formula from microbial growth and keep the product stable during use.</p><p>In an ingredient checker, it should be grouped as a preservation ingredient and reviewed in context with sensitivity history and formula type.</p>",
    "aliases": [
      "cha"
    ]
  },
  {
    "name": "Caprylic/Capric Triglyceride",
    "category": "Emollient",
    "description": "<p>Caprylic/Capric Triglyceride is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": [
      "caprylic capric triglyceride",
      "mct oil"
    ]
  },
  {
    "name": "Capryloyl Glycerin/Sebacic Acid Copolymer",
    "category": "Film former/polymer",
    "description": "<p>Capryloyl Glycerin/Sebacic Acid Copolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "capryloyl glycerin sebacic acid copolymer"
    ]
  },
  {
    "name": "Capryloyl Glycerin/Sebacic Acid Crosspolymer",
    "category": "Film former/polymer",
    "description": "<p>Capryloyl Glycerin/Sebacic Acid Crosspolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "capryloyl glycerin sebacic acid crosspolymer"
    ]
  },
  {
    "name": "Caprylyl Glycol",
    "category": "Humectant/solvent",
    "description": "<p>Caprylyl Glycol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Carthamus Tinctorius (Safflower) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Carthamus Tinctorius (Safflower) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "safflower seed oil",
      "safflower oil",
      "safflower"
    ]
  },
  {
    "name": "Centella Asiatica Extract",
    "category": "Botanical extract",
    "description": "<p>Centella Asiatica Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "cica extract",
      "gotu kola extract",
      "centella extract",
      "centella asiatica"
    ]
  },
  {
    "name": "Centella Asiatica Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Centella Asiatica Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "cica leaf extract",
      "gotu kola leaf extract",
      "centella leaf extract",
      "centella asiatica leaf"
    ]
  },
  {
    "name": "Cetearyl Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Cetearyl Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Cetearyl Olivate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Cetearyl Olivate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Cetearyl Wheat Straw Glycosides",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Cetearyl Wheat Straw Glycosides helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Cetyl Alcohol",
    "category": "Fatty alcohol/emollient",
    "description": "<p>Cetyl Alcohol is a fatty alcohol used as an emollient, thickener, and texture enhancer. Fatty alcohols are different from drying alcohols.</p><p>In an ingredient checker, it is usually treated as a skin-softening and formula-structuring ingredient rather than a drying alcohol.</p>",
    "aliases": []
  },
  {
    "name": "Cetyl Hydroxyethylcellulose",
    "category": "Thickener/stabilizer",
    "description": "<p>Cetyl Hydroxyethylcellulose is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Cetyl Palmitate",
    "category": "Emollient",
    "description": "<p>Cetyl Palmitate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Chamomilla Recutita (Matricaria) Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Chamomilla Recutita (Matricaria) Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "chamomilla recutita flower extract",
      "german chamomile flower extract",
      "chamomilla recutita flower",
      "matricaria flower extract",
      "matricaria",
      "matricaria extract",
      "chamomile extract"
    ]
  },
  {
    "name": "Charcoal Powder",
    "category": "Absorbent/mineral powder",
    "description": "<p>Charcoal Powder is an absorbent mineral powder used to mattify, add opacity, enhance slip, or adjust product texture.</p><p>In an ingredient checker, it is usually grouped as a texture and oil-control support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Chlorella Vulgaris Extract",
    "category": "Botanical extract",
    "description": "<p>Chlorella Vulgaris Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "chlorella vulgaris"
    ]
  },
  {
    "name": "Cholesteryl Chloride",
    "category": "Lipid/emollient",
    "description": "<p>Cholesteryl Chloride is a lipid-based emollient used to support skin softness, comfort, and barrier feel.</p><p>In an ingredient checker, it can be grouped with nourishing emollients and reviewed based on dryness, oiliness, and product texture needs.</p>",
    "aliases": []
  },
  {
    "name": "Cholesteryl Nonanoate",
    "category": "Lipid/emollient",
    "description": "<p>Cholesteryl Nonanoate is a lipid-based emollient used to support skin softness, comfort, and barrier feel.</p><p>In an ingredient checker, it can be grouped with nourishing emollients and reviewed based on dryness, oiliness, and product texture needs.</p>",
    "aliases": []
  },
  {
    "name": "Cholesteryl Oleyl Carbonate",
    "category": "Lipid/emollient",
    "description": "<p>Cholesteryl Oleyl Carbonate is a lipid-based emollient used to support skin softness, comfort, and barrier feel.</p><p>In an ingredient checker, it can be grouped with nourishing emollients and reviewed based on dryness, oiliness, and product texture needs.</p>",
    "aliases": []
  },
  {
    "name": "Chrysanthemum Parthenium (Feverfew) Extract",
    "category": "Botanical extract",
    "description": "<p>Chrysanthemum Parthenium (Feverfew) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "feverfew extract",
      "feverfew"
    ]
  },
  {
    "name": "CI 77492",
    "category": "Colorant/pigment",
    "description": "<p>CI 77492 is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "iron oxide yellow",
      "yellow iron oxide"
    ]
  },
  {
    "name": "Citrulline",
    "category": "Protein/amino acid",
    "description": "<p>Citrulline is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Citrullus Lanatus (Watermelon) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Citrullus Lanatus (Watermelon) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "watermelon fruit extract",
      "watermelon extract",
      "watermelon"
    ]
  },
  {
    "name": "Citrus Aurantium Dulcis (Orange Zest) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Citrus Aurantium Dulcis (Orange Zest) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "orange zest extract",
      "orange zest",
      "orange zest fruit extract",
      "orange fruit extract"
    ]
  },
  {
    "name": "Citrus Grandis (Grapefruit) Extract",
    "category": "Botanical extract",
    "description": "<p>Citrus Grandis (Grapefruit) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "grapefruit extract",
      "grapefruit"
    ]
  },
  {
    "name": "Citrus Japonica (Kumquat) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Citrus Japonica (Kumquat) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "citrus japonica fruit extract",
      "kumquat fruit extract",
      "kumquat extract",
      "citrus japonica fruit",
      "kumquat"
    ]
  },
  {
    "name": "Citrus Junos Peel Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Citrus Junos Peel Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "yuzu peel oil",
      "yuzu oil"
    ]
  },
  {
    "name": "Citrus Limon (Lemon) Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Citrus Limon (Lemon) Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "citrus medica limonum lemon oil",
      "lemon",
      "lemon oil"
    ]
  },
  {
    "name": "Citrus Limon (Lemon) Peel Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Citrus Limon (Lemon) Peel Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "citrus medica limonum lemon peel oil",
      "lemon peel oil",
      "lemon",
      "lemon oil"
    ]
  },
  {
    "name": "Citrus Paradisi (Grapefruit) Peel Oil",
    "category": "Botanical extract",
    "description": "<p>Citrus Paradisi (Grapefruit) Peel Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "citrus grandis grapefruit peel oil",
      "grapefruit peel oil",
      "grapefruit oil",
      "grapefruit"
    ]
  },
  {
    "name": "Citrus Reticulata Peel Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Citrus Reticulata Peel Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "tangerine peel oil",
      "mandarin peel oil"
    ]
  },
  {
    "name": "Citrus Sinensis (Orange) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Citrus Sinensis (Orange) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "sweet orange extract",
      "orange",
      "orange extract",
      "orange fruit extract"
    ]
  },
  {
    "name": "Coccinia Indica Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Coccinia Indica Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "coccinia indica fruit"
    ]
  },
  {
    "name": "Coco-Caprylate",
    "category": "Emollient",
    "description": "<p>Coco-Caprylate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": [
      "coco caprylate"
    ]
  },
  {
    "name": "Coco-Caprylate/Caprate",
    "category": "Emollient",
    "description": "<p>Coco-Caprylate/Caprate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": [
      "coco caprylate caprate"
    ]
  },
  {
    "name": "Coco-Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Coco-Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "coco glucoside"
    ]
  },
  {
    "name": "Coconut Alkanes",
    "category": "Emollient",
    "description": "<p>Coconut Alkanes is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Coffea Arabica (Coffee) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Coffea Arabica (Coffee) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "coffee seed oil",
      "arabica coffee oil",
      "coffee",
      "coffee oil"
    ]
  },
  {
    "name": "Copernicia Cerifera (Carnauba) Wax",
    "category": "Wax/resin",
    "description": "<p>Copernicia Cerifera (Carnauba) Wax is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": [
      "carnauba wax",
      "carnauba"
    ]
  },
  {
    "name": "Copper Gluconate",
    "category": "Mineral/trace element",
    "description": "<p>Copper Gluconate is a trace mineral ingredient used for skin-conditioning or formula-support benefits.</p><p>In an ingredient checker, it can be grouped as a mineral support ingredient and reviewed in context with the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Corallina Officinalis Extract",
    "category": "Marine/algae extract",
    "description": "<p>Corallina Officinalis Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "corallina officinalis"
    ]
  },
  {
    "name": "Crambe Abyssinica Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Crambe Abyssinica Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Cucumis Sativus (Cucumber) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Cucumis Sativus (Cucumber) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "cucumis sativus cucumber extract",
      "cucumber extract",
      "cucumber",
      "cucumis sativus fruit extract",
      "cucumber fruit extract",
      "cucumis sativus fruit"
    ]
  },
  {
    "name": "Curcuma Longa (Turmeric) Root Extract",
    "category": "Botanical extract",
    "description": "<p>Curcuma Longa (Turmeric) Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "turmeric root extract",
      "turmeric extract",
      "turmeric"
    ]
  },
  {
    "name": "Cyclodextrin",
    "category": "Thickener/stabilizer",
    "description": "<p>Cyclodextrin is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Daucus Carota Sativa (Carrot) Root Extract",
    "category": "Botanical extract",
    "description": "<p>Daucus Carota Sativa (Carrot) Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "carrot root extract",
      "carrot extract",
      "carrot"
    ]
  },
  {
    "name": "Daucus Carota Sativa (Carrot) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Daucus Carota Sativa (Carrot) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "carrot seed oil",
      "carrot oil",
      "carrot"
    ]
  },
  {
    "name": "Decyl Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Decyl Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Dextran",
    "category": "Thickener/stabilizer",
    "description": "<p>Dextran is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Dicaprylyl Ether",
    "category": "Emollient",
    "description": "<p>Dicaprylyl Ether is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Diethylhexyl Carbonate",
    "category": "Emollient",
    "description": "<p>Diethylhexyl Carbonate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Diethylhexyl Syringylidenemalonate",
    "category": "Antioxidant/UV stabilizer",
    "description": "<p>Diethylhexyl Syringylidenemalonate is an antioxidant and UV-stabilizing support ingredient used to help protect formulas from degradation and enhance product performance.</p><p>In an ingredient checker, it is generally grouped as a formula-support antioxidant rather than a sunscreen active.</p>",
    "aliases": []
  },
  {
    "name": "Diheptyl Succinate",
    "category": "Emollient",
    "description": "<p>Diheptyl Succinate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Diisostearyl Malate",
    "category": "Emollient",
    "description": "<p>Diisostearyl Malate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Dimethyl Anthranilate",
    "category": "Fragrance/aroma compound",
    "description": "<p>Dimethyl Anthranilate is an aroma ingredient used to contribute scent or flavor character to a product.</p><p>In an ingredient checker, it should be tagged as aroma-related so users with fragrance sensitivity can review it in context.</p>",
    "aliases": []
  },
  {
    "name": "Dimethyl Sulfone",
    "category": "Skin conditioning active",
    "description": "<p>Dimethyl Sulfone is a skin-conditioning active used to support texture, comfort, hydration, or overall skin appearance.</p><p>In an ingredient checker, it can be grouped as a supportive active and reviewed based on the user’s primary skin goals.</p>",
    "aliases": [
      "msm",
      "methylsulfonylmethane"
    ]
  },
  {
    "name": "Dipalmitoyl Hydroxyproline",
    "category": "Skin conditioning active",
    "description": "<p>Dipalmitoyl Hydroxyproline is a skin-conditioning active used to support texture, comfort, hydration, or overall skin appearance.</p><p>In an ingredient checker, it can be grouped as a supportive active and reviewed based on the user’s primary skin goals.</p>",
    "aliases": []
  },
  {
    "name": "Dipeptide-6",
    "category": "Peptide",
    "description": "<p>Dipeptide-6 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "dipeptide 6"
    ]
  },
  {
    "name": "Dipropylene Glycol",
    "category": "Humectant/solvent",
    "description": "<p>Dipropylene Glycol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Ectoin",
    "category": "Skin-protective active",
    "description": "<p>Ectoin is a skin-protective active used to support resilience, hydration, or environmental defense in a formula.</p><p>In an ingredient checker, it is best grouped as a barrier and protection-support ingredient.</p>",
    "aliases": [
      "ectoine"
    ]
  },
  {
    "name": "Epilobium Angustifolium Flower/Leaf/Stem Extract",
    "category": "Botanical extract",
    "description": "<p>Epilobium Angustifolium Flower/Leaf/Stem Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "epilobium angustifolium flower leaf stem extract",
      "epilobium angustifolium flower leaf stem"
    ]
  },
  {
    "name": "Epiphyllum Oxypetalum Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Epiphyllum Oxypetalum Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "queen of the night flower extract",
      "night blooming cereus extract",
      "epiphyllum oxypetalum flower"
    ]
  },
  {
    "name": "Ergothioneine",
    "category": "Antioxidant",
    "description": "<p>Ergothioneine is an antioxidant used to help protect the formula or skin from oxidation and support product freshness.</p><p>In an ingredient checker, it is usually grouped as a supportive active or formula-protection ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Ethyl Macadamiate",
    "category": "Plant oil/butter/wax",
    "description": "<p>Ethyl Macadamiate is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Ethylhexyl Hydroxystearate",
    "category": "Emollient",
    "description": "<p>Ethylhexyl Hydroxystearate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Ethylhexylglycerin",
    "category": "Preservative booster",
    "description": "<p>Ethylhexylglycerin is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": [
      "ethylhexyl glycerin"
    ]
  },
  {
    "name": "Eucalyptus Radiata Flower/Leaf/Stem Oil",
    "category": "Botanical extract",
    "description": "<p>Eucalyptus Radiata Flower/Leaf/Stem Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "eucalyptus radiata flower leaf stem oil"
    ]
  },
  {
    "name": "Euphorbia Cerifera Cera",
    "category": "Wax/resin",
    "description": "<p>Euphorbia Cerifera Cera is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Fucus Vesiculosus Extract",
    "category": "Marine/algae extract",
    "description": "<p>Fucus Vesiculosus Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "bladderwrack extract",
      "seaweed extract",
      "fucus vesiculosus"
    ]
  },
  {
    "name": "Fulvic Acid",
    "category": "Mineral/organic acid",
    "description": "<p>Fulvic Acid is a mineral salt of an organic acid used for formula support, skin-conditioning, or stability benefits.</p><p>In an ingredient checker, it is generally grouped as a functional and skin-conditioning ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Galactoarabinan",
    "category": "Film former/polysaccharide",
    "description": "<p>Galactoarabinan is a film-forming polysaccharide used to create a smoother feel, support hydration, or enhance product texture on the skin.</p><p>In an ingredient checker, it is generally grouped as a texture and skin-conditioning support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Garcinia Mangostana (Mangosteen) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Garcinia Mangostana (Mangosteen) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "mangosteen fruit extract",
      "mangosteen extract",
      "mangosteen"
    ]
  },
  {
    "name": "Ginkgo Biloba Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Ginkgo Biloba Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "ginkgo biloba leaf"
    ]
  },
  {
    "name": "Gluconic Acid",
    "category": "Exfoliant/acid active",
    "description": "<p>Gluconic Acid is an acid active commonly used for exfoliation, brightening support, or texture refinement depending on concentration and pH.</p><p>In an ingredient checker, it should be tagged as an active ingredient and reviewed for skin sensitivity, frequency of use, and barrier condition.</p>",
    "aliases": []
  },
  {
    "name": "Glucose",
    "category": "Humectant",
    "description": "<p>Glucose is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Glucuronolactone",
    "category": "Skin conditioning active",
    "description": "<p>Glucuronolactone is a skin-conditioning active used to support texture, comfort, hydration, or overall skin appearance.</p><p>In an ingredient checker, it can be grouped as a supportive active and reviewed based on the user’s primary skin goals.</p>",
    "aliases": []
  },
  {
    "name": "Glutamic Acid",
    "category": "Protein/amino acid",
    "description": "<p>Glutamic Acid is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Glyceryl Acrylate/Acrylic Acid Copolymer",
    "category": "Film former/polymer",
    "description": "<p>Glyceryl Acrylate/Acrylic Acid Copolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "glyceryl acrylate acrylic acid copolymer"
    ]
  },
  {
    "name": "Glyceryl Caprylate",
    "category": "Preservative booster",
    "description": "<p>Glyceryl Caprylate is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Glyceryl Ricinoleate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Glyceryl Ricinoleate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Glyceryl Stearate SE",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Glyceryl Stearate SE helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Glyceryl Undecylenate",
    "category": "Preservative booster",
    "description": "<p>Glyceryl Undecylenate is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Glycine",
    "category": "Protein/amino acid",
    "description": "<p>Glycine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Glycol Distearate",
    "category": "Emollient",
    "description": "<p>Glycol Distearate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Glycosaminoglycans",
    "category": "Humectant",
    "description": "<p>Glycosaminoglycans is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Glycosyl Trehalose",
    "category": "Humectant",
    "description": "<p>Glycosyl Trehalose is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Glycyrrhiza Glabra (Licorice) Root Extract",
    "category": "Botanical extract",
    "description": "<p>Glycyrrhiza Glabra (Licorice) Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "licorice root extract",
      "liquorice root extract",
      "licorice",
      "licorice extract"
    ]
  },
  {
    "name": "Hamamelis Virginiana (Witch Hazel) Bark/Leaf/Twig Extract",
    "category": "Botanical extract",
    "description": "<p>Hamamelis Virginiana (Witch Hazel) Bark/Leaf/Twig Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "witch hazel extract",
      "witch hazel bark leaf twig extract",
      "hamamelis virginiana witch hazel bark leaf twig extract",
      "witch hazel"
    ]
  },
  {
    "name": "Hamamelis Virginiana (Witch Hazel) Water",
    "category": "Botanical water/distillate",
    "description": "<p>Hamamelis Virginiana (Witch Hazel) Water is used in cosmetic formulas as a botanical water/distillate ingredient, supporting the product’s texture, performance, or skin feel.</p><p>In an ingredient checker, it should be grouped under Botanical water/distillate and reviewed in the context of the full formula and user profile.</p>",
    "aliases": [
      "witch hazel water",
      "witch hazel distillate",
      "witch hazel"
    ]
  },
  {
    "name": "Helianthus Annuus (Sunflower) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Helianthus Annuus (Sunflower) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "helianthus annuus seed oil",
      "sunflower seed oil",
      "sunflower oil",
      "sunflower"
    ]
  },
  {
    "name": "Helianthus Annuus (Sunflower) Seed Wax",
    "category": "Plant oil/butter/wax",
    "description": "<p>Helianthus Annuus (Sunflower) Seed Wax is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "sunflower seed wax",
      "sunflower wax",
      "sunflower"
    ]
  },
  {
    "name": "Heptyl Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Heptyl Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Hexylene Glycol",
    "category": "Humectant/solvent",
    "description": "<p>Hexylene Glycol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Hibiscus Sabdariffa Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Hibiscus Sabdariffa Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "hibiscus sabdariffa fruit"
    ]
  },
  {
    "name": "Hippophae Rhamnoides (Sea Buckthorn) Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Hippophae Rhamnoides (Sea Buckthorn) Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "hippophae rhamnoides oil",
      "sea buckthorn oil",
      "sea buckthorn"
    ]
  },
  {
    "name": "Hippophae Rhamnoides Extract",
    "category": "Botanical extract",
    "description": "<p>Hippophae Rhamnoides Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "hippophae rhamnoides"
    ]
  },
  {
    "name": "Hippophae Rhamnoides Fruit Oil",
    "category": "Botanical extract",
    "description": "<p>Hippophae Rhamnoides Fruit Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": []
  },
  {
    "name": "Honey",
    "category": "Animal-derived humectant",
    "description": "<p>Honey is a humectant or skin-conditioning ingredient used to support hydration and skin feel.</p><p>In an ingredient checker, it should be tagged for both function and sourcing so users can evaluate it against vegan ingredient preferences.</p>",
    "aliases": []
  },
  {
    "name": "Human Fibroblast Conditioned Media",
    "category": "Biotech/conditioned media",
    "description": "<p>Human Fibroblast Conditioned Media is a biotechnology-derived conditioned media ingredient used in formulas positioned around skin renewal, conditioning, or advanced active support.</p><p>In an ingredient checker, it should be tagged as a specialty biotech ingredient and reviewed for sourcing preferences and user comfort level.</p>",
    "aliases": [
      "fibroblast conditioned media",
      "hfcm"
    ]
  },
  {
    "name": "Human Stem Cell Conditioned Media",
    "category": "Biotech/conditioned media",
    "description": "<p>Human Stem Cell Conditioned Media is a biotechnology-derived conditioned media ingredient used in formulas positioned around skin renewal, conditioning, or advanced active support.</p><p>In an ingredient checker, it should be tagged as a specialty biotech ingredient and reviewed for sourcing preferences and user comfort level.</p>",
    "aliases": [
      "stem cell conditioned media",
      "hscm",
      "exosome",
      "exosomes",
      "stem cell",
      "stem cells"
    ]
  },
  {
    "name": "Hydrogenated Castor Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Hydrogenated Castor Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Hydrogenated Olive Oil Stearyl Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Hydrogenated Olive Oil Stearyl Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Hydrogenated Phosphatidylcholine",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Hydrogenated Phosphatidylcholine helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Hydrogenated Polyisobutene",
    "category": "Emollient",
    "description": "<p>Hydrogenated Polyisobutene is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Hydrogenated Starch Hydrolysate",
    "category": "Humectant",
    "description": "<p>Hydrogenated Starch Hydrolysate is a plant-derived humectant and conditioning agent used to help bind water and enhance skin feel.</p><p>It is not a ferment or postbiotic ingredient, though it is often used alongside hydration-focused formulas.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry or dehydrated routines.</p>",
    "aliases": [
      "hsh"
    ]
  },
  {
    "name": "Hydrogenated Vegetable Glycerides Citrate",
    "category": "Emollient",
    "description": "<p>Hydrogenated Vegetable Glycerides Citrate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Hydrolyzed Adansonia Digitata Extract",
    "category": "Botanical extract",
    "description": "<p>Hydrolyzed Adansonia Digitata Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "hydrolyzed adansonia digitata"
    ]
  },
  {
    "name": "Hydrolyzed Glycosaminoglycans",
    "category": "Humectant",
    "description": "<p>Hydrolyzed Glycosaminoglycans is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Hydrolyzed Jojoba Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Hydrolyzed Jojoba Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Hydrolyzed Myrtus Communis Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Hydrolyzed Myrtus Communis Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "hydrolyzed myrtus communis leaf"
    ]
  },
  {
    "name": "Hydrolyzed Rhizobian Gum",
    "category": "Thickener/stabilizer",
    "description": "<p>Hydrolyzed Rhizobian Gum is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Hydrolyzed Rhodophyceae Extract",
    "category": "Marine/algae extract",
    "description": "<p>Hydrolyzed Rhodophyceae Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "hydrolyzed rhodophyceae"
    ]
  },
  {
    "name": "Hydrolyzed Sodium Hyaluronate",
    "category": "Humectant",
    "description": "<p>Hydrolyzed Sodium Hyaluronate is a hyaluronic-acid-related humectant used to bind water and support a plumper, more hydrated skin feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient.</p>",
    "aliases": [
      "low molecular weight sodium hyaluronate",
      "hydrolyzed ha"
    ]
  },
  {
    "name": "Hydrolyzed Yeast Protein",
    "category": "Protein/amino acid",
    "description": "<p>Hydrolyzed Yeast Protein is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxyacetophenone",
    "category": "Antioxidant/preservative booster",
    "description": "<p>Hydroxyacetophenone can support antioxidant protection and also help enhance preservation or formula stability.</p><p>In an ingredient checker, it is useful to group this under formula-protection ingredients.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxyethyl Acrylates/Sodium Acryloyldimethyl Taurate Copolymer",
    "category": "Film former/polymer",
    "description": "<p>Hydroxyethyl Acrylates/Sodium Acryloyldimethyl Taurate Copolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "hydroxyethyl acrylates sodium acryloyldimethyl taurate copolymer"
    ]
  },
  {
    "name": "Hydroxyethylcellulose",
    "category": "Thickener/stabilizer",
    "description": "<p>Hydroxyethylcellulose is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxyproline",
    "category": "Protein/amino acid",
    "description": "<p>Hydroxyproline is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxypropyl Cyclodextrin",
    "category": "Thickener/stabilizer",
    "description": "<p>Hydroxypropyl Cyclodextrin is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxypropyl Guar",
    "category": "Thickener/stabilizer",
    "description": "<p>Hydroxypropyl Guar is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Hydroxypropyl Starch Phosphate",
    "category": "Thickener/stabilizer",
    "description": "<p>Hydroxypropyl Starch Phosphate is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Iron Oxides (CI 77491)",
    "category": "Colorant/pigment",
    "description": "<p>Iron Oxides (CI 77491) is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "ci 77491",
      "red iron oxide",
      "iron oxides"
    ]
  },
  {
    "name": "Iron Oxides (CI 77499)",
    "category": "Colorant/pigment",
    "description": "<p>Iron Oxides (CI 77499) is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "ci 77499",
      "black iron oxide",
      "iron oxides"
    ]
  },
  {
    "name": "Isodecyl Neopentanoate",
    "category": "Emollient",
    "description": "<p>Isodecyl Neopentanoate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Isododecane",
    "category": "Emollient/solvent",
    "description": "<p>Isododecane works as an emollient solvent, helping dissolve oil-soluble ingredients while giving the skin a smoother, lighter feel.</p><p>In an ingredient checker, it can be grouped as a texture and delivery ingredient rather than a treatment active.</p>",
    "aliases": []
  },
  {
    "name": "Isohexadecane",
    "category": "Emollient/solvent",
    "description": "<p>Isohexadecane works as an emollient solvent, helping dissolve oil-soluble ingredients while giving the skin a smoother, lighter feel.</p><p>In an ingredient checker, it can be grouped as a texture and delivery ingredient rather than a treatment active.</p>",
    "aliases": []
  },
  {
    "name": "Isononyl Isononanoate",
    "category": "Emollient",
    "description": "<p>Isononyl Isononanoate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Jojoba Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Jojoba Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Kaolin",
    "category": "Absorbent/mineral powder",
    "description": "<p>Kaolin is an absorbent mineral powder used to mattify, add opacity, enhance slip, or adjust product texture.</p><p>In an ingredient checker, it is usually grouped as a texture and oil-control support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Kappaphycus Alvarezii Extract",
    "category": "Marine/algae extract",
    "description": "<p>Kappaphycus Alvarezii Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "kappaphycus alvarezii"
    ]
  },
  {
    "name": "Ketoglutaric Acid",
    "category": "Skin conditioning acid",
    "description": "<p>Ketoglutaric Acid is an organic acid used for skin-conditioning, formula support, or pH-related performance depending on the product.</p><p>In an ingredient checker, it should be reviewed in context with product type and concentration.</p>",
    "aliases": []
  },
  {
    "name": "Lactococcus Ferment Lysate",
    "category": "Ferment/biotech ingredient",
    "description": "<p>Lactococcus Ferment Lysate is a ferment or biotechnology-derived ingredient used for skin-conditioning, hydration support, or formula performance.</p><p>In an ingredient checker, it can be grouped as a biotech or postbiotic-style ingredient and reviewed in context with sensitivity and product format.</p>",
    "aliases": []
  },
  {
    "name": "Laminaria Digitata Extract",
    "category": "Marine/algae extract",
    "description": "<p>Laminaria Digitata Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "laminaria digitata"
    ]
  },
  {
    "name": "Lauroyl Lysine",
    "category": "Texture enhancer/amino acid derivative",
    "description": "<p>Lauroyl Lysine is an amino-acid-derived texture ingredient used to enhance slip, softness, adhesion, or product feel.</p><p>In an ingredient checker, it is generally grouped as a sensory and formula-performance ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Lauryl Glucoside",
    "category": "Surfactant/cleanser",
    "description": "<p>Lauryl Glucoside is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Lauryl Laurate",
    "category": "Emollient",
    "description": "<p>Lauryl Laurate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Lavandula Angustifolia (Lavender) Extract",
    "category": "Botanical extract",
    "description": "<p>Lavandula Angustifolia (Lavender) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "lavender extract",
      "lavender"
    ]
  },
  {
    "name": "Lavandula Angustifolia (Lavender) Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Lavandula Angustifolia (Lavender) Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "lavandula officinalis flower oil",
      "lavender flower oil",
      "lavender oil",
      "lavender"
    ]
  },
  {
    "name": "Lawsonia Inermis (Henna) Extract",
    "category": "Botanical extract",
    "description": "<p>Lawsonia Inermis (Henna) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "henna extract",
      "henna"
    ]
  },
  {
    "name": "Lens Esculenta (Lentil) Seed Extract",
    "category": "Botanical extract",
    "description": "<p>Lens Esculenta (Lentil) Seed Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "lentil",
      "lentil seed extract",
      "lentil extract"
    ]
  },
  {
    "name": "Leuconostoc/Radish Root Ferment Filtrate",
    "category": "Ferment/biotech ingredient",
    "description": "<p>Leuconostoc/Radish Root Ferment Filtrate is a ferment or biotechnology-derived ingredient used for skin-conditioning, hydration support, or formula performance.</p><p>In an ingredient checker, it can be grouped as a biotech or postbiotic-style ingredient and reviewed in context with sensitivity and product format.</p>",
    "aliases": [
      "leuconostoc radish ferment filtrate",
      "radish ferment filtrate",
      "leuconostoc ferment filtrate",
      "radish root ferment filtrate",
      "leuconostoc radish root ferment filtrate"
    ]
  },
  {
    "name": "Levulinic Acid",
    "category": "Preservative booster",
    "description": "<p>Levulinic Acid is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Limnanthes Alba (Meadowfoam) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Limnanthes Alba (Meadowfoam) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "meadowfoam seed oil",
      "meadowfoam oil",
      "meadowfoam"
    ]
  },
  {
    "name": "Linum Usitatissimum Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Linum Usitatissimum Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Litsea Cubeba Fruit Oil",
    "category": "Botanical extract",
    "description": "<p>Litsea Cubeba Fruit Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": []
  },
  {
    "name": "Lonicera Caprifolium (Honeysuckle) Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Lonicera Caprifolium (Honeysuckle) Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "lonicera caprifolium honeysuckle extract",
      "honeysuckle",
      "honeysuckle extract",
      "honeysuckle flower extract"
    ]
  },
  {
    "name": "Lonicera Japonica (Honeysuckle) Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Lonicera Japonica (Honeysuckle) Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "lonicera japonica honeysuckle extract",
      "japanese honeysuckle extract",
      "japanese honeysuckle flower extract",
      "honeysuckle",
      "honeysuckle extract",
      "honeysuckle flower extract"
    ]
  },
  {
    "name": "Lycium Barbarum Fruit Powder",
    "category": "Botanical extract",
    "description": "<p>Lycium Barbarum Fruit Powder is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "goji fruit powder",
      "wolfberry fruit powder"
    ]
  },
  {
    "name": "Lysine",
    "category": "Protein/amino acid",
    "description": "<p>Lysine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Lysine HCl",
    "category": "Protein/amino acid",
    "description": "<p>Lysine HCl is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": [
      "l lysine hcl",
      "lysine hydrochloride"
    ]
  },
  {
    "name": "Macadamia Ternifolia Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Macadamia Ternifolia Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "macadamia seed oil",
      "macadamia oil"
    ]
  },
  {
    "name": "Macrocystis Pyrifera (Kelp) Extract",
    "category": "Marine/algae extract",
    "description": "<p>Macrocystis Pyrifera (Kelp) Extract is a marine or algae-derived ingredient commonly used for skin-conditioning, hydration support, or antioxidant benefits.</p><p>In an ingredient checker, it can be grouped as a marine botanical extract and usually needs context from the full formula rather than being judged alone.</p>",
    "aliases": [
      "kelp extract",
      "giant kelp extract",
      "kelp"
    ]
  },
  {
    "name": "Madecassic Acid",
    "category": "Skin-soothing active",
    "description": "<p>Madecassic Acid is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Madecassoside",
    "category": "Skin-soothing active",
    "description": "<p>Madecassoside is a skin-soothing or comfort-support ingredient used to help calm the look and feel of skin.</p><p>In an ingredient checker, it is generally useful for sensitive, dry, or barrier-focused routines depending on the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Magnesium Chloride",
    "category": "Mineral/salt",
    "description": "<p>Magnesium Chloride is a mineral salt used to support texture, viscosity, pH balance, or formula performance.</p><p>In an ingredient checker, it is generally treated as a functional formulation ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Malachite Extract",
    "category": "Botanical extract",
    "description": "<p>Malachite Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "malachite"
    ]
  },
  {
    "name": "Maltodextrin",
    "category": "Binder/stabilizer",
    "description": "<p>Maltodextrin helps bind, stabilize, or enhance the physical structure of a formula.</p><p>In an ingredient checker, it is generally treated as a functional texture ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Mangifera Indica (Mango) Juice",
    "category": "Botanical extract",
    "description": "<p>Mangifera Indica (Mango) Juice is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "mango juice",
      "mango"
    ]
  },
  {
    "name": "Mangifera Indica Fruit",
    "category": "Botanical extract",
    "description": "<p>Mangifera Indica Fruit is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "mango fruit"
    ]
  },
  {
    "name": "Mangifera Indica Seed Butter",
    "category": "Plant oil/butter/wax",
    "description": "<p>Mangifera Indica Seed Butter is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "mango seed butter",
      "mango butter"
    ]
  },
  {
    "name": "Melia Azadirachta (Neem) Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Melia Azadirachta (Neem) Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "neem flower extract",
      "neem",
      "neem extract"
    ]
  },
  {
    "name": "Melia Azadirachta (Neem) Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Melia Azadirachta (Neem) Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "neem leaf extract",
      "neem",
      "neem extract"
    ]
  },
  {
    "name": "Menthyl Ethylamido Oxalate",
    "category": "Cooling sensory agent",
    "description": "<p>Menthyl Ethylamido Oxalate is a sensory ingredient used to create a cooling or refreshing feel on the skin.</p><p>In an ingredient checker, it can be grouped as a sensorial ingredient and reviewed for sensitivity or comfort preferences.</p>",
    "aliases": []
  },
  {
    "name": "Methyl Undecenoyl Leucinate",
    "category": "Skin conditioning active",
    "description": "<p>Methyl Undecenoyl Leucinate is a skin-conditioning active used to support texture, comfort, hydration, or overall skin appearance.</p><p>In an ingredient checker, it can be grouped as a supportive active and reviewed based on the user’s primary skin goals.</p>",
    "aliases": []
  },
  {
    "name": "Micrococcus Lysate",
    "category": "Ferment/biotech ingredient",
    "description": "<p>Micrococcus Lysate is a ferment or biotechnology-derived ingredient used for skin-conditioning, hydration support, or formula performance.</p><p>In an ingredient checker, it can be grouped as a biotech or postbiotic-style ingredient and reviewed in context with sensitivity and product format.</p>",
    "aliases": []
  },
  {
    "name": "Myrtus Communis Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Myrtus Communis Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "myrtus communis leaf"
    ]
  },
  {
    "name": "Niacinamide",
    "category": "Vitamin/skin active",
    "description": "<p>Niacinamide is a vitamin B3 active used to support the appearance of even tone, barrier comfort, and balanced-looking skin.</p><p>In an ingredient checker, it is usually tagged as a versatile skin active for tone, barrier, and oil-balance goals.</p>",
    "aliases": [
      "vitamin b3",
      "nicotinamide"
    ]
  },
  {
    "name": "Nonapeptide-1",
    "category": "Peptide",
    "description": "<p>Nonapeptide-1 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "nonapeptide 1"
    ]
  },
  {
    "name": "Ocimum Basilicum (Basil) Flower/Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Ocimum Basilicum (Basil) Flower/Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "ocimum basilicum basil leaf extract",
      "basil",
      "basil leaf extract",
      "basil extract",
      "basil flower leaf extract",
      "ocimum basilicum basil flower leaf extract"
    ]
  },
  {
    "name": "Ocimum Sanctum Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Ocimum Sanctum Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "ocimum sanctum leaf"
    ]
  },
  {
    "name": "Octyldodecanol",
    "category": "Emollient",
    "description": "<p>Octyldodecanol is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Octyldodecyl Stearoyl Stearate",
    "category": "Emollient",
    "description": "<p>Octyldodecyl Stearoyl Stearate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Olea Europaea (Olive) Fruit Oil",
    "category": "Botanical extract",
    "description": "<p>Olea Europaea (Olive) Fruit Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "olea europaea fruit oil",
      "olive fruit oil",
      "olive",
      "olive oil"
    ]
  },
  {
    "name": "Olea Europaea (Olive) Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Olea Europaea (Olive) Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "olive leaf extract",
      "olive extract",
      "olive"
    ]
  },
  {
    "name": "Olea Europaea (Olive) Oil Unsaponifiables",
    "category": "Plant oil/butter/wax",
    "description": "<p>Olea Europaea (Olive) Oil Unsaponifiables is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "olive oil unsaponifiables",
      "olive",
      "olive oil"
    ]
  },
  {
    "name": "Olive Oil Glycereth-8 Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Olive Oil Glycereth-8 Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "olive oil glycereth 8 esters"
    ]
  },
  {
    "name": "Orbignya Oleifera Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Orbignya Oleifera Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "babassu seed oil",
      "babassu oil"
    ]
  },
  {
    "name": "Oryza Sativa (Rice) Bran Wax",
    "category": "Plant oil/butter/wax",
    "description": "<p>Oryza Sativa (Rice) Bran Wax is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "rice bran wax",
      "rice"
    ]
  },
  {
    "name": "Ozonized Ethyl Oleate",
    "category": "Emollient",
    "description": "<p>Ozonized Ethyl Oleate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Palmitic Acid",
    "category": "Fatty acid/emollient",
    "description": "<p>Palmitic Acid is a fatty acid used to support emollience, texture, and formula structure.</p><p>In an ingredient checker, it is usually grouped as a lipid or texture-support ingredient and reviewed in relation to skin type and product format.</p>",
    "aliases": []
  },
  {
    "name": "Palmitoyl Hexapeptide-12",
    "category": "Peptide",
    "description": "<p>Palmitoyl Hexapeptide-12 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "palmitoyl hexapeptide 12"
    ]
  },
  {
    "name": "Palmitoyl Tripeptide-1",
    "category": "Peptide",
    "description": "<p>Palmitoyl Tripeptide-1 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "pal ghk",
      "palmitoyl tripeptide 1"
    ]
  },
  {
    "name": "Palmitoyl Tripeptide-38",
    "category": "Peptide",
    "description": "<p>Palmitoyl Tripeptide-38 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "palmitoyl tripeptide 38"
    ]
  },
  {
    "name": "Palmitoyl Tripeptide-5",
    "category": "Peptide",
    "description": "<p>Palmitoyl Tripeptide-5 is a peptide ingredient used in skincare for targeted skin-conditioning benefits such as firmness, smoothness, or visible skin support.</p><p>In an ingredient checker, it should be tagged as a peptide active and reviewed based on the product’s claims and routine goals.</p>",
    "aliases": [
      "palmitoyl tripeptide 5"
    ]
  },
  {
    "name": "Panthenol",
    "category": "Vitamin/skin active",
    "description": "<p>Panthenol, also known as provitamin B5, is a humectant and skin-conditioning ingredient used to support hydration and comfort.</p><p>In an ingredient checker, it is commonly grouped as a soothing and barrier-support ingredient.</p>",
    "aliases": [
      "pro vitamin b5",
      "dexpanthenol"
    ]
  },
  {
    "name": "Papain",
    "category": "Enzyme exfoliant",
    "description": "<p>Papain is an enzyme ingredient commonly used to help loosen dead surface cells and support smoother-looking skin.</p><p>In an ingredient checker, it should be tagged as an exfoliating active and reviewed for sensitivity, frequency of use, and product format.</p>",
    "aliases": [
      "papaya enzyme"
    ]
  },
  {
    "name": "Pentaerythrityl Tetraisostearate",
    "category": "Emollient",
    "description": "<p>Pentaerythrityl Tetraisostearate is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Pentylene Glycol",
    "category": "Humectant/solvent",
    "description": "<p>Pentylene Glycol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Persea Gratissima (Avocado) Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Persea Gratissima (Avocado) Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "persea gratissima oil",
      "avocado oil",
      "avocado"
    ]
  },
  {
    "name": "Peumus Boldus Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Peumus Boldus Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "peumus boldus leaf"
    ]
  },
  {
    "name": "Phenylethyl Resorcinol",
    "category": "Brightening antioxidant",
    "description": "<p>Phenylethyl Resorcinol is an antioxidant ingredient often used to support brighter-looking, more even-toned skin.</p><p>In an ingredient checker, it can be grouped under antioxidant and tone-support actives.</p>",
    "aliases": []
  },
  {
    "name": "Phenylpropanol",
    "category": "Preservative booster/fragrance",
    "description": "<p>Phenylpropanol can function as a preservative booster and may also contribute to scent or formula aesthetics.</p><p>In an ingredient checker, it should be tagged for both preservation support and aroma-related function when relevant.</p>",
    "aliases": []
  },
  {
    "name": "Phosphatidylcholine",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Phosphatidylcholine is a lipid-based ingredient used to support skin feel, ingredient delivery, and formula stability.</p><p>In an ingredient checker, it can be grouped as a barrier-feel and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Phospholipids",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Phospholipids is a lipid-based ingredient used to support skin feel, ingredient delivery, and formula stability.</p><p>In an ingredient checker, it can be grouped as a barrier-feel and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Plankton Extract",
    "category": "Marine/biotech extract",
    "description": "<p>Plankton Extract is a marine-derived or biotechnology-derived skin-conditioning ingredient used to support hydration, texture, or overall formula performance.</p><p>In an ingredient checker, it is generally grouped as a specialty active or conditioning ingredient and reviewed alongside the full product formula.</p>",
    "aliases": [
      "plankton"
    ]
  },
  {
    "name": "Pogostemon Cablin (Patchouli) Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Pogostemon Cablin (Patchouli) Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "patchouli",
      "patchouli oil"
    ]
  },
  {
    "name": "Polyacrylate Crosspolymer-6",
    "category": "Film former/polymer",
    "description": "<p>Polyacrylate Crosspolymer-6 is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "polyacrylate crosspolymer 6"
    ]
  },
  {
    "name": "Polybutene",
    "category": "Film former/polymer",
    "description": "<p>Polybutene is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": []
  },
  {
    "name": "Polyglutamic Acid",
    "category": "Humectant",
    "description": "<p>Polyglutamic Acid is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": []
  },
  {
    "name": "Polyglyceryl-4 Caprate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Polyglyceryl-4 Caprate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": [
      "polyglyceryl 4 caprate"
    ]
  },
  {
    "name": "Polygonum Cuspidatum Extract",
    "category": "Botanical extract",
    "description": "<p>Polygonum Cuspidatum Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "polygonum cuspidatum"
    ]
  },
  {
    "name": "Polygonum Cuspidatum Root Extract",
    "category": "Botanical extract",
    "description": "<p>Polygonum Cuspidatum Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "polygonum cuspidatum root"
    ]
  },
  {
    "name": "Potassium Cetyl Phosphate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Potassium Cetyl Phosphate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "PPG-17/IPDI/DMPA Copolymer",
    "category": "Film former/polymer",
    "description": "<p>PPG-17/IPDI/DMPA Copolymer is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": [
      "ppg 17 ipdi dmpa copolymer"
    ]
  },
  {
    "name": "Proline",
    "category": "Protein/amino acid",
    "description": "<p>Proline is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Propanediol",
    "category": "Humectant/solvent",
    "description": "<p>Propanediol functions as both a humectant and solvent, helping bind water while also enhancing ingredient dispersion and formula stability.</p><p>In an ingredient checker, it can be grouped as a hydration and formulation-support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Prunus Amygdalus Amara (Bitter Almond) Kernel Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Prunus Amygdalus Amara (Bitter Almond) Kernel Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "bitter almond oil",
      "bitter almond",
      "bitter almond kernel oil"
    ]
  },
  {
    "name": "Prunus Amygdalus Dulcis (Sweet Almond) Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Prunus Amygdalus Dulcis (Sweet Almond) Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "prunus amygdalus dulcis oil",
      "sweet almond oil",
      "almond oil",
      "sweet almond"
    ]
  },
  {
    "name": "Prunus Armeniaca (Apricot) Kernel Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Prunus Armeniaca (Apricot) Kernel Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "prunus armeniaca kernel oil",
      "apricot kernel oil",
      "apricot",
      "apricot oil"
    ]
  },
  {
    "name": "Prunus Avium (Sweet Cherry) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Prunus Avium (Sweet Cherry) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "sweet cherry fruit extract",
      "cherry fruit extract",
      "sweet cherry",
      "sweet cherry extract"
    ]
  },
  {
    "name": "Prunus Cerasus (Bitter Cherry) Extract",
    "category": "Botanical extract",
    "description": "<p>Prunus Cerasus (Bitter Cherry) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "bitter cherry",
      "bitter cherry extract"
    ]
  },
  {
    "name": "Prunus Serotina (Wild Cherry) Bark Extract",
    "category": "Botanical extract",
    "description": "<p>Prunus Serotina (Wild Cherry) Bark Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "wild cherry",
      "wild cherry bark extract",
      "wild cherry extract"
    ]
  },
  {
    "name": "Pseudoalteromonas Ferment Extract",
    "category": "Ferment/biotech ingredient",
    "description": "<p>Pseudoalteromonas Ferment Extract is a ferment or biotechnology-derived ingredient used for skin-conditioning, hydration support, or formula performance.</p><p>In an ingredient checker, it can be grouped as a biotech or postbiotic-style ingredient and reviewed in context with sensitivity and product format.</p>",
    "aliases": [
      "pseudoalteromonas ferment"
    ]
  },
  {
    "name": "Psidium Guajava Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Psidium Guajava Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "psidium guajava fruit"
    ]
  },
  {
    "name": "Pullulan",
    "category": "Film former/polymer",
    "description": "<p>Pullulan is a film-forming polymer used to enhance wear, texture, adhesion, or the smooth finish of a product on skin.</p><p>In an ingredient checker, it can be grouped as a texture and performance ingredient rather than a direct skin active.</p>",
    "aliases": []
  },
  {
    "name": "Pyridoxine HCl",
    "category": "Vitamin/skin active",
    "description": "<p>Pyridoxine HCl is a vitamin or vitamin-related skin active used to support skin tone, barrier feel, hydration, or overall skin-conditioning benefits.</p><p>In an ingredient checker, it should be tagged as an active ingredient and evaluated based on the user’s skin goals and formula strength.</p>",
    "aliases": []
  },
  {
    "name": "Pyrus Malus (Apple) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Pyrus Malus (Apple) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "apple fruit extract",
      "apple extract",
      "apple"
    ]
  },
  {
    "name": "Retinaldehyde",
    "category": "Retinoid active",
    "description": "<p>Retinaldehyde is Osmosis's vitamin A active used for gentle cell renewal, texture support, and visible signs of aging with less irritation than many conventional retinoids.</p><p>In an ingredient checker, it is the preferred Osmosis alternative when shoppers are avoiding retinol, retinoic acid, or other retinoid actives.</p>",
    "aliases": [
      "retinal",
      "vitamin a aldehyde"
    ]
  },
  {
    "name": "Rhus Verniciflua Peel Wax",
    "category": "Wax/resin",
    "description": "<p>Rhus Verniciflua Peel Wax is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Rice Oil Glycereth-8 Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Rice Oil Glycereth-8 Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "rice oil glycereth 8 esters"
    ]
  },
  {
    "name": "Ricinus Communis (Castor) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Ricinus Communis (Castor) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "ricinus communis seed oil",
      "castor seed oil",
      "castor oil",
      "castor"
    ]
  },
  {
    "name": "Rosa Canina Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Rosa Canina Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "rosehip seed oil",
      "rosehip oil"
    ]
  },
  {
    "name": "Rosa Centifolia Flower Wax",
    "category": "Wax/resin",
    "description": "<p>Rosa Centifolia Flower Wax is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Rosa Damascena Flower Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Rosa Damascena Flower Oil is an aromatic botanical oil or fragrance-related ingredient used to add scent and may also contribute botanical positioning.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "damask rose flower oil",
      "rose oil"
    ]
  },
  {
    "name": "Rosa Damascena Flower Wax",
    "category": "Wax/resin",
    "description": "<p>Rosa Damascena Flower Wax is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Rosmarinus Officinalis (Rosemary) Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Rosmarinus Officinalis (Rosemary) Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "rosemary leaf extract",
      "rosemary extract",
      "rosemary"
    ]
  },
  {
    "name": "Rubus Arcticus Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Rubus Arcticus Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "rubus arcticus fruit"
    ]
  },
  {
    "name": "Rubus Chamaemorus (Cloud Berry) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Rubus Chamaemorus (Cloud Berry) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "rubus chamaemorus seed oil",
      "cloudberry seed oil",
      "cloud berry",
      "cloud berry seed oil",
      "cloud berry oil"
    ]
  },
  {
    "name": "Rubus Chamaemorus Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Rubus Chamaemorus Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "rubus chamaemorus fruit"
    ]
  },
  {
    "name": "Rubus Fruticosus (Blackberry) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Rubus Fruticosus (Blackberry) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "blackberry",
      "blackberry seed oil",
      "blackberry oil"
    ]
  },
  {
    "name": "Rubus Idaeus (Raspberry) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Rubus Idaeus (Raspberry) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "rubus idaeus seed oil",
      "raspberry seed oil",
      "raspberry",
      "raspberry oil"
    ]
  },
  {
    "name": "Rumex Occidentalis Extract",
    "category": "Botanical extract",
    "description": "<p>Rumex Occidentalis Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "rumex occidentalis"
    ]
  },
  {
    "name": "Ruscus Aculeatus Root Extract",
    "category": "Botanical extract",
    "description": "<p>Ruscus Aculeatus Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "ruscus aculeatus root"
    ]
  },
  {
    "name": "Saccharide Isomerate",
    "category": "Humectant",
    "description": "<p>Saccharide Isomerate is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": [
      "pentavitin"
    ]
  },
  {
    "name": "Salvia Hispanica Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Salvia Hispanica Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "chia seed oil"
    ]
  },
  {
    "name": "Sambucus Nigra (Elderberry) Fruit Juice",
    "category": "Botanical extract",
    "description": "<p>Sambucus Nigra (Elderberry) Fruit Juice is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "elderberry fruit juice",
      "elderberry juice",
      "elderberry"
    ]
  },
  {
    "name": "Sambucus Nigra Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Sambucus Nigra Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "sambucus nigra flower"
    ]
  },
  {
    "name": "Sambucus Nigra Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Sambucus Nigra Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "sambucus nigra fruit"
    ]
  },
  {
    "name": "Sambucus Nigra Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Sambucus Nigra Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "elderberry seed oil"
    ]
  },
  {
    "name": "Schisandra Chinensis Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Schisandra Chinensis Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "schisandra chinensis fruit"
    ]
  },
  {
    "name": "Sclerotium Gum",
    "category": "Thickener/stabilizer",
    "description": "<p>Sclerotium Gum is used to thicken, stabilize, or enhance the texture of a skincare formula.</p><p>In an ingredient checker, it is usually grouped as a texture and stability ingredient with low relevance unless a user has a specific sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Scutellaria Baicalensis Root Extract",
    "category": "Botanical extract",
    "description": "<p>Scutellaria Baicalensis Root Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "scutellaria baicalensis root"
    ]
  },
  {
    "name": "Sea Water",
    "category": "Mineral/salt",
    "description": "<p>Sea Water is a mineral salt used to support texture, viscosity, pH balance, or formula performance.</p><p>In an ingredient checker, it is generally treated as a functional formulation ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Serine",
    "category": "Protein/amino acid",
    "description": "<p>Serine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Shorea Robusta Resin",
    "category": "Wax/resin",
    "description": "<p>Shorea Robusta Resin is a wax or resin ingredient used to add structure, richness, water resistance, or a protective feel to skincare and cosmetic formulas.</p><p>In an ingredient checker, it is usually grouped under texture-building emollients and reviewed for heaviness, occlusiveness, and product format.</p>",
    "aliases": []
  },
  {
    "name": "Simmondsia Chinensis (Jojoba) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Simmondsia Chinensis (Jojoba) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "simmondsia chinensis seed oil",
      "jojoba seed oil",
      "jojoba oil",
      "jojoba"
    ]
  },
  {
    "name": "Sodium Acetylated Hyaluronate",
    "category": "Humectant",
    "description": "<p>Sodium Acetylated Hyaluronate is a hyaluronic-acid-related humectant used to bind water and support a plumper, more hydrated skin feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient.</p>",
    "aliases": [
      "acetylated hyaluronate sodium salt"
    ]
  },
  {
    "name": "Sodium Bicarbonate",
    "category": "pH adjuster/buffer",
    "description": "<p>Sodium Bicarbonate is used to adjust or buffer the pH of a cosmetic formula so it remains stable and performs as intended.</p><p>In an ingredient checker, it is typically grouped as a functional formulation ingredient rather than a direct skincare active.</p>",
    "aliases": [
      "bicarbonate sodium salt"
    ]
  },
  {
    "name": "Sodium Carboxymethyl Beta-Glucan",
    "category": "Humectant/skin-soothing active",
    "description": "<p>Sodium Carboxymethyl Beta-Glucan is a hydration-support ingredient that may also help enhance skin comfort and a smoother-feeling barrier.</p><p>In an ingredient checker, it can be grouped as both a humectant and skin-conditioning active.</p>",
    "aliases": [
      "sodium carboxymethyl beta glucan",
      "carboxymethyl beta glucan sodium salt"
    ]
  },
  {
    "name": "Sodium Chloride",
    "category": "Mineral/salt",
    "description": "<p>Sodium Chloride is a mineral salt used to support texture, viscosity, pH balance, or formula performance.</p><p>In an ingredient checker, it is generally treated as a functional formulation ingredient.</p>",
    "aliases": [
      "chloride sodium salt"
    ]
  },
  {
    "name": "Sodium Citrate",
    "category": "pH adjuster/buffer",
    "description": "<p>Sodium Citrate is used to adjust or buffer the pH of a cosmetic formula so it remains stable and performs as intended.</p><p>In an ingredient checker, it is typically grouped as a functional formulation ingredient rather than a direct skincare active.</p>",
    "aliases": [
      "citrate sodium salt"
    ]
  },
  {
    "name": "Sodium Coco-Glucoside Tartrate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Coco-Glucoside Tartrate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "sodium coco glucoside tartrate",
      "coco glucoside tartrate sodium salt"
    ]
  },
  {
    "name": "Sodium Cocoamphoacetate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Cocoamphoacetate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "cocoamphoacetate sodium salt"
    ]
  },
  {
    "name": "Sodium Cocoyl Glutamate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Cocoyl Glutamate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "cocoyl glutamate sodium salt"
    ]
  },
  {
    "name": "Sodium Cocoyl Hydrolyzed Amaranth Protein",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Cocoyl Hydrolyzed Amaranth Protein is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "cocoyl hydrolyzed amaranth protein sodium salt"
    ]
  },
  {
    "name": "Sodium Gluconate",
    "category": "Chelating agent",
    "description": "<p>Sodium Gluconate is a chelating agent used to bind metal ions that can affect formula stability, color, scent, or preservation.</p><p>In an ingredient checker, it is usually grouped as a formula-stability support ingredient.</p>",
    "aliases": [
      "gluconate sodium salt"
    ]
  },
  {
    "name": "Sodium Hyaluronate",
    "category": "Humectant",
    "description": "<p>Sodium Hyaluronate is a hyaluronic-acid-related humectant used to bind water and support a plumper, more hydrated skin feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient.</p>",
    "aliases": [
      "ha sodium salt",
      "sodium salt of hyaluronic acid",
      "hyaluronate sodium salt",
      "hyaluronic acid",
      "ha"
    ]
  },
  {
    "name": "Sodium Hyaluronate Crosspolymer",
    "category": "Humectant",
    "description": "<p>Sodium Hyaluronate Crosspolymer is a hyaluronic-acid-related humectant used to bind water and support a plumper, more hydrated skin feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient.</p>",
    "aliases": [
      "hyaluronate crosspolymer sodium salt"
    ]
  },
  {
    "name": "Sodium Hydroxypropylsulfonate Decylglucoside Crosspolymer",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Hydroxypropylsulfonate Decylglucoside Crosspolymer is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "hydroxypropylsulfonate decylglucoside crosspolymer sodium salt"
    ]
  },
  {
    "name": "Sodium Hydroxypropylsulfonate Laurylglucoside Crosspolymer",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Hydroxypropylsulfonate Laurylglucoside Crosspolymer is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "hydroxypropylsulfonate laurylglucoside crosspolymer sodium salt"
    ]
  },
  {
    "name": "Sodium Lauroyl Methyl Isethionate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Lauroyl Methyl Isethionate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "lauroyl methyl isethionate sodium salt"
    ]
  },
  {
    "name": "Sodium Lauryl Glucose Carboxylate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Lauryl Glucose Carboxylate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "lauryl glucose carboxylate sodium salt"
    ]
  },
  {
    "name": "Sodium Levulinate",
    "category": "Preservative booster",
    "description": "<p>Sodium Levulinate is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": [
      "levulinate sodium salt"
    ]
  },
  {
    "name": "Sodium Methyl Cocoyl Taurate",
    "category": "Surfactant/cleanser",
    "description": "<p>Sodium Methyl Cocoyl Taurate is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": [
      "methyl cocoyl taurate sodium salt"
    ]
  },
  {
    "name": "Sodium PCA",
    "category": "Humectant",
    "description": "<p>Sodium PCA is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": [
      "sodium pyrrolidone carboxylic acid",
      "pca sodium salt"
    ]
  },
  {
    "name": "Sodium Stearoyl Glutamate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Sodium Stearoyl Glutamate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": [
      "stearoyl glutamate sodium salt"
    ]
  },
  {
    "name": "Solanum Melongena (Eggplant) Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Solanum Melongena (Eggplant) Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "eggplant fruit extract",
      "eggplant extract",
      "eggplant"
    ]
  },
  {
    "name": "Sorbitan Oleate Decylglucoside Crosspolymer",
    "category": "Surfactant/cleanser",
    "description": "<p>Sorbitan Oleate Decylglucoside Crosspolymer is a surfactant or cleansing agent used to help remove oil, sunscreen, makeup, or debris and enhance how a product spreads or rinses.</p><p>In an ingredient checker, it is useful to group this under cleansing or emulsifying ingredients and review based on product type and skin sensitivity.</p>",
    "aliases": []
  },
  {
    "name": "Sorbitan Olivate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Sorbitan Olivate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Sorbitan Palmitate",
    "category": "Emulsifier/solubilizer",
    "description": "<p>Sorbitan Palmitate helps oil and water mix, enhances ingredient dispersion, and supports the texture and stability of emulsions.</p><p>In an ingredient checker, it is typically grouped as a formulation-support ingredient rather than a standalone active.</p>",
    "aliases": []
  },
  {
    "name": "Spilanthes Acmella Flower Extract",
    "category": "Botanical extract",
    "description": "<p>Spilanthes Acmella Flower Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "spilanthes acmella flower"
    ]
  },
  {
    "name": "Spilanthes Acmella Flower/Leaf/Stem Extract",
    "category": "Botanical extract",
    "description": "<p>Spilanthes Acmella Flower/Leaf/Stem Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "spilanthes acmella flower leaf stem extract",
      "spilanthes acmella flower leaf stem"
    ]
  },
  {
    "name": "Squalane",
    "category": "Emollient",
    "description": "<p>Squalane is a lightweight emollient used to soften skin and support a smooth, comfortable barrier feel.</p><p>In an ingredient checker, it is usually grouped as a non-greasy lipid emollient suitable for many skin types.</p>",
    "aliases": [
      "sugarcane squalane",
      "olive squalane"
    ]
  },
  {
    "name": "Sunflower Seed Oil Hydrogenated Sunflower Seed Oil Esters",
    "category": "Plant oil/butter/wax",
    "description": "<p>Sunflower Seed Oil Hydrogenated Sunflower Seed Oil Esters is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": []
  },
  {
    "name": "Swertia Chirata Leaf Extract",
    "category": "Botanical extract",
    "description": "<p>Swertia Chirata Leaf Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "swertia chirata leaf"
    ]
  },
  {
    "name": "Synthetic Fluorphlogopite",
    "category": "Colorant/pigment",
    "description": "<p>Synthetic Fluorphlogopite is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": []
  },
  {
    "name": "Synthetic PBT",
    "category": "Texture enhancer/polymer",
    "description": "<p>Synthetic PBT is a texture-enhancing polymer used to enhance slip, blur, smoothness, or the finished feel of a formula.</p><p>In an ingredient checker, it is typically tagged as a cosmetic feel and performance ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Tagetes Minuta Flower Oil",
    "category": "Essential oil/fragrance",
    "description": "<p>Tagetes Minuta Flower Oil is an essential oil from tagetes, also known as marigold, used for aromatic character.</p><p>It is not the same as calendula (Calendula officinalis), and essential oils can be fragrance-sensitization concerns for reactive users.</p><p>In an ingredient checker, it should be tagged as fragrance-related so sensitive-skin users can review it carefully in context.</p>",
    "aliases": [
      "tagetes flower oil",
      "tagetes oil",
      "marigold oil"
    ]
  },
  {
    "name": "Terminalia Ferdinandiana Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Terminalia Ferdinandiana Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "terminalia ferdinandiana fruit"
    ]
  },
  {
    "name": "Tetrasodium Glutamate Diacetate",
    "category": "Chelating agent",
    "description": "<p>Tetrasodium Glutamate Diacetate is a chelating agent used to bind metal ions that can affect formula stability, color, scent, or preservation.</p><p>In an ingredient checker, it is usually grouped as a formula-stability support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Thioctic Acid",
    "category": "Antioxidant",
    "description": "<p>Thioctic Acid is an antioxidant used to help protect the formula or skin from oxidation and support product freshness.</p><p>In an ingredient checker, it is usually grouped as a supportive active or formula-protection ingredient.</p>",
    "aliases": [
      "alpha lipoic acid",
      "ala"
    ]
  },
  {
    "name": "Threonine",
    "category": "Protein/amino acid",
    "description": "<p>Threonine is an amino acid or protein-related ingredient used to support hydration, conditioning, and skin-feel benefits.</p><p>In an ingredient checker, it can be grouped as a supportive skin-conditioning ingredient, especially for hydration and barrier-focused products.</p>",
    "aliases": []
  },
  {
    "name": "Titanium Dioxide (CI 77891)",
    "category": "Colorant/pigment",
    "description": "<p>Titanium Dioxide (CI 77891) is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "ci 77891",
      "titanium dioxide"
    ]
  },
  {
    "name": "Tremella Fuciformis (Mushroom) Extract",
    "category": "Botanical extract",
    "description": "<p>Tremella Fuciformis (Mushroom) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "tremella mushroom extract",
      "snow mushroom extract",
      "mushroom",
      "mushroom extract"
    ]
  },
  {
    "name": "Tribehenin",
    "category": "Emollient",
    "description": "<p>Tribehenin is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Trihydroxystearin",
    "category": "Emollient",
    "description": "<p>Trihydroxystearin is an emollient used to soften the skin, enhance slip, and make a formula feel smoother or more cushiony.</p><p>In an ingredient checker, it is typically grouped as a skin-feel and barrier-support ingredient, with relevance depending on skin type and formula concentration.</p>",
    "aliases": []
  },
  {
    "name": "Trisodium Ethylenediamine Disuccinate",
    "category": "Chelating agent",
    "description": "<p>Trisodium Ethylenediamine Disuccinate is a chelating agent used to bind metal ions that can affect formula stability, color, scent, or preservation.</p><p>In an ingredient checker, it is usually grouped as a formula-stability support ingredient.</p>",
    "aliases": []
  },
  {
    "name": "Tromethamine",
    "category": "pH adjuster/buffer",
    "description": "<p>Tromethamine is used to adjust or buffer the pH of a cosmetic formula so it remains stable and performs as intended.</p><p>In an ingredient checker, it is typically grouped as a functional formulation ingredient rather than a direct skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Tropolone",
    "category": "Preservative booster",
    "description": "<p>Tropolone is commonly used to support preservation, enhance formula stability, or promote the effectiveness of preservative systems.</p><p>In an ingredient checker, it is best grouped as a formula-protection ingredient rather than a primary skincare active.</p>",
    "aliases": []
  },
  {
    "name": "Ubiquinone",
    "category": "Antioxidant",
    "description": "<p>Ubiquinone is an antioxidant used to help protect the formula or skin from oxidation and support product freshness.</p><p>In an ingredient checker, it is usually grouped as a supportive active or formula-protection ingredient.</p>",
    "aliases": [
      "coenzyme q10",
      "coq10"
    ]
  },
  {
    "name": "Ultramarines (CI 77007)",
    "category": "Colorant/pigment",
    "description": "<p>Ultramarines (CI 77007) is a cosmetic colorant or pigment used to add tint, opacity, shimmer, or visual tone to a formula.</p><p>In an ingredient checker, it should be tagged as a color ingredient and reviewed mainly for pigment sensitivity, makeup use, or regulatory labeling context.</p>",
    "aliases": [
      "ci 77007",
      "ultramarines"
    ]
  },
  {
    "name": "Uncaria Tomentosa (Cat's Claw) Extract",
    "category": "Botanical extract",
    "description": "<p>Uncaria Tomentosa (Cat's Claw) Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "cat's claw extract",
      "cat's claw"
    ]
  },
  {
    "name": "Undecylenoyl Phenylalanine",
    "category": "Brightening active",
    "description": "<p>Undecylenoyl Phenylalanine is a brightening-focused active used to support the appearance of more even-looking skin tone.</p><p>In an ingredient checker, it should be grouped as a tone-support active and reviewed with uneven-tone goals and sensitivity profile.</p>",
    "aliases": []
  },
  {
    "name": "Vaccinium Angustifolium Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Vaccinium Angustifolium Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "vaccinium angustifolium fruit"
    ]
  },
  {
    "name": "Vaccinium Macrocarpon (Cranberry) Fruit",
    "category": "Botanical extract",
    "description": "<p>Vaccinium Macrocarpon (Cranberry) Fruit is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "cranberry fruit",
      "cranberry"
    ]
  },
  {
    "name": "Vaccinium Vitis-Idaea Fruit Extract",
    "category": "Botanical extract",
    "description": "<p>Vaccinium Vitis-Idaea Fruit Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "vaccinium vitis idaea fruit extract",
      "vaccinium vitis idaea fruit"
    ]
  },
  {
    "name": "Vitis Vinifera (Grape) Seed Extract",
    "category": "Botanical extract",
    "description": "<p>Vitis Vinifera (Grape) Seed Extract is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "grape seed extract",
      "grape extract",
      "grape"
    ]
  },
  {
    "name": "Vitis Vinifera (Grape) Seed Oil",
    "category": "Plant oil/butter/wax",
    "description": "<p>Vitis Vinifera (Grape) Seed Oil is a plant-derived oil, butter, or wax used to soften the skin, diminish moisture loss, and enhance the feel of a formula.</p><p>In an ingredient checker, it is useful to flag as an emollient lipid and review based on skin type, texture preference, and blemish-prone or very oily skin concerns.</p>",
    "aliases": [
      "grape seed oil",
      "grape oil",
      "grape"
    ]
  },
  {
    "name": "Water (Aqua)",
    "category": "Solvent/base",
    "description": "<p>Water (Aqua) is the main solvent and base used in many skincare formulas, helping dissolve and carry other ingredients.</p><p>In an ingredient checker, it is typically treated as a neutral base ingredient.</p>",
    "aliases": [
      "aqua",
      "water"
    ]
  },
  {
    "name": "Xylitylglucoside",
    "category": "Humectant",
    "description": "<p>Xylitylglucoside is a humectant used to attract and hold water in the skin or formula, helping support hydration and a smoother feel.</p><p>In an ingredient checker, it is generally grouped as a hydration-support ingredient and is especially relevant for dry, dehydrated, or barrier-focused routines.</p>",
    "aliases": [
      "xylityl glucoside"
    ]
  },
  {
    "name": "Zinc Gluconate",
    "category": "Mineral/trace element",
    "description": "<p>Zinc Gluconate is a trace mineral ingredient used for skin-conditioning or formula-support benefits.</p><p>In an ingredient checker, it can be grouped as a mineral support ingredient and reviewed in context with the overall formula.</p>",
    "aliases": []
  },
  {
    "name": "Zingiber Officinale (Ginger) Root Oil",
    "category": "Botanical extract",
    "description": "<p>Zingiber Officinale (Ginger) Root Oil is a plant-derived extract used in skincare for skin-conditioning, antioxidant, soothing, or botanical support depending on the source plant and formula.</p><p>In an ingredient checker, it is best treated as a botanical ingredient and reviewed in context with the user’s sensitivity profile and the rest of the formula.</p>",
    "aliases": [
      "ginger root oil",
      "ginger oil",
      "ginger"
    ]
  }
];
